var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// node_modules/tsup/assets/esm_shims.js
var init_esm_shims = __esm({
  "node_modules/tsup/assets/esm_shims.js"() {
  }
});

// src/index.tsx
init_esm_shims();

// src/theme.ts
init_esm_shims();

// src/themeColors.ts
init_esm_shims();

// src/colorPrimatives.ts
init_esm_shims();
var colorPrimatives = {
  light: {
    white: "#ffffff",
    gray: {
      50: "#f5f5f5",
      100: "#efefef",
      150: "#e7e7e7",
      200: "#dcdcdc",
      300: "#bdbdbd",
      400: "#989898",
      500: "#7c7c7c",
      600: "#656565",
      700: "#525252",
      800: "#464646",
      900: "#3d3d3d",
      950: "#292929"
    },
    blue: {
      50: "#f1f9fe",
      100: "#e2f3fc",
      200: "#bfe5f8",
      300: "#86d3f3",
      400: "#46bbea",
      500: "#1ea3d9",
      600: "#107eb1",
      700: "#0f6995",
      800: "#10597c",
      900: "#134a67",
      950: "#0d2f44"
    },
    green: {
      50: "#effaf3",
      100: "#d7f4e0",
      200: "#b3e7c5",
      300: "#81d4a3",
      400: "#4dba7d",
      500: "#2a9f62",
      600: "#1e8c55",
      700: "#166640",
      800: "#145134",
      900: "#11432d",
      950: "#082619"
    },
    red: {
      50: "#fef2f2",
      100: "#ffe1e1",
      200: "#ffc9c9",
      300: "#fea3a3",
      400: "#fb6e6e",
      500: "#f34040",
      600: "#e22c2c",
      700: "#bd1818",
      800: "#9c1818",
      900: "#811b1b",
      950: "#460909"
    },
    yellow: {
      50: "#fefbec",
      100: "#fcf3c9",
      200: "#f9e78e",
      300: "#f6d453",
      400: "#f5c63d",
      500: "#eda113",
      600: "#d27c0d",
      700: "#ae580f",
      800: "#8e4412",
      900: "#753812",
      950: "#431c05"
    },
    purple: {
      50: "#f6f5fd",
      100: "#efecfb",
      200: "#e0dcf8",
      300: "#c9c0f2",
      400: "#ae9ce9",
      500: "#9174de",
      600: "#7f56d1",
      700: "#754bc0",
      800: "#5d389f",
      900: "#4d3082",
      950: "#301d58"
    },
    brand: {
      50: "#effaff",
      100: "#def3ff",
      200: "#b6eaff",
      300: "#75dbff",
      400: "#2ccaff",
      500: "#00adee",
      600: "#0090d4",
      700: "#0072ab",
      800: "#00608d",
      900: "#065074",
      950: "#04334d"
    },
    charcoal: {
      50: "#f6f6f6",
      100: "#e7e7e7",
      200: "#d1d1d1",
      300: "#b0b0b0",
      400: "#888888",
      500: "#6d6d6d",
      600: "#5d5d5d",
      700: "#4f4f4f",
      800: "#454545",
      900: "#3d3d3d",
      950: "#1c1c1c"
    },
    fog: {
      50: "#f4f7fa",
      100: "#e2e8f0",
      200: "#d4dde9",
      300: "#b6c7da",
      400: "#93aac7",
      500: "#7991b8",
      600: "#677ca9",
      700: "#5b6c9a",
      800: "#4e5a7f",
      900: "#424b66",
      950: "#2b3040"
    },
    foam: {
      50: "#f9f6f3",
      100: "#f5f0ea",
      200: "#e3d4c5",
      300: "#d1b8a0",
      400: "#bd967a",
      500: "#b07e5f",
      600: "#a26d54",
      700: "#875847",
      800: "#6e493e",
      900: "#5a3d34",
      950: "#301e1a"
    },
    rpa: {
      50: "#ededfd",
      100: "#e0e0fa",
      200: "#cbcaf6",
      300: "#b1adf0",
      400: "#978ce8",
      500: "#8873de",
      600: "#7a59cf",
      700: "#6a49b6",
      800: "#563d8f",
      900: "#4c3a7e"
    },
    calm: {
      50: "#eef2f7",
      100: "#e0e9f0",
      200: "#cdd8e5",
      300: "#bfcfdf",
      400: "#92adc8",
      500: "#7895ba",
      600: "#647daa",
      700: "#596d9b",
      800: "#4d5a80",
      900: "#414d68"
    },
    neutral: {
      10: "#ffffff",
      100: "#ffffff",
      200: "#ffffff",
      300: "#ffffff"
    }
  },
  dark: {
    gray: {
      50: "#1d1d1d",
      100: "#262626",
      200: "#323232",
      300: "#3f3f3f",
      400: "#545454",
      500: "#707070",
      600: "#909090",
      700: "#b2b2b2",
      800: "#d1d1d1",
      900: "#ebebeb",
      950: "#ffffff"
    },
    blue: {
      50: "#003877",
      100: "#00418a",
      200: "#004da3",
      300: "#0059c2",
      400: "#0367e0",
      500: "#1379f3",
      600: "#348ff4",
      700: "#54a3f6",
      800: "#72b7f9",
      900: "#8fcafc",
      950: "#8fcafc"
    },
    green: {
      50: "#044329",
      100: "#004e2f",
      200: "#005c38",
      300: "#006c43",
      400: "#007d4e",
      500: "#008f5d",
      600: "#12a26c",
      700: "#2bb47d",
      800: "#43c78f",
      900: "#5ed9a2",
      950: "#81e9b8"
    },
    red: {
      50: "#7b0000",
      100: "#8d0000",
      200: "#a50000",
      300: "#be0403",
      400: "#d71913",
      500: "#ea3829",
      600: "#f65843",
      700: "#ff755e",
      800: "#ff9581",
      900: "#ffb0a1",
      950: "#ffc9bd"
    },
    orange: {
      50: "#662500",
      100: "#752d00",
      200: "#893700",
      300: "#9e4200",
      400: "#b44e00",
      500: "#ca5d00",
      600: "#e16d00",
      700: "#f4810c",
      800: "#fe9a2e",
      900: "#ffb558",
      950: "#fdce88"
    },
    indigo: {
      50: "#282c8c",
      100: "#2f34a3",
      200: "#393fbb",
      300: "#464bd3",
      400: "#555be7",
      500: "#686df4",
      600: "#7c81fb",
      700: "#9195ff",
      800: "#a7aaff",
      900: "#bcbeff",
      950: "#d0d2ff"
    },
    neutral: {
      10: "#000000",
      100: "#000000",
      200: "#000000",
      300: "#000000"
    }
  }
};

// src/themeColors.ts
var rpaLightTheme = {
  icon: {
    success: colorPrimatives.light.green[700],
    warning: colorPrimatives.light.yellow[700],
    disabled: colorPrimatives.light.gray[500],
    bold: colorPrimatives.light.gray[900],
    inverse: colorPrimatives.light.gray[50],
    subtle: colorPrimatives.light.gray[700],
    brand: colorPrimatives.light.rpa[700],
    danger: colorPrimatives.light.red[700],
    info: colorPrimatives.light.blue[600],
    link: colorPrimatives.light.blue[600],
    linkHover: colorPrimatives.light.blue[800],
    linkActive: colorPrimatives.light.blue[950],
    subtleHover: colorPrimatives.light.gray[800],
    subtleActive: colorPrimatives.light.gray[900],
    inverseSubtle: colorPrimatives.light.gray[500],
    inverseSubtleHover: colorPrimatives.light.gray[600],
    inverseSubtleActive: colorPrimatives.light.gray[700],
    accent: {
      purple: colorPrimatives.light.purple[700],
      green: colorPrimatives.light.green[400],
      orange: colorPrimatives.light.yellow[700],
      red: colorPrimatives.light.red[700],
      blue: colorPrimatives.light.blue[400]
    }
  },
  bg: {
    danger: colorPrimatives.light.red[700],
    dangerHover: colorPrimatives.light.red[800],
    dangerActive: colorPrimatives.light.red[900],
    dangerSubtlest: colorPrimatives.light.red[100],
    brand: colorPrimatives.light.rpa[700],
    brandSubtlest: colorPrimatives.light.rpa[50],
    brandHover: colorPrimatives.light.rpa[800],
    brandActive: colorPrimatives.light.rpa[900],
    surface: colorPrimatives.light.white,
    surfaceSunken: colorPrimatives.light.gray[200],
    surfaceRaised: colorPrimatives.light.white,
    surfaceBold: colorPrimatives.light.gray[950],
    surfaceOverlay: colorPrimatives.light.white,
    surfaceBoldBrand: colorPrimatives.light.blue[950],
    neutralDisabled: colorPrimatives.light.gray[200],
    grayBold: colorPrimatives.light.gray[950],
    grayBoldHover: colorPrimatives.light.gray[800],
    grayBoldActive: colorPrimatives.light.gray[600],
    graySubtle: colorPrimatives.light.gray[300],
    graySubtleHover: colorPrimatives.light.gray[400],
    graySubtleActive: colorPrimatives.light.gray[500],
    graySubtler: colorPrimatives.light.white,
    graySubtlerHover: colorPrimatives.light.gray[50],
    graySubtlerActive: colorPrimatives.light.gray[200],
    graySubtlest: colorPrimatives.light.gray[150],
    success: colorPrimatives.light.green[700],
    successHover: colorPrimatives.light.green[800],
    successActive: colorPrimatives.light.green[900],
    successSubtlest: colorPrimatives.light.green[100],
    warning: colorPrimatives.light.yellow[700],
    warningHover: colorPrimatives.light.yellow[800],
    warningActive: colorPrimatives.light.yellow[900],
    warningSubtlest: colorPrimatives.light.yellow[100],
    info: colorPrimatives.light.blue[600],
    infoHover: colorPrimatives.light.blue[800],
    infoActive: colorPrimatives.light.blue[950],
    infoSubtlest: colorPrimatives.light.blue[100],
    input: colorPrimatives.light.white,
    inputHover: colorPrimatives.light.gray[50],
    accent: {
      purple: colorPrimatives.light.purple[400],
      purpleSubtlest: colorPrimatives.light.purple[50],
      green: colorPrimatives.light.green[400],
      greenSubtlest: colorPrimatives.light.green[50],
      orange: colorPrimatives.light.yellow[200],
      orangeSubtlest: colorPrimatives.light.yellow[100],
      red: colorPrimatives.light.red[400],
      redSubtlest: colorPrimatives.light.red[50],
      blue: colorPrimatives.light.blue[400],
      blueSubtlest: colorPrimatives.light.blue[50]
    }
  },
  text: {
    brand: colorPrimatives.light.rpa[700],
    disabled: colorPrimatives.light.gray[600],
    subtle: colorPrimatives.light.gray[800],
    bold: colorPrimatives.light.gray[950],
    inverse: colorPrimatives.light.white,
    inverseSubtle: colorPrimatives.light.gray[500],
    danger: colorPrimatives.light.red[700],
    success: colorPrimatives.light.green[700],
    warning: colorPrimatives.light.yellow[700],
    info: colorPrimatives.light.blue[700],
    link: colorPrimatives.light.rpa[700],
    linkHover: colorPrimatives.light.rpa[800],
    linkActive: colorPrimatives.light.rpa[900],
    linkInlineHover: colorPrimatives.light.gray[800],
    linkInlineActive: colorPrimatives.light.gray[600],
    accent: {
      purple: colorPrimatives.light.purple[600],
      green: colorPrimatives.light.green[400],
      orange: colorPrimatives.light.yellow[700],
      red: colorPrimatives.light.red[700]
    }
  },
  border: {
    subtle: colorPrimatives.light.gray[400],
    bold: colorPrimatives.light.gray[950],
    inverse: colorPrimatives.light.gray[50],
    brand: colorPrimatives.light.rpa[700],
    danger: colorPrimatives.light.red[700],
    success: colorPrimatives.light.green[700],
    warning: colorPrimatives.light.yellow[700],
    info: colorPrimatives.light.blue[600],
    focus: colorPrimatives.light.blue[400],
    link: colorPrimatives.light.blue[600],
    linkHover: colorPrimatives.light.blue[800],
    linkActive: colorPrimatives.light.blue[950],
    accent: {
      blue: colorPrimatives.light.blue[600],
      purple: colorPrimatives.light.purple[600],
      green: colorPrimatives.light.green[400],
      orange: colorPrimatives.light.yellow[700],
      red: colorPrimatives.light.red[700]
    }
  }
};

// src/theme.ts
var semanticColors = {
  textInverse: "#ffffff",
  textIconInverse: "#F5F5F5",
  primaryButton: "#6A49B6",
  primaryButtonHover: "#b1aec4",
  primaryButtonActive: "#504a73",
  borderFocus: "#46bbea",
  borderSubtle: "#989898",
  inputBackground: "#ffffff",
  textIconBold: "#3D3D3D",
  textBold: "#292929",
  textSubtle: "#464646",
  darkContentPaneBackground: "#320161",
  alertDangerBorder: "#BD1818",
  alertDangerBackground: "#FEF2F2",
  divider: "#888888",
  headerDivider: "#CBCBCB",
  successBackground: "#166640",
  link: "#6A49B6",
  ...rpaLightTheme
};
var sizes = {
  "body-text-lineheight": "140%",
  "alert-content-lineheight": "140%",
  "icon-xs": 16,
  "icon-md": 24,
  md: 40
};
var fontWeights = {
  light: 300,
  regular: 400,
  normal: 400,
  roman: 450,
  medium: 500,
  semibold: 600,
  bold: 700
};
var fontTypes = {
  d1: {
    fontFamily: "neue-haas-grotesk-display",
    fontSize: 64,
    lineHeight: "64px"
  },
  d2: {
    fontFamily: "neue-haas-grotesk-display",
    fontSize: 40,
    lineHeight: "48px"
  },
  h1: {
    fontFamily: "neue-haas-grotesk-display",
    fontSize: 34,
    lineHeight: "36px"
  },
  h2: {
    fontFamily: "neue-haas-grotesk-display",
    fontSize: 24
  },
  h3: {
    fontFamily: "neue-haas-grotesk-display",
    fontSize: 20,
    lineHeight: "24px"
  },
  h4: {
    fontFamily: "neue-haas-grotesk-display",
    fontSize: 16,
    letterSpacing: "1px"
  },
  p1: {
    fontFamily: "sofia-pro",
    fontSize: 20,
    lineHeight: "24px"
  },
  p2: {
    fontFamily: "sofia-pro",
    fontSize: 16
  },
  p3: {
    fontFamily: "sofia-pro",
    fontSize: 14,
    lineHeight: "19.6px"
  },
  button: {
    fontFamily: "sofia-pro",
    fontSize: 16
  },
  link: {
    fontFamily: "sofia-pro",
    fontSize: 16,
    lineHeight: "16px"
  },
  label: {
    fontFamily: "sofia-pro",
    fontSize: 14
  },
  error: {
    fontFamily: "sofia-pro",
    fontSize: 14
  }
};
var boxShadows = {
  button: "0px 4px 4px 0px #00000026",
  buttonHover: "0px 4px 4px 0px #0000000D",
  large: "0px 10px 40px 0px #0000001A",
  darkMode: "0px 16px 32px rgba(0, 0, 0, 0.37), 0px 2px 10.67px rgba(0, 0, 0, 0.37)"
};
var scrollbars = {
  light: {
    "::-webkit-scrollbar": {
      width: 8,
      height: 8
    },
    "::-webkit-scrollbar-track": {
      background: "transparent"
    },
    "::-webkit-scrollbar-thumb": {
      background: "rgba(255, 255, 255, 0.8)",
      borderRadius: 100
    }
  }
};
var themeOther = {
  fontWeights,
  fontTypes,
  boxShadows,
  scrollbars,
  sizes,
  semanticColors
};
var rpiTheme = {
  fontFamily: "'sofia-pro', sans-serif",
  headings: {
    fontWeight: 500,
    fontFamily: "'sofia-pro', sans-serif"
  },
  primaryShade: 5,
  primaryColor: "brand",
  black: "#050203",
  other: themeOther,
  colors: {
    text: [
      "#b3b3b3",
      "#b3b3b3",
      "#b3b3b3",
      "#999999",
      "#5c5c5c",
      "#050203",
      "#050203",
      "#050203",
      "#050203",
      "#050203"
    ],
    sky: ["#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#f2f2f2", "#e6e6e6", "#d9d9d9", "#d9d9d9"],
    brand: [
      "#b1aec4",
      "#b1aec4",
      "#b1aec4",
      "#b1aec4",
      "#827cac",
      "#655c94",
      "#5a5382",
      "#504a73",
      "#504a73",
      "#504a73"
    ],
    spark: [
      "#fadeda",
      "#fadeda",
      "#fadeda",
      "#f5beb5",
      "#f5beb5",
      "#f56b55",
      "#b93a2e",
      "#b93a2e",
      "#b93a2e",
      "#b93a2e"
    ],
    mellow: [
      "#e7d54f",
      "#e7d54f",
      "#e7d54f",
      "#e7d54f",
      "#e7d54f",
      "#e7d54f",
      "#ddd179",
      "#ddd179",
      "#ddd179",
      "#ddd179"
    ],
    calm: [
      "#f4f7fa",
      "#f4f7fa",
      "#f4f7fa",
      "#f4f7fa",
      "#f4f7fa",
      "#bcccdd",
      "#6da2ec",
      "#6da2ec",
      "#6da2ec",
      "#6da2ec"
    ],
    amethyst: [
      "#a57fa0",
      "#a57fa0",
      "#a57fa0",
      "#a57fa0",
      "#a57fa0",
      "#a57fa0",
      "#a57fa0",
      "#a57fa0",
      "#a57fa0",
      "#a57fa0"
    ],
    green: [
      "#9cf0d3",
      "#9cf0d3",
      "#9cf0d3",
      "#9cf0d3",
      "#9cf0d3",
      "#52c8b1",
      "#52c8b1",
      "#52c8b1",
      "#52c8b1",
      "#52c8b1"
    ],
    darkMode: [
      "#2f2e2e",
      "#2f2e2e",
      "#2f2e2e",
      "#2f2e2e",
      "#272626",
      "#242323",
      "#242323",
      "#242323",
      "#242323",
      "#242323"
    ]
  }
};

// src/icons/createIcon.tsx
init_esm_shims();
import React from "react";
import { jsx } from "react/jsx-runtime";
var IconSvg = ({ viewBox, size, width, height, ...props }) => {
  const dimensions = React.useMemo(() => {
    if (!size) {
      if (width === void 0 && height === void 0) {
        return { width: viewBox.width, height: viewBox.height };
      }
      return { width, height };
    }
    if (typeof size === "number")
      return { width: size, height: size };
    return size;
  }, [size, width, height, viewBox]);
  const svgProps = {
    viewBox: `${viewBox.minX} ${viewBox.minY} ${viewBox.width} ${viewBox.height}`,
    width: dimensions.width,
    height: dimensions.height,
    display: "block",
    ...props
  };
  return /* @__PURE__ */ jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps
  });
};

// src/icons/Icon.tsx
var Icon_exports = {};
__export(Icon_exports, {
  Amazon: () => AmazonIcon,
  ChevronPagination: () => ChevronPaginationIcon,
  CircleCheckmark: () => CircleCheckmarkIcon,
  Close: () => CloseIcon,
  Dashboard: () => DashboardIcons_exports,
  Logo: () => LogoIcon,
  LogoBlack: () => LogoBlackIcon,
  Menu: () => MenuIcons_exports
});
init_esm_shims();

// src/icons/dashboard/DashboardIcons.tsx
var DashboardIcons_exports = {};
__export(DashboardIcons_exports, {
  Calendar: () => CalendarIcon,
  Chevron: () => ChevronIcon,
  CircleError: () => CircleErrorIcon,
  ErrorDocument: () => ErrorDocumentIcon,
  Errro: () => ErrorIcon,
  QuestionMark: () => QuestionMarkIcon
});
init_esm_shims();

// src/icons/dashboard/CalendarIcon.tsx
init_esm_shims();
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var CalendarIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsxs(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 48 },
  ...props,
  children: [
    /* @__PURE__ */ jsx2("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 11V0H16V11H12Z",
      fill: color
    }),
    /* @__PURE__ */ jsx2("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M32 11V0H36V11H32Z",
      fill: color
    }),
    /* @__PURE__ */ jsx2("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M46.5 20H2V17H46.5V20Z",
      fill: color
    }),
    /* @__PURE__ */ jsx2("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M45 7H3V45H45V7ZM0 4V48H48V4H0Z",
      fill: color
    })
  ]
});

// src/icons/dashboard/ChevronIcon.tsx
init_esm_shims();
import { jsx as jsx3 } from "react/jsx-runtime";
var ChevronIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsx3(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 20, height: 35 },
  ...props,
  children: /* @__PURE__ */ jsx3("path", {
    d: "M20 4.89801L7.5 17.1429L20 29.3878L17.5 34.2858L1.49868e-06 17.1429L17.5 5.31872e-05L20 4.89801Z",
    fill: color
  })
});

// src/icons/dashboard/CircleErrorIcon.tsx
init_esm_shims();
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var CircleErrorIcon = ({
  color = "#B93A2E",
  background = "#F6CCCC",
  ...props
}) => /* @__PURE__ */ jsxs2(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 56, height: 56 },
  ...props,
  children: [
    /* @__PURE__ */ jsx4("path", {
      d: "M56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28Z",
      fill: background
    }),
    /* @__PURE__ */ jsx4("path", {
      d: "M31.8638 13.4667L29.9363 32.9008H26.5465L24.619 13.4667H31.8638ZM33.0414 12.4H23.4414L25.5801 33.9675H30.9022L33.0414 12.4ZM28.2414 37.3104C29.9065 37.3104 31.2611 38.6613 31.2611 40.3216C31.2611 41.9819 29.9065 43.3333 28.2414 43.3333C26.5758 43.3333 25.2206 41.9824 25.2206 40.3221C25.2206 38.6619 26.5758 37.3104 28.2414 37.3104ZM28.2414 36.2437C25.9838 36.2437 24.1539 38.0699 24.1539 40.3216C24.1539 42.5733 25.9838 44.4 28.2414 44.4C30.4985 44.4 32.3278 42.5739 32.3278 40.3221C32.3278 38.0704 30.4985 36.2437 28.2414 36.2437Z",
      fill: color
    }),
    /* @__PURE__ */ jsx4("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M33.4833 12L31.2647 34.3675H25.218L23 12H33.4833ZM31.8638 13.4667H24.619L26.5465 32.9008H29.9363L31.8638 13.4667ZM31.4224 13.8667H25.0609L26.909 32.5008H29.5743L31.4224 13.8667ZM23.4414 12.4L25.5801 33.9675H30.9022L33.0414 12.4H23.4414ZM30.8614 40.3216C30.8614 38.8833 29.6868 37.7104 28.2416 37.7104C26.7958 37.7104 25.6208 38.8839 25.6208 40.3221C25.6208 41.7603 26.7957 42.9333 28.2416 42.9333C29.6867 42.9333 30.8614 41.76 30.8614 40.3216ZM23.7542 40.3216C23.7542 37.8481 25.764 35.8437 28.2416 35.8437C30.7189 35.8437 32.728 37.8488 32.728 40.3221C32.728 42.7955 30.7189 44.8 28.2416 44.8C25.7639 44.8 23.7542 42.795 23.7542 40.3216ZM31.2611 40.3216C31.2611 38.6613 29.9065 37.3104 28.2414 37.3104C26.5758 37.3104 25.2206 38.6619 25.2206 40.3221C25.2206 41.9824 26.5758 43.3333 28.2414 43.3333C29.9065 43.3333 31.2611 41.9819 31.2611 40.3216ZM24.1539 40.3216C24.1539 38.0699 25.9838 36.2437 28.2414 36.2437C30.4985 36.2437 32.3278 38.0704 32.3278 40.3221C32.3278 42.5739 30.4985 44.4 28.2414 44.4C25.9838 44.4 24.1539 42.5733 24.1539 40.3216Z",
      fill: color
    })
  ]
});

// src/icons/dashboard/ErrorDocumentIcon.tsx
init_esm_shims();
import { jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var ErrorDocumentIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsxs3(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 35, height: 48 },
  ...props,
  children: [
    /* @__PURE__ */ jsx5("path", {
      d: "M34.9818 14.4557C34.9628 14.105 34.8182 13.7728 34.5744 13.5194L34.5723 13.5166L21.4482 0.426574L21.4455 0.424538C21.3237 0.306666 21.1818 0.211262 21.0266 0.142749C20.9847 0.123316 20.9411 0.112393 20.8973 0.0968581C20.77 0.051755 20.637 0.024941 20.5021 0.0172218C20.4723 0.0154473 20.4469 0 20.4167 0H1.45833C1.07156 0 0.700627 0.153246 0.427136 0.426026C0.153646 0.698807 0 1.06878 0 1.45455V21.8182C0.00825855 21.8816 0.0209875 21.9444 0.0380919 22.0061C0.0474972 22.1074 0.0677273 22.2073 0.0984377 22.3043C0.173841 22.4721 0.268308 22.6307 0.379983 22.777C0.44963 22.8491 0.52669 22.9137 0.60989 22.9697C0.65678 23.0151 0.706876 23.0571 0.759792 23.0953L6.10393 26.0044C6.31815 26.1211 6.55835 26.1823 6.80247 26.1823C7.04658 26.1823 7.28679 26.1211 7.50101 26.0044L12.1459 23.4753L16.7908 26.0044C17.0051 26.1209 17.2452 26.1819 17.4893 26.1819C17.7334 26.1819 17.9736 26.1209 18.1879 26.0044L22.8349 23.4753L27.4904 26.0044C27.7044 26.1211 27.9444 26.1823 28.1882 26.1823C28.4321 26.1823 28.6721 26.1211 28.8861 26.0044L34.2394 23.0953C34.2917 23.0575 34.3412 23.016 34.3876 22.9713C34.4718 22.9148 34.5498 22.8496 34.6201 22.7768C34.7317 22.6304 34.8261 22.4719 34.9016 22.3042C34.932 22.2078 34.9521 22.1085 34.9615 22.0079C34.9788 21.9457 34.9917 21.8823 35 21.8182V14.5455C35 14.5136 34.984 14.487 34.9818 14.4557ZM21.875 4.96591L30.0212 13.0909H21.875V4.96591ZM28.1883 23.071L23.532 20.5412C23.3179 20.4245 23.0778 20.3633 22.8338 20.3633C22.5898 20.3633 22.3497 20.4245 22.1356 20.5412L17.4894 23.0703L12.8445 20.5412C12.6303 20.4245 12.3901 20.3633 12.1459 20.3633C11.9018 20.3633 11.6616 20.4245 11.4474 20.5412L6.80253 23.0703L2.91667 20.9548V2.90909H18.9583V14.5455C18.9583 14.9312 19.112 15.3012 19.3855 15.574C19.659 15.8468 20.0299 16 20.4167 16H32.0833V20.9545L28.1883 23.071Z",
      fill: color
    }),
    /* @__PURE__ */ jsx5("path", {
      d: "M34.9286 28.7386C34.9094 28.6436 34.8807 28.5508 34.8427 28.4617C34.8322 28.44 34.8336 28.4162 34.822 28.3949C34.784 28.3425 34.7422 28.2929 34.6972 28.2464C34.6409 28.1628 34.576 28.0855 34.5033 28.0156C34.3568 27.9043 34.198 27.8101 34.03 27.7347C33.9322 27.7037 33.8314 27.6834 33.7292 27.6741C33.6677 27.6572 33.605 27.6446 33.5417 27.6364C33.5175 27.6364 33.4975 27.6489 33.4737 27.65C33.2817 27.6787 33.0931 27.7267 32.9109 27.7932C32.8891 27.8036 32.8653 27.8022 32.8438 27.8139L28.1883 30.3438L23.532 27.8139C23.3179 27.6972 23.0778 27.636 22.8338 27.636C22.5898 27.636 22.3497 27.6972 22.1356 27.8139L17.4894 30.343L12.8445 27.8139C12.6303 27.6972 12.3901 27.636 12.1459 27.636C11.9018 27.636 11.6616 27.6972 11.4474 27.8139L6.80253 30.343L2.15688 27.8139C2.13516 27.8021 2.11086 27.8036 2.08879 27.793C1.99936 27.7552 1.90631 27.7265 1.81107 27.7074C1.71934 27.6791 1.625 27.6601 1.52946 27.6507C1.50453 27.6495 1.48352 27.6364 1.45833 27.6364C1.39179 27.6448 1.32595 27.658 1.26136 27.6761C1.1641 27.6855 1.06806 27.7048 0.97475 27.7338C0.69889 27.8237 0.461899 28.0045 0.302721 28.2465C0.257705 28.2928 0.216033 28.3421 0.178019 28.3942C0.166089 28.4159 0.167519 28.4402 0.156829 28.4623C0.0903539 28.6437 0.0424706 28.8313 0.0139126 29.0224C0.0127314 29.0464 0 29.0666 0 29.0909V46.5455C0 46.9312 0.153646 47.3012 0.427136 47.574C0.700627 47.8468 1.07156 48 1.45833 48H33.5417C33.9284 48 34.2994 47.8468 34.5729 47.574C34.8464 47.3012 35 46.9312 35 46.5455V29.0909C35 29.0665 34.9873 29.0463 34.9861 29.0222C34.9766 28.926 34.9574 28.8309 34.9286 28.7386ZM2.91667 45.0909V31.542L6.10393 33.277C6.31815 33.3937 6.55835 33.4549 6.80247 33.4549C7.04658 33.4549 7.28679 33.3937 7.50101 33.277L12.1459 30.7479L16.7908 33.277C17.0051 33.3935 17.2452 33.4545 17.4893 33.4545C17.7334 33.4545 17.9736 33.3935 18.1879 33.277L22.8349 30.7479L27.4904 33.277C27.7044 33.3937 27.9444 33.4549 28.1882 33.4549C28.4321 33.4549 28.6721 33.3937 28.8861 33.277L32.0833 31.5396V45.0909H2.91667Z",
      fill: color
    })
  ]
});

// src/icons/dashboard/ErrorIcon.tsx
init_esm_shims();
import { jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var ErrorIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsxs4(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 16, height: 49 },
  ...props,
  children: [
    /* @__PURE__ */ jsx6("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0947 33.3329L15.3414 0.599976H0L3.24585 33.3329H12.0947ZM12.3254 3.33168H3.01589L5.72046 30.6011H9.62088L12.3254 3.33168Z",
      fill: color
    }),
    /* @__PURE__ */ jsx6("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.67067 35.4932C4.04482 35.4932 1.10365 38.4265 1.10365 42.0462C1.10365 45.6659 4.04472 48.6 7.67067 48.6C11.2959 48.6 14.2361 45.6666 14.2361 42.047C14.2361 38.4275 11.296 35.4932 7.67067 35.4932ZM11.5044 42.0462C11.5044 39.9414 9.78561 38.2249 7.67067 38.2249C5.55488 38.2249 3.83535 39.9422 3.83535 42.047C3.83535 44.1516 5.55474 45.8683 7.67067 45.8683C9.78548 45.8683 11.5044 44.1512 11.5044 42.0462Z",
      fill: color
    })
  ]
});

// src/icons/dashboard/QuestionMarkIcon.tsx
init_esm_shims();
import { jsx as jsx7 } from "react/jsx-runtime";
var QuestionMarkIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsx7(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 32, height: 52 },
  ...props,
  children: /* @__PURE__ */ jsx7("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78717 10.8953L7.7176 12.5494C8.9824 9.8703 11.4717 6.98895 15.9434 6.98895C19.8104 6.98895 22.3745 8.84586 23.5025 11.408C24.5791 13.8533 24.2713 16.7953 22.7932 18.8929C21.7067 20.4461 20.2767 21.7633 18.9744 22.9629C18.8102 23.1143 18.6479 23.2637 18.4886 23.4116C17.0095 24.7843 15.7224 26.0675 14.8571 27.6295C13.8094 29.5188 13.7424 31.6385 13.7755 33.5263H18.2769C18.3052 32.4088 18.3718 31.5725 18.4928 30.8898C18.6757 29.8573 18.9773 29.2097 19.3449 28.5332C20.2328 26.9008 21.4813 25.6932 22.7148 24.5003C22.7727 24.4443 22.8305 24.3884 22.8882 24.3325C24.202 23.0602 25.6239 21.6592 27.0803 19.5111C28.2433 17.7872 28.6346 15.7207 28.508 13.6919C28.3808 11.6529 27.7351 9.76303 26.9645 8.49647C25.1363 5.51036 21.483 3 15.9176 3C9.98521 3 5.74567 6.50159 3.78717 10.8953ZM0.439331 11.2383C2.44191 5.23054 7.92759 0 15.9176 0C22.4723 0 27.1228 3.00761 29.5244 6.93232L29.5263 6.93534C30.5606 8.63456 31.3458 10.9994 31.5022 13.5051C31.6592 16.021 31.187 18.7893 29.5656 21.1913L29.5639 21.1938C27.9258 23.6101 26.3176 25.1876 24.9752 26.4876L24.9458 26.516C23.5942 27.825 22.6453 28.7439 21.9806 29.9661C21.7037 30.4757 21.554 30.8081 21.4468 31.4131C21.3265 32.0924 21.2603 33.1265 21.2603 35.0263V36.5263H10.8262L10.8072 35.0455C10.8045 34.8355 10.7973 34.5997 10.7894 34.3418C10.7289 32.3584 10.6284 29.0695 12.2329 26.1758C13.3534 24.153 14.9676 22.5865 16.4478 21.2127C16.6125 21.0598 16.7752 20.9096 16.9355 20.7615C18.2715 19.528 19.4486 18.441 20.3362 17.1715L20.3398 17.1664C21.2068 15.9373 21.4141 14.1098 20.7568 12.6168C20.1505 11.2397 18.7301 9.98895 15.9434 9.98895C12.5598 9.98895 10.7922 12.4924 9.96619 14.994L9.45696 16.5362L0 12.5563L0.439331 11.2383ZM15.9434 41.6842C13.935 41.6842 12.2855 43.3337 12.2855 45.3421C12.2855 47.3505 13.935 49 15.9434 49C17.9518 49 19.6013 47.3505 19.6013 45.3421C19.6013 43.3337 17.9518 41.6842 15.9434 41.6842ZM9.28551 45.3421C9.28551 41.6768 12.2781 38.6842 15.9434 38.6842C19.6087 38.6842 22.6013 41.6768 22.6013 45.3421C22.6013 49.0074 19.6087 52 15.9434 52C12.2781 52 9.28551 49.0074 9.28551 45.3421Z",
    fill: color
  })
});

// src/icons/menu/MenuIcons.tsx
var MenuIcons_exports = {};
__export(MenuIcons_exports, {
  Api: () => ApiIcon,
  Box: () => BoxIcon,
  Customers: () => CustomersIcon,
  Error: () => ErrorIcon2,
  ErrorFilled: () => ErrorFilledIcon,
  Home: () => HomeIcon,
  Key: () => KeyIcon,
  Lock: () => LockIcon,
  Pdf: () => PdfIcon,
  Settings: () => SettingsIcon,
  SignOut: () => SignOutIcon,
  Truck: () => TruckIcon,
  User: () => UserIcon
});
init_esm_shims();

// src/icons/menu/ApiIcon.tsx
init_esm_shims();
import { jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var ApiIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsxs5(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 22 },
  ...props,
  children: [
    /* @__PURE__ */ jsx8("path", {
      d: "M0 11.9095V14.5805L15.9318 20.6453V17.7543L3.80225 13.2293L15.9318 8.76718V5.81336L0 11.9095Z",
      fill: color
    }),
    /* @__PURE__ */ jsx8("path", {
      d: "M20.8645 21.6509L31.5485 0H28.8147L18.1307 21.6509H20.8645Z",
      fill: color
    }),
    /* @__PURE__ */ jsx8("path", {
      d: "M32.0997 8.76718L44.1977 13.2293L32.0997 17.7543V20.6767L48 14.5805V11.9095L32.0997 5.81336V8.76718Z",
      fill: color
    })
  ]
});

// src/icons/menu/BoxIcon.tsx
init_esm_shims();
import { jsx as jsx9 } from "react/jsx-runtime";
var BoxIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsx9(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 48 },
  ...props,
  children: /* @__PURE__ */ jsx9("path", {
    d: "M24.558 3.12376C24.1998 2.97953 23.8002 2.97953 23.442 3.12376L5.538 10.3193L12.75 13.2162L31.212 5.7976L24.558 3.12376ZM35.25 7.42241L16.788 14.8411L24 17.738L42.462 10.3193L35.25 7.42241ZM45 12.547L25.5 20.3847V44.2654L45 36.4278V12.55V12.547ZM22.5 44.2684V20.3817L3 12.547V36.4308L22.5 44.2684ZM22.329 0.323305C23.4017 -0.107768 24.5983 -0.107768 25.671 0.323305L47.058 8.92061C47.3361 9.03258 47.5744 9.22565 47.7423 9.47494C47.9102 9.72423 47.9999 10.0183 48 10.3193V36.4308C47.9996 37.0331 47.8197 37.6216 47.4833 38.1202C47.147 38.6188 46.6697 39.0047 46.113 39.2282L24.558 47.8918C24.1998 48.0361 23.8002 48.0361 23.442 47.8918L1.89 39.2282C1.33275 39.0052 0.854827 38.6195 0.517926 38.1208C0.181025 37.6222 0.000618988 37.0335 0 36.4308L0 10.3193C6.97198e-05 10.0183 0.0898312 9.72423 0.257721 9.47494C0.425611 9.22565 0.663938 9.03258 0.942 8.92061L22.329 0.323305Z",
    fill: color
  })
});

// src/icons/menu/CustomersIcon.tsx
init_esm_shims();
import { jsx as jsx10 } from "react/jsx-runtime";
var CustomersIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsx10(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 66, height: 50 },
  ...props,
  children: /* @__PURE__ */ jsx10("path", {
    d: "M21.0375 24.7083C24.1486 24.5995 27.092 23.2573 29.2306 20.9724C31.3691 18.6875 32.5307 15.6437 32.4637 12.5C32.5301 10.9204 32.2867 9.34321 31.7477 7.85894C31.2086 6.37468 30.3845 5.01263 29.3228 3.85107C28.261 2.68951 26.9824 1.75133 25.5606 1.09043C24.1387 0.429541 22.6016 0.0589655 21.0375 0C19.4699 0.0535985 17.9283 0.420232 16.5017 1.07874C15.0751 1.73726 13.7917 2.67461 12.7255 3.83672C11.6594 4.99884 10.8317 6.3627 10.2901 7.84961C9.74848 9.33652 9.50375 10.9171 9.57 12.5C9.51403 15.6476 10.6848 18.6913 12.83 20.975C14.9751 23.2587 17.9228 24.5995 21.0375 24.7083ZM50.6963 26.2917C53.2968 26.1939 55.7536 25.0614 57.5309 23.1413C59.3082 21.2212 60.2618 18.6691 60.1838 16.0417C60.2729 13.4071 59.3243 10.8443 57.5458 8.91515C55.7674 6.98595 53.3042 5.84773 50.6963 5.75C48.0956 5.85846 45.6429 7.00135 43.8733 8.92937C42.1037 10.8574 41.1607 13.4141 41.25 16.0417C41.1718 18.6622 42.1197 21.2082 43.8882 23.1271C45.6567 25.0461 48.103 26.1832 50.6963 26.2917ZM50.6963 10.9583C51.9331 11.0648 53.0794 11.6566 53.8891 12.607C54.6988 13.5573 55.1075 14.7904 55.0275 16.0417C55.0964 17.286 54.6826 18.5084 53.874 19.4497C53.0654 20.3909 51.9255 20.9769 50.6963 21.0833C49.4596 20.9872 48.3094 20.4056 47.4921 19.4632C46.6748 18.5209 46.2554 17.2926 46.3237 16.0417C46.2442 14.7838 46.6585 13.5448 47.4769 12.5933C48.2954 11.6418 49.452 11.0544 50.6963 10.9583ZM50.4075 31.5C47.9594 31.4918 45.5425 32.0555 43.3457 33.1469C41.1489 34.2383 39.2317 35.828 37.7437 37.7917C35.7119 35.3094 33.1586 33.3149 30.2691 31.9528C27.3795 30.5907 24.2261 29.8952 21.0375 29.9167C15.6227 29.8037 10.3812 31.8467 6.445 35.6044C2.50881 39.3621 0.193821 44.5328 0 50H5.15625C5.31734 45.903 7.07898 42.0374 10.0555 39.2494C13.032 36.4615 16.9809 34.9785 21.0375 35.125C25.0901 34.9786 29.0345 36.463 32.0045 39.252C34.9744 42.041 36.7271 45.9067 36.8775 50H42.0337C42.0461 47.5889 41.5979 45.198 40.7137 42.9583C41.5502 41.0753 42.9135 39.4803 44.6358 38.3699C46.3582 37.2594 48.3644 36.6819 50.4075 36.7083C53.0637 36.6067 55.6518 37.5704 57.607 39.3893C59.5623 41.2081 60.7258 43.7344 60.8438 46.4167V50H66V46.4167C65.8813 42.3532 64.1742 38.5026 61.2521 35.7072C58.33 32.9118 54.4309 31.3991 50.4075 31.5Z",
    fill: color
  })
});

// src/icons/menu/ErrorFilledIcon.tsx
init_esm_shims();
import { jsx as jsx11 } from "react/jsx-runtime";
var ErrorFilledIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsx11(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 15, height: 47 },
  ...props,
  children: /* @__PURE__ */ jsx11("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3825 0.473397L11.3388 31.9723H3.04298L0 0.473397H14.3825ZM1.03467 40.33C1.03467 36.858 3.79202 34.0445 7.19125 34.0445C10.59 34.0445 13.3464 36.859 13.3464 40.3308C13.3464 43.8027 10.5899 46.6163 7.19125 46.6163C3.79193 46.6163 1.03467 43.802 1.03467 40.33Z",
    fill: color
  })
});

// src/icons/menu/ErrorIcon.tsx
init_esm_shims();
import { jsx as jsx12, jsxs as jsxs6 } from "react/jsx-runtime";
var ErrorIcon2 = ({ color = "black", ...props }) => /* @__PURE__ */ jsxs6(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 16, height: 49 },
  ...props,
  children: [
    /* @__PURE__ */ jsx12("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0947 33.3329L15.3414 0.599976H0L3.24585 33.3329H12.0947ZM12.3254 3.33168H3.01589L5.72046 30.6011H9.62088L12.3254 3.33168Z",
      fill: color
    }),
    /* @__PURE__ */ jsx12("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.67067 35.4932C4.04482 35.4932 1.10365 38.4265 1.10365 42.0462C1.10365 45.6659 4.04472 48.6 7.67067 48.6C11.2959 48.6 14.2361 45.6666 14.2361 42.047C14.2361 38.4275 11.296 35.4932 7.67067 35.4932ZM11.5044 42.0462C11.5044 39.9414 9.78561 38.2249 7.67067 38.2249C5.55488 38.2249 3.83535 39.9422 3.83535 42.047C3.83535 44.1516 5.55474 45.8683 7.67067 45.8683C9.78548 45.8683 11.5044 44.1512 11.5044 42.0462Z",
      fill: color
    })
  ]
});

// src/icons/menu/HomeIcon.tsx
init_esm_shims();
import { jsx as jsx13 } from "react/jsx-runtime";
var HomeIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsx13(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 48 },
  ...props,
  children: /* @__PURE__ */ jsx13("path", {
    d: "M24 0L22.7422 1.29796L0 25.8591L2.51739 28.5778L4.75662 26.1538V48H20.5012V29.1068H27.4988V48H43.2434V26.1538L45.4844 28.5759L48 25.8591L25.2578 1.29796L24 0ZM24 5.37322L39.7446 22.3771V44.2214H30.9976V25.3282H17.0024V44.2214H8.25541V22.3752L24 5.37322Z",
    fill: color
  })
});

// src/icons/menu/KeyIcon.tsx
init_esm_shims();
import { jsx as jsx14 } from "react/jsx-runtime";
var KeyIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsx14(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 25 },
  ...props,
  children: /* @__PURE__ */ jsx14("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9455 13.3671C22.0716 18.8767 17.2998 23.0886 11.5443 23.0886C5.16856 23.0886 0 17.92 0 11.5443C0 5.16856 5.16856 0 11.5443 0C17.2998 0 22.0716 4.21187 22.9455 9.72152H48V13.3671H43.1392V24.9114H39.4937V13.3671H35.2405V20.0506H31.5949V13.3671H22.9455ZM19.443 11.5443C19.443 15.9067 15.9067 19.443 11.5443 19.443C7.18195 19.443 3.64557 15.9067 3.64557 11.5443C3.64557 7.18195 7.18195 3.64557 11.5443 3.64557C15.9067 3.64557 19.443 7.18195 19.443 11.5443Z",
    fill: color
  })
});

// src/icons/menu/LockIcon.tsx
init_esm_shims();
import { jsx as jsx15, jsxs as jsxs7 } from "react/jsx-runtime";
var LockIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsxs7(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 40, height: 48 },
  ...props,
  children: [
    /* @__PURE__ */ jsx15("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M36 22.8H3.6V44.4H36V22.8ZM0 19.2V48H39.6V19.2H0Z",
      fill: color
    }),
    /* @__PURE__ */ jsx15("path", {
      d: "M15.6 30H24V37.2H15.6V30Z",
      fill: color
    }),
    /* @__PURE__ */ jsx15("path", {
      d: "M35.3475 15.2738C35.3475 6.85141 28.4961 0 20.0738 0C11.6514 0 4.8 6.85141 4.8 15.2738V19.2H9.16312V15.2738C9.16312 9.25657 14.0594 4.36312 20.0738 4.36312C26.0881 4.36312 30.9844 9.25944 30.9844 15.2738V19.2H35.3475V15.2738Z",
      fill: color
    })
  ]
});

// src/icons/menu/PdfIcon.tsx
init_esm_shims();
import { jsx as jsx16 } from "react/jsx-runtime";
var PdfIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsx16(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 49, height: 35 },
  ...props,
  children: /* @__PURE__ */ jsx16("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48652 3.9996C5.42792 1.85297 9.42471 0.75 13.4559 0.75C17.257 0.75 21.0276 1.73069 24.75 3.64234C28.4724 1.73069 32.243 0.75 36.0441 0.75C40.0753 0.75 44.0721 1.85297 48.0135 3.9996C48.4675 4.24686 48.75 4.72246 48.75 5.23941V33.2206C48.75 33.7099 48.4966 34.1644 48.0803 34.4216C47.6639 34.6788 47.1441 34.7021 46.7065 34.4831C43.1159 32.6865 39.5643 31.8088 36.0441 31.8088C32.5256 31.8088 28.9756 32.6857 25.3867 34.4806L25.3817 34.4831C25.0099 34.6692 24.5788 34.6803 24.2022 34.5218C24.1722 34.5091 24.1425 34.4954 24.1133 34.4806C20.5244 32.6857 16.9744 31.8088 13.4559 31.8088C9.93573 31.8088 6.38409 32.6865 2.7935 34.4831C2.35587 34.7021 1.83605 34.6788 1.41974 34.4216C1.00342 34.1644 0.75 33.7099 0.75 33.2206V5.23941C0.75 4.72246 1.03254 4.24686 1.48652 3.9996ZM26.1618 31.0242C29.4311 29.6717 32.7288 28.9853 36.0441 28.9853C39.3595 28.9853 42.6571 29.6717 45.9265 31.0242V6.09178C42.5924 4.40001 39.3009 3.57353 36.0441 3.57353C32.7873 3.57353 29.4958 4.40001 26.1618 6.09178V31.0242ZM23.3382 6.09178V31.0242C20.0689 29.6717 16.7712 28.9853 13.4559 28.9853C10.1405 28.9853 6.84288 29.6717 3.57353 31.0242V6.09178C6.90761 4.40001 10.1991 3.57353 13.4559 3.57353C16.7127 3.57353 20.0042 4.40001 23.3382 6.09178Z",
    fill: color
  })
});

// src/icons/menu/SettingsIcon.tsx
init_esm_shims();
import { jsx as jsx17, jsxs as jsxs8 } from "react/jsx-runtime";
var SettingsIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsxs8(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 48 },
  ...props,
  children: [
    /* @__PURE__ */ jsx17("path", {
      d: "M24.15 13.5C18.3 13.5 13.65 18.15 13.65 24C13.65 29.85 18.3 34.5 24.15 34.5C30 34.5 34.65 29.85 34.65 24C34.65 18.15 30 13.5 24.15 13.5ZM24.15 31.5C19.95 31.5 16.65 28.2 16.65 24C16.65 19.8 19.95 16.5 24.15 16.5C28.35 16.5 31.65 19.8 31.65 24C31.65 28.2 28.35 31.5 24.15 31.5Z",
      fill: color
    }),
    /* @__PURE__ */ jsx17("path", {
      d: "M46.2 19.05L42 17.7L41.1 15.45L43.2 11.55C43.65 10.65 43.5 9.45 42.75 8.7L39.15 5.1C38.4 4.35 37.2 4.2 36.3 4.65L32.4 6.75L30.15 5.85L28.8 1.65C28.5 0.75 27.6 0 26.55 0H21.45C20.4 0 19.5 0.75 19.35 1.8L18 6C17.1 6.15 16.35 6.45 15.6 6.9L11.7 4.8C10.8 4.35 9.6 4.5 8.85 5.25L5.25 8.85C4.5 9.6 4.35 10.8 4.8 11.7L6.75 15.45C6.45 16.2 6.15 17.1 5.85 17.85L1.65 19.2C0.75 19.5 0 20.4 0 21.45V26.55C0 27.6 0.75 28.5 1.8 28.8L6 30.15L6.9 32.4L4.8 36.3C4.35 37.2 4.5 38.4 5.25 39.15L8.85 42.75C9.6 43.5 10.8 43.65 11.7 43.2L15.6 41.1L17.85 42L19.2 46.35C19.5 47.25 20.4 48 21.45 48H26.55C27.6 48 28.5 47.25 28.8 46.35L30.15 42L32.4 41.1L36.3 43.2C37.2 43.65 38.4 43.5 39.15 42.75L42.75 39.15C43.5 38.4 43.65 37.2 43.2 36.3L41.1 32.4L42 30.15L46.35 28.8C47.25 28.5 48 27.6 48 26.55V21.45C48 20.4 47.25 19.35 46.2 19.05ZM45 26.1L39.6 27.75L39.45 28.5L38.1 31.65L37.65 32.4L40.35 37.35L37.35 40.35L32.4 37.65L31.65 38.1C30.6 38.7 29.55 39.15 28.5 39.45L27.75 39.6L26.1 45H21.9L20.25 39.6L19.5 39.45L16.35 38.1L15.6 37.65L10.65 40.35L7.65 37.35L10.35 32.4L9.9 31.65C9.3 30.6 8.85 29.55 8.55 28.5L8.4 27.75L3 26.1V21.9L8.1 20.4L8.4 19.65C8.7 18.45 9.15 17.4 9.75 16.35L10.2 15.6L7.65 10.65L10.65 7.65L15.45 10.35L16.2 9.9C17.25 9.3 18.3 8.85 19.5 8.55L20.25 8.25L21.9 3H26.1L27.75 8.25L28.5 8.55C29.55 8.85 30.6 9.3 31.65 9.9L32.4 10.35L37.35 7.65L40.35 10.65L37.65 15.6L38.1 16.35C38.7 17.4 39.15 18.45 39.45 19.5L39.6 20.25L45 21.9V26.1Z",
      fill: color
    })
  ]
});

// src/icons/menu/SignOutIcon.tsx
init_esm_shims();
import { jsx as jsx18, jsxs as jsxs9 } from "react/jsx-runtime";
var SignOutIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsxs9(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 41, height: 50 },
  ...props,
  children: [
    /* @__PURE__ */ jsx18("path", {
      d: "M16.1106 24.1106C16.603 24.1106 16.9995 24.507 16.9995 24.9995V30.3326C16.9995 30.8251 16.603 31.2215 16.1106 31.2215C15.6182 31.2215 15.2217 30.8251 15.2217 30.3326V24.9995C15.2217 24.507 15.6182 24.1106 16.1106 24.1106ZM1.90092 1.00011C1.28491 0.992545 0.999902 1.40027 0.999902 2.04175C0.999902 14.4541 0.999902 27.0052 0.999902 39.4175C0.999877 39.7569 1.19321 40.0668 1.49815 40.2161L19.2754 48.9085C19.866 49.1973 20.5549 48.7673 20.5549 48.1099V40.1102H26.777C27.2679 40.1101 27.6658 39.7122 27.6658 39.2213V28.5549C27.6727 28.0538 27.2642 27.6461 26.7631 27.6539C26.2728 27.6628 25.8814 28.0647 25.8881 28.5549V38.3324H20.5549V24.1106H37.0857L31.4817 29.7146C30.6092 30.5524 31.9009 31.8441 32.7386 30.9715L39.8495 23.8605C40.1965 23.5134 40.1965 22.9508 39.8495 22.6037L32.7386 15.4928C32.5716 15.3201 32.3417 15.2224 32.1015 15.2219C31.3017 15.2219 30.907 16.1935 31.4817 16.7496L37.0649 22.3329H20.5549V11.1682C20.5549 10.8287 20.3616 10.5189 20.0567 10.3696L4.53106 2.77784H25.8881V14.3331C25.8711 15.5351 27.6828 15.5351 27.6658 14.3331V1.88897C27.6658 1.39809 27.2679 1.00016 26.777 1.00011H1.90092ZM2.77763 3.89934L18.7772 11.722V46.6881L2.77763 38.8637V3.89934Z",
      fill: color
    }),
    /* @__PURE__ */ jsx18("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.49815 40.2161C1.19321 40.0668 0.999877 39.7569 0.999902 39.4175V2.04175C0.999902 1.40027 1.28491 0.992545 1.90092 1.00011H26.777C27.2679 1.00016 27.6658 1.39809 27.6658 1.88897V14.3331C27.6828 15.5351 25.8711 15.5351 25.8881 14.3331V2.77784H4.53106L20.0567 10.3696C20.3616 10.5189 20.5549 10.8287 20.5549 11.1682V22.3329H37.0649L31.4817 16.7496C30.907 16.1935 31.3017 15.2219 32.1015 15.2219C32.3417 15.2224 32.5716 15.3201 32.7386 15.4928L39.8495 22.6037C40.1965 22.9508 40.1965 23.5134 39.8495 23.8605L32.7386 30.9715C31.9009 31.8441 30.6092 30.5524 31.4817 29.7146L37.0857 24.1106H20.5549V38.3324H25.8881V28.5549C25.8814 28.0647 26.2728 27.6628 26.7631 27.6539C27.2642 27.6461 27.6727 28.0538 27.6658 28.5549V39.2213C27.6658 39.7122 27.2679 40.1101 26.777 40.1102H20.5549V48.1099C20.5549 48.7673 19.866 49.1973 19.2754 48.9085L1.49815 40.2161ZM21.1549 40.7102V48.1099C21.1549 49.211 20.0011 49.9313 19.0119 49.4475L1.23459 40.7551C0.72387 40.5051 0.399861 39.986 0.399902 39.4175V2.04175C0.399902 1.64458 0.486498 1.22575 0.75506 0.897562C1.04058 0.548645 1.4541 0.395519 1.90426 0.400109H26.777C27.5992 0.400199 28.2658 1.0667 28.2658 1.88891V14.3294C28.2711 14.7916 28.0957 15.1843 27.7939 15.4555C27.5026 15.7172 27.1295 15.8346 26.777 15.8346C26.4245 15.8346 26.0513 15.7172 25.76 15.4555C25.4583 15.1843 25.2828 14.7916 25.2881 14.3294V3.37784H7.12395L20.3202 9.83063C20.8309 10.0806 21.1549 10.5996 21.1549 11.1682C21.1549 11.1682 21.1549 11.1682 21.1549 11.1682V21.7329H35.6164L31.0605 17.177C30.1024 16.2435 30.7666 14.6219 32.1015 14.6219H32.1026C32.5031 14.6227 32.8864 14.7848 33.166 15.0716L40.2738 22.1794C40.855 22.7608 40.8551 23.7033 40.2739 24.2847L33.1667 31.3919C32.8443 31.7252 32.4421 31.881 32.0355 31.8603C31.6428 31.8403 31.2945 31.6587 31.0445 31.4087C30.7945 31.1587 30.613 30.8104 30.593 30.4177C30.5722 30.0112 30.728 29.609 31.0613 29.2865L35.6372 24.7106H21.1549V37.7324H25.2881V28.5584C25.2794 27.7381 25.9352 27.0688 26.7522 27.054L26.7537 27.054C27.5915 27.0409 28.2747 27.7212 28.2658 28.5584V39.2213C28.2658 40.0436 27.5992 40.71 26.7771 40.7102H21.1549ZM16.1106 23.5106C16.9344 23.5106 17.5995 24.1757 17.5995 24.9995V30.3326C17.5995 31.1564 16.9344 31.8215 16.1106 31.8215C15.2868 31.8215 14.6217 31.1564 14.6217 30.3326V24.9995C14.6217 24.1757 15.2868 23.5106 16.1106 23.5106ZM2.77763 3.89934V38.8637L18.7772 46.6881V11.722L2.77763 3.89934ZM3.37763 4.86057V38.4892L18.1772 45.7268V12.0966L3.37763 4.86057ZM16.9995 24.9995C16.9995 24.507 16.603 24.1106 16.1106 24.1106C15.6182 24.1106 15.2217 24.507 15.2217 24.9995V30.3326C15.2217 30.8251 15.6182 31.2215 16.1106 31.2215C16.603 31.2215 16.9995 30.8251 16.9995 30.3326V24.9995Z",
      fill: color
    })
  ]
});

// src/icons/menu/TruckIcon.tsx
init_esm_shims();
import { jsx as jsx19 } from "react/jsx-runtime";
var TruckIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsx19(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 38 },
  ...props,
  children: /* @__PURE__ */ jsx19("path", {
    d: "M47.6506 18.1079L42.5306 6.16113C42.3999 5.85265 42.1814 5.58944 41.9021 5.40431C41.6229 5.21919 41.2954 5.12032 40.9604 5.12005H35.8404V1.70668C35.8404 1.25404 35.6605 0.819942 35.3405 0.499876C35.0204 0.179811 34.5863 0 34.1337 0H1.70668C1.25404 0 0.819941 0.179811 0.499876 0.499876C0.179811 0.819942 0 1.25404 0 1.70668V30.7203C0 31.1729 0.179811 31.607 0.499876 31.9271C0.819941 32.2472 1.25404 32.427 1.70668 32.427H5.35899C5.75201 33.8732 6.60999 35.1499 7.80056 36.0601C8.99114 36.9703 10.4481 37.4634 11.9468 37.4634C13.4454 37.4634 14.9024 36.9703 16.093 36.0601C17.2836 35.1499 18.1416 33.8732 18.5346 32.427H29.2526C29.6456 33.8732 30.5036 35.1499 31.6941 36.0601C32.8847 36.9703 34.3417 37.4634 35.8404 37.4634C37.339 37.4634 38.796 36.9703 39.9866 36.0601C41.1772 35.1499 42.0351 33.8732 42.4282 32.427H46.0805C46.5331 32.427 46.9672 32.2472 47.2873 31.9271C47.6073 31.607 47.7871 31.1729 47.7871 30.7203V18.7735C47.7867 18.5447 47.7403 18.3184 47.6506 18.1079ZM35.8404 8.53342H39.834L43.4863 17.0668H35.8404V8.53342ZM11.9468 34.1337C11.2717 34.1337 10.6117 33.9335 10.0504 33.5584C9.4891 33.1833 9.0516 32.6503 8.79325 32.0265C8.5349 31.4028 8.4673 30.7165 8.59901 30.0544C8.73071 29.3923 9.0558 28.7841 9.53317 28.3067C10.0105 27.8293 10.6187 27.5042 11.2809 27.3725C11.943 27.2408 12.6293 27.3084 13.253 27.5668C13.8767 27.8251 14.4098 28.2626 14.7849 28.8239C15.16 29.3853 15.3602 30.0452 15.3602 30.7203C15.3602 31.6256 15.0005 32.4938 14.3604 33.1339C13.7203 33.7741 12.8521 34.1337 11.9468 34.1337ZM29.2526 29.0136H18.5346C18.1416 27.5674 17.2836 26.2907 16.093 25.3805C14.9024 24.4703 13.4454 23.9772 11.9468 23.9772C10.4481 23.9772 8.99114 24.4703 7.80056 25.3805C6.60999 26.2907 5.75201 27.5674 5.35899 29.0136H3.41337V3.41337H32.427V24.8493C31.6498 25.3004 30.9694 25.9004 30.4246 26.615C29.8799 27.3296 29.4816 28.1447 29.2526 29.0136ZM35.8404 34.1337C35.1653 34.1337 34.5053 33.9335 33.944 33.5584C33.3827 33.1833 32.9452 32.6503 32.6868 32.0265C32.4285 31.4028 32.3609 30.7165 32.4926 30.0544C32.6243 29.3923 32.9494 28.7841 33.4267 28.3067C33.9041 27.8293 34.5123 27.5042 35.1744 27.3725C35.8366 27.2408 36.5229 27.3084 37.1466 27.5668C37.7703 27.8251 38.3034 28.2626 38.6785 28.8239C39.0535 29.3853 39.2537 30.0452 39.2537 30.7203C39.2537 31.6256 38.8941 32.4938 38.254 33.1339C37.6138 33.7741 36.7456 34.1337 35.8404 34.1337ZM44.3738 29.0136H42.4282C42.0508 27.5519 41.1995 26.2565 40.0075 25.3301C38.8155 24.4036 37.35 23.8985 35.8404 23.8936V20.4802H44.3738V29.0136Z",
    fill: color
  })
});

// src/icons/menu/UserIcon.tsx
init_esm_shims();
import { jsx as jsx20 } from "react/jsx-runtime";
var UserIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsx20(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 44, height: 48 },
  ...props,
  children: /* @__PURE__ */ jsx20("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 4.21326C18.2951 4.21326 15.2916 7.19089 15.2916 10.864C15.2916 14.5371 18.2951 17.5147 22 17.5147C25.705 17.5147 28.7085 14.5371 28.7085 10.864C28.7085 7.19089 25.705 4.21326 22 4.21326ZM11.0418 10.864C11.0418 4.86397 15.948 0 22 0C28.0521 0 32.9583 4.86397 32.9583 10.864C32.9583 16.864 28.0521 21.728 22 21.728C15.948 21.728 11.0418 16.864 11.0418 10.864ZM0 45.8934C0 33.8478 9.84987 24.0827 22 24.0827C34.1501 24.0827 44 33.8478 44 45.8934V48H39.7502V45.8934C39.7502 36.1747 31.803 28.2959 22 28.2959C12.197 28.2959 4.24983 36.1747 4.24983 45.8934V48H0V45.8934Z",
    fill: color
  })
});

// src/icons/misc/AmazonIcon.tsx
init_esm_shims();
import { jsx as jsx21 } from "react/jsx-runtime";
var AmazonIcon = ({ color = "black", ...props }) => /* @__PURE__ */ jsx21(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 40, height: 40 },
  ...props,
  children: /* @__PURE__ */ jsx21("path", {
    d: "M38.4 0H1.6C0.715 0 0 0.715 0 1.6V38.4C0 39.285 0.715 40 1.6 40H38.4C39.285 40 40 39.285 40 38.4V1.6C40 0.715 39.285 0 38.4 0ZM21.79 10.735C21.43 10.19 20.785 9.915 19.855 9.915C19.79 9.915 19.705 9.92 19.59 9.93C19.48 9.94 19.26 10.005 18.945 10.115C18.6286 10.2282 18.3279 10.3811 18.05 10.57C17.775 10.76 17.475 11.07 17.15 11.49C16.83 11.915 16.575 12.41 16.385 12.98L11.685 12.56C11.685 11.94 11.805 11.325 12.035 10.715C12.265 10.105 12.625 9.52 13.105 8.965C13.585 8.405 14.16 7.915 14.83 7.495C15.5 7.07 16.31 6.735 17.25 6.48C18.195 6.225 19.205 6.1 20.295 6.1C21.36 6.1 22.325 6.23 23.185 6.485C24.045 6.745 24.74 7.06 25.255 7.44C25.7512 7.79797 26.1882 8.23158 26.55 8.725C26.895 9.205 27.135 9.65 27.27 10.06C27.405 10.47 27.47 10.845 27.47 11.2V20.325C27.47 20.645 27.54 20.975 27.685 21.315C27.83 21.655 28 21.955 28.195 22.215C28.39 22.475 28.59 22.71 28.795 22.93C29 23.145 29.175 23.315 29.325 23.425L29.53 23.595L25.905 27.065C25.48 26.68 25.06 26.295 24.645 25.895C24.23 25.495 23.92 25.195 23.72 24.99L23.415 24.68C23.295 24.565 23.165 24.395 23.015 24.17C22.61 24.78 22.09 25.31 21.46 25.76C20.825 26.21 20.145 26.54 19.425 26.745C18.7 26.95 17.955 27.07 17.19 27.1C16.425 27.13 15.69 27.025 14.995 26.775C14.3 26.525 13.67 26.19 13.115 25.76C12.56 25.33 12.12 24.75 11.79 24.01C11.46 23.27 11.295 22.435 11.295 21.49C11.295 20.62 11.445 19.825 11.74 19.105C12.04 18.38 12.42 17.78 12.89 17.3C13.36 16.82 13.925 16.39 14.59 16.015C15.255 15.64 15.91 15.345 16.55 15.13C17.19 14.92 17.88 14.74 18.625 14.595C19.37 14.45 20.005 14.355 20.535 14.31C21.065 14.265 21.595 14.23 22.125 14.21V12.24C22.125 11.565 22.01 11.065 21.79 10.735ZM30.815 29.715C30.675 29.88 30.44 30.105 30.11 30.39C29.78 30.675 29.27 31.025 28.585 31.445C27.9 31.865 27.145 32.245 26.335 32.59C25.52 32.935 24.52 33.235 23.33 33.49C22.145 33.745 20.92 33.87 19.665 33.87C18.395 33.87 17.13 33.71 15.86 33.39C14.59 33.07 13.48 32.675 12.52 32.205C11.565 31.735 10.64 31.195 9.765 30.595C8.885 29.99 8.18 29.45 7.645 28.97C7.115 28.49 6.665 28.035 6.305 27.615C6.22 27.52 6.165 27.435 6.145 27.36C6.125 27.285 6.13 27.22 6.16 27.175C6.19 27.13 6.235 27.095 6.29 27.065C6.34973 27.0385 6.41541 27.0282 6.48038 27.0353C6.54535 27.0423 6.60731 27.0663 6.66 27.105C8.705 28.315 10.305 29.17 11.455 29.675C15.6 31.495 19.855 31.96 24.22 31.07C26.245 30.655 28.325 29.96 30.465 28.98C30.625 28.92 30.765 28.905 30.88 28.935C30.995 28.965 31.055 29.055 31.055 29.205C31.055 29.345 30.975 29.52 30.815 29.715ZM33.81 28.265C33.72 28.82 33.565 29.345 33.355 29.855C32.995 30.71 32.54 31.355 32 31.775C31.82 31.92 31.68 31.965 31.585 31.915C31.49 31.865 31.49 31.74 31.585 31.545C31.81 31.08 32.045 30.455 32.295 29.66C32.545 28.87 32.58 28.36 32.4 28.135C32.345 28.06 32.265 28.005 32.15 27.955C32.04 27.91 31.895 27.88 31.72 27.86C31.545 27.84 31.385 27.83 31.25 27.82C31.11 27.81 30.925 27.81 30.69 27.82C30.455 27.83 30.29 27.84 30.185 27.85C29.9003 27.8778 29.6152 27.9028 29.33 27.925C29.265 27.935 29.195 27.945 29.125 27.95C29.05 27.955 28.99 27.96 28.95 27.965L28.815 27.98C28.765 27.985 28.73 27.99 28.705 27.99H28.545L28.495 27.98L28.465 27.955L28.44 27.91C28.375 27.745 28.625 27.54 29.19 27.29C29.755 27.04 30.305 26.885 30.835 26.825C31.325 26.75 31.9 26.75 32.56 26.81C33.22 26.87 33.625 26.995 33.775 27.18C33.89 27.355 33.9 27.715 33.81 28.265ZM18.65 17.775C18.07 18.02 17.605 18.385 17.26 18.875C16.915 19.365 16.74 19.955 16.74 20.65C16.74 21.54 17.115 22.225 17.86 22.71C18.565 23.165 19.305 23.28 20.08 23.05C20.975 22.79 21.58 22.155 21.9 21.145C22.05 20.68 22.125 20.16 22.125 19.58V17.07C21.495 17.09 20.905 17.15 20.35 17.255C19.795 17.36 19.23 17.535 18.65 17.775Z",
    fill: color
  })
});

// src/icons/misc/ChevronPaginationIcon.tsx
init_esm_shims();
import { jsx as jsx22 } from "react/jsx-runtime";
var ChevronPaginationIcon = ({
  color = "#645C90",
  direction = "left",
  ...props
}) => /* @__PURE__ */ jsx22(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 6, height: 10 },
  ...props,
  children: direction === "left" ? /* @__PURE__ */ jsx22("path", {
    d: "M5.83399 1.42857L2.18815 5L5.83398 8.57143L5.10482 10L0.00065132 5L5.10482 -6.37458e-08L5.83399 1.42857Z",
    fill: color
  }) : /* @__PURE__ */ jsx22("path", {
    d: "M0 8.57143L3.64583 5L0 1.42857L0.729167 0L5.83333 5L0.729167 10L0 8.57143Z",
    fill: color
  })
});

// src/icons/misc/CircleCheckmarkIcon.tsx
init_esm_shims();
import { jsx as jsx23, jsxs as jsxs10 } from "react/jsx-runtime";
var CircleCheckmarkIcon = ({ color = "#52C8B1", ...props }) => /* @__PURE__ */ jsxs10(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 47, height: 46 },
  ...props,
  children: [
    /* @__PURE__ */ jsx23("path", {
      d: "M23.5 43.125C18.1625 43.125 13.0436 41.0047 9.26948 37.2305C5.49531 33.4564 3.375 28.3375 3.375 23C3.375 17.6625 5.49531 12.5436 9.26948 8.76948C13.0436 4.99531 18.1625 2.875 23.5 2.875C28.8375 2.875 33.9564 4.99531 37.7305 8.76948C41.5047 12.5436 43.625 17.6625 43.625 23C43.625 28.3375 41.5047 33.4564 37.7305 37.2305C33.9564 41.0047 28.8375 43.125 23.5 43.125ZM23.5 46C29.6 46 35.4501 43.5768 39.7635 39.2635C44.0768 34.9501 46.5 29.1 46.5 23C46.5 16.9 44.0768 11.0499 39.7635 6.73654C35.4501 2.42321 29.6 0 23.5 0C17.4 0 11.5499 2.42321 7.23654 6.73654C2.92321 11.0499 0.5 16.9 0.5 23C0.5 29.1 2.92321 34.9501 7.23654 39.2635C11.5499 43.5768 17.4 46 23.5 46Z",
      fill: color
    }),
    /* @__PURE__ */ jsx23("path", {
      d: "M32.0395 14.2888C32.019 14.3087 31.9998 14.3298 31.982 14.3521L21.9971 27.0739L15.9797 21.0537C15.571 20.6728 15.0303 20.4655 14.4717 20.4753C13.9131 20.4852 13.3801 20.7115 12.9851 21.1065C12.59 21.5016 12.3637 22.0346 12.3539 22.5932C12.344 23.1518 12.5513 23.6924 12.9322 24.1012L20.5395 31.7113C20.7444 31.9159 20.9885 32.0771 21.257 32.1853C21.5256 32.2935 21.8132 32.3465 22.1027 32.3411C22.3923 32.3358 22.6777 32.2721 22.9421 32.154C23.2065 32.036 23.4444 31.8658 23.6416 31.6538L35.1186 17.3076C35.5094 16.8974 35.7231 16.3499 35.7134 15.7834C35.7038 15.217 35.4716 14.6771 35.067 14.2805C34.6625 13.8839 34.1181 13.6624 33.5515 13.6639C32.985 13.6655 32.4418 13.89 32.0395 14.2888Z",
      fill: color
    })
  ]
});

// src/icons/misc/CloseIcon.tsx
init_esm_shims();
import { jsx as jsx24 } from "react/jsx-runtime";
var CloseIcon = ({ color = "#B3B3B3", ...props }) => /* @__PURE__ */ jsx24(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 14, height: 14 },
  ...props,
  children: /* @__PURE__ */ jsx24("path", {
    d: "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z",
    fill: color
  })
});

// src/icons/misc/LogoBlackIcon.tsx
init_esm_shims();
import { jsx as jsx25, jsxs as jsxs11 } from "react/jsx-runtime";
var LogoBlackIcon = ({ color = "#050203", ...props }) => /* @__PURE__ */ jsxs11(IconSvg, {
  fill: "none",
  viewBox: {
    minX: 0,
    minY: 0,
    width: 200,
    height: 200
  },
  ...props,
  children: [
    /* @__PURE__ */ jsx25("g", {
      "clip-path": "url(#clip0_937_3266)",
      children: /* @__PURE__ */ jsx25("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M0 0H200V200H0V0ZM80.5042 44.8955H58.5937V155.104H80.5042V44.8955ZM127.993 53.6915C121.818 47.3632 113.327 44.8955 97.2736 44.8955H83.6219L83.602 63.728H97.4262C99.5091 63.728 101.353 63.8939 102.965 64.2388C103.502 64.3516 104.013 64.4909 104.504 64.6434C105.479 64.9552 106.362 65.3532 107.144 65.8441C107.735 66.209 108.272 66.6269 108.763 67.0978C109.088 67.4096 109.393 67.7479 109.672 68.1128C110.096 68.6567 110.468 69.2537 110.799 69.9105C111.237 70.7861 111.595 71.7612 111.881 72.8491C112.305 74.4743 112.557 76.3516 112.657 78.4876C112.69 79.1973 112.703 79.9403 112.703 80.7164C112.703 93.0614 108.537 97.6916 97.4196 97.6916H83.5555L83.5357 116.677H97.2736C112.093 116.677 120.272 114.514 126.448 109.114C133.4 103.091 136.325 94.607 136.325 80.7098C136.325 67.7413 133.857 59.874 127.993 53.6982V53.6915ZM98.4743 119.708C108.551 119.655 115.615 118.58 121.121 116.1H121.128L141.42 155.104H115.177L98.4743 119.708Z",
        fill: color
      })
    }),
    /* @__PURE__ */ jsx25("defs", {
      children: /* @__PURE__ */ jsx25("clipPath", {
        id: "clip0_937_3266",
        children: /* @__PURE__ */ jsx25("rect", {
          width: "200",
          height: "200",
          fill: "white"
        })
      })
    })
  ]
});

// src/icons/misc/LogoIcon.tsx
init_esm_shims();
import { jsx as jsx26, jsxs as jsxs12 } from "react/jsx-runtime";
var LogoIcon = ({ ...props }) => /* @__PURE__ */ jsxs12(IconSvg, {
  fill: "none",
  viewBox: {
    minX: 0,
    minY: 0,
    width: 200,
    height: 200
  },
  ...props,
  children: [
    /* @__PURE__ */ jsxs12("g", {
      clipPath: "url(#a)",
      children: [
        /* @__PURE__ */ jsxs12("g", {
          filter: "url(#b)",
          children: [
            /* @__PURE__ */ jsx26("path", {
              d: "M200 0H0v200h200V0Z",
              fill: "#655C94"
            }),
            /* @__PURE__ */ jsx26("path", {
              d: "M58.594 44.895h21.91v110.209h-21.91V44.895Z",
              fill: "#E7D54F"
            }),
            /* @__PURE__ */ jsx26("path", {
              d: "M127.993 53.691c-6.175-6.328-14.666-8.796-30.72-8.796H83.623l-.02 18.833h13.824c2.083 0 3.927.166 5.539.51.537.114 1.048.253 1.539.405.975.312 1.858.71 2.64 1.201a9.663 9.663 0 0 1 1.619 1.254c.325.312.63.65.909 1.015.424.544.796 1.14 1.127 1.797.438.876.796 1.851 1.082 2.94.424 1.624.676 3.502.776 5.638.033.71.046 1.452.046 2.228 0 12.345-4.166 16.976-15.283 16.976H83.555l-.02 18.985h13.739c14.819 0 22.998-2.163 29.174-7.563 6.952-6.023 9.877-14.507 9.877-28.404 0-12.969-2.468-20.836-8.332-27.012v-.007Z",
              fill: "#BCCCDD"
            }),
            /* @__PURE__ */ jsx26("path", {
              d: "M121.121 116.1c-5.506 2.48-12.57 3.555-22.647 3.608l16.703 35.396h26.243L121.128 116.1h-.007Z",
              fill: "#fff"
            })
          ]
        }),
        /* @__PURE__ */ jsx26("path", {
          d: "M200 0H0v200h200V0Z",
          fill: "#655C91"
        }),
        /* @__PURE__ */ jsx26("path", {
          d: "M58.6 44.9h21.9v110.22H58.6V44.9Z",
          fill: "#E4D24F"
        }),
        /* @__PURE__ */ jsx26("path", {
          d: "M136.464 90.16c.2-1.42.34-2.92.42-4.48.1-1.58.14-3.22.14-4.96 0-12.96-2.46-20.84-8.34-27.02a24.5 24.5 0 0 0-5.14-4.04c-5.74-3.36-13.54-4.76-25.58-4.76h-13.66v18.84h13.8c8.34 0 12.76 2.6 14.46 9.12.56 2.18.82 4.78.82 7.86 0 7.72-1.62 12.42-5.56 14.86-2.36 1.46-5.56 2.12-9.72 2.12h-13.86v18.98h13.72c14.82 0 23-2.16 29.18-7.56 3.48-3.02 5.94-6.64 7.54-11.24.8-2.3 1.38-4.86 1.76-7.7l.02-.02Z",
          fill: "#BCCCDD"
        }),
        /* @__PURE__ */ jsx26("path", {
          d: "M121.519 116.898c-5.66 2.38-12.82 3.42-22.74 3.48l16.38 34.74h26.24l-19.88-38.22Z",
          fill: "#fff"
        })
      ]
    }),
    /* @__PURE__ */ jsxs12("defs", {
      children: [
        /* @__PURE__ */ jsx26("clipPath", {
          id: "a",
          children: /* @__PURE__ */ jsx26("path", {
            fill: "#fff",
            d: "M0 0h200v200H0z"
          })
        }),
        /* @__PURE__ */ jsxs12("filter", {
          id: "b",
          x: 0,
          y: 0,
          width: 224.32,
          height: 224.32,
          filterUnits: "userSpaceOnUse",
          colorInterpolationFilters: "sRGB",
          children: [
            /* @__PURE__ */ jsx26("feFlood", {
              floodOpacity: 0,
              result: "BackgroundImageFix"
            }),
            /* @__PURE__ */ jsx26("feColorMatrix", {
              in: "SourceAlpha",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }),
            /* @__PURE__ */ jsx26("feOffset", {
              dx: 12.16,
              dy: 12.16
            }),
            /* @__PURE__ */ jsx26("feGaussianBlur", {
              stdDeviation: 6.08
            }),
            /* @__PURE__ */ jsx26("feColorMatrix", {
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            }),
            /* @__PURE__ */ jsx26("feBlend", {
              in2: "BackgroundImageFix",
              result: "effect1_dropShadow_937_3264"
            }),
            /* @__PURE__ */ jsx26("feBlend", {
              in: "SourceGraphic",
              in2: "effect1_dropShadow_937_3264",
              result: "shape"
            })
          ]
        })
      ]
    })
  ]
});

// src/icons/IconV2.tsx
var IconV2_exports = {};
__export(IconV2_exports, {
  Arrow: () => ArrowIcon,
  ArrowDown: () => ArrowDownIcon,
  ArrowUp: () => ArrowUpIcon,
  Box: () => BoxIcon2,
  Boxes: () => BoxesIcon,
  Checkbox: () => CheckboxIcon,
  Code: () => CodeIcon,
  Communications: () => CommunicationsIcon,
  Copy: () => CopyIcon,
  CreditCard: () => CreditCardIcon,
  Dashboard: () => DashboardIcon,
  Delete: () => DeleteIcon,
  Document: () => DocumentIcon,
  Edit: () => EditIcon,
  ErrorOutline: () => ErrorOutlineIcon,
  ErrorSolid: () => ErrorSolidIcon,
  Eye: () => EyeIcon,
  EyeOff: () => EyeOffIcon,
  FileDownload: () => FileDownloadIcon,
  Filter: () => FilterIcon,
  Gear: () => GearIcon,
  HelpOutline: () => HelpOutlineIcon,
  HelpSolid: () => HelpSolidIcon,
  InfoOutline: () => InfoOutlineIcon,
  InfoSolid: () => InfoSolidIcon,
  Key: () => KeyIcon2,
  LightBulb: () => LightBulbIcon,
  LockOutline: () => LockOutlineIcon,
  LockSolid: () => LockSolidIcon,
  LogOut: () => LogOutIcon,
  Minus: () => MinusIcon,
  Moon: () => MoonIcon,
  Plus: () => PlusIcon,
  Printer: () => PrinterIcon,
  Refresh: () => RefreshIcon,
  Search: () => SearchIcon,
  Success: () => SuccessIcon,
  Sun: () => SunIcon,
  Truck: () => TruckIcon2,
  UnlockOutline: () => UnlockOutlineIcon,
  UnlockSolid: () => UnlockSolidIcon,
  Users: () => UsersIcon,
  VerticalDots: () => VerticalDotsIcon,
  Wallet: () => WalletIcon,
  X: () => XIcon
});
init_esm_shims();

// src/icons/v2/ArrowDownIcon.tsx
init_esm_shims();
import { jsx as jsx27, jsxs as jsxs13 } from "react/jsx-runtime";
var ArrowDownIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs13(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 48 },
  ...props,
  children: [
    /* @__PURE__ */ jsx27("g", {
      clipPath: "url(#clip0_1676_16542)",
      children: /* @__PURE__ */ jsx27("path", {
        d: "M6.85714 10L24 27.1429L41.1429 10L48 13.4286L24 37.4286L0 13.4286L6.85714 10Z",
        fill: color
      })
    }),
    /* @__PURE__ */ jsx27("defs", {
      children: /* @__PURE__ */ jsx27("clipPath", {
        id: "clip0_1676_16542",
        children: /* @__PURE__ */ jsx27("rect", {
          width: 48,
          height: 48,
          fill: "white"
        })
      })
    })
  ]
});

// src/icons/v2/ArrowIcon.tsx
init_esm_shims();
import { jsx as jsx28 } from "react/jsx-runtime";
var ArrowIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsx28(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 48 },
  ...props,
  children: /* @__PURE__ */ jsx28("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1384 3.05839C25.2162 1.98054 26.9638 1.98054 28.0416 3.05839L46.4416 21.4584C47.5195 22.5362 47.5195 24.2838 46.4416 25.3616L28.0416 43.7616C26.9638 44.8395 25.2162 44.8395 24.1384 43.7616C23.0605 42.6838 23.0605 40.9362 24.1384 39.8584L40.5868 23.41L24.1384 6.96161C23.0605 5.88377 23.0605 4.13623 24.1384 3.05839ZM1.25 23.41C1.25 21.8857 2.48569 20.65 4.01 20.65H28.5433C30.0676 20.65 31.3033 21.8857 31.3033 23.41C31.3033 24.9343 30.0676 26.17 28.5433 26.17H4.01C2.48569 26.17 1.25 24.9343 1.25 23.41Z",
    fill: color
  })
});

// src/icons/v2/ArrowUpIcon.tsx
init_esm_shims();
import { jsx as jsx29, jsxs as jsxs14 } from "react/jsx-runtime";
var ArrowUpIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs14(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 48 },
  ...props,
  children: [
    /* @__PURE__ */ jsx29("g", {
      clipPath: "url(#clip0_1676_16539)",
      children: /* @__PURE__ */ jsx29("path", {
        d: "M41.1429 37.4277L24 20.2849L6.85714 37.4277L-1.01157e-06 33.9992L24 9.99916L48 33.9992L41.1429 37.4277Z",
        fill: color
      })
    }),
    /* @__PURE__ */ jsx29("defs", {
      children: /* @__PURE__ */ jsx29("clipPath", {
        id: "clip0_1676_16539",
        children: /* @__PURE__ */ jsx29("rect", {
          width: 48,
          height: 48,
          fill: "white"
        })
      })
    })
  ]
});

// src/icons/v2/BoxesIcon.tsx
init_esm_shims();
import { jsx as jsx30 } from "react/jsx-runtime";
var BoxesIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsx30(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 43, height: 38 },
  ...props,
  children: /* @__PURE__ */ jsx30("path", {
    d: "m.754 21.746 3.138-6.276c.174-.305.48-.523.828-.523h5.84V8.235c0-.13.044-.262.087-.392l3.138-6.32c.175-.305.48-.523.828-.523h13.511c.35 0 .654.174.829.523l3.137 6.276c.044.13.088.261.088.392v6.712h5.84c.349 0 .654.174.828.523l3.138 6.32c.044.13.087.261.087.392v13.947a.894.894 0 0 1-.915.915H1.582a.894.894 0 0 1-.915-.915V22.138c0-.13.043-.262.087-.392Zm9.806-4.969H5.286l-2.222 4.446h7.496v-4.446Zm9.894-13.946H15.18l-2.223 4.445h7.497V2.831Zm7.104 0h-5.274v4.445h7.497l-2.223-4.445Zm2.79 6.276H12.39v12.116h17.956V9.107Zm7.103 7.67h-5.273v4.446h7.496l-2.223-4.446ZM22.284 35.17h17.957V23.053H22.284V35.17Zm-19.787 0h17.957V23.053H2.497V35.17Z",
    fill: color,
    stroke: color,
    strokeWidth: 0.75
  })
});

// src/icons/v2/BoxIcon.tsx
init_esm_shims();
import { jsx as jsx31, jsxs as jsxs15 } from "react/jsx-runtime";
var BoxIcon2 = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs15(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 49 },
  ...props,
  children: [
    /* @__PURE__ */ jsx31("path", {
      d: "M7.92871 0.515625L7.258 1.38563L0.428711 10.4928V47.6585H47.5716V10.4928L40.7402 1.38563L40.0716 0.515625H7.92871ZM10.0716 4.80134H21.8573V9.08705H6.85729L10.0716 4.80134ZM26.143 4.80134H37.9287L41.143 9.08705H26.143V4.80134ZM4.71443 13.3728H43.2859V43.3728H4.71443V13.3728ZM17.1709 17.6585C15.9901 17.7656 15.118 18.8221 15.2273 20.0028C15.3366 21.1813 16.3909 22.0535 17.5716 21.9442H30.4287C31.2002 21.9528 31.918 21.5499 32.3123 20.8813C32.5015 20.5528 32.601 20.1804 32.601 19.8013C32.601 19.4223 32.5015 19.0498 32.3123 18.7213C31.918 18.0528 31.198 17.6499 30.4287 17.6585H17.1687H17.1709Z",
      fill: color
    }),
    /* @__PURE__ */ jsx31("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.97157 4.60134H22.0573V9.28706H6.45728L9.97157 4.60134ZM25.943 4.60134H38.0287L41.543 9.28706H25.943V4.60134ZM4.51443 13.1728H43.4859V43.5728H4.51443V13.1728ZM17.1687 17.6585H17.1709H30.4287C31.198 17.6499 31.918 18.0528 32.3123 18.7213C32.5015 19.0498 32.601 19.4223 32.601 19.8013C32.601 20.1804 32.5015 20.5528 32.3123 20.8813C31.918 21.5499 31.2002 21.9528 30.4287 21.9442H17.5716C16.3909 22.0535 15.3366 21.1813 15.2273 20.0028C15.1181 18.8228 15.9891 17.7667 17.1687 17.6585ZM15.4264 19.9843C15.5255 21.0523 16.4818 21.8442 17.5531 21.745L17.5623 21.7442H30.4309C31.1306 21.752 31.7815 21.3869 32.1395 20.7806C32.3108 20.4827 32.401 20.145 32.401 19.8013C32.401 19.4577 32.3108 19.12 32.1395 18.8221C31.7816 18.2159 31.1285 17.8507 30.431 17.8585L30.4287 17.8585L17.1801 17.8585C16.115 17.96 15.3275 18.9158 15.4264 19.9843ZM7.41722 1.50667L0.628711 10.5594V47.4585H47.3716V10.5594L40.5816 1.50749L40.5802 1.50564L39.973 0.715625H8.02706L7.41722 1.50667ZM7.92871 0.515625L7.258 1.38563L0.428711 10.4928V47.6585H47.5716V10.4928L40.7402 1.38563L40.0716 0.515625H7.92871ZM10.0716 4.80134H21.8573V9.08705H6.85729L10.0716 4.80134ZM26.143 9.08705V4.80134H37.9287L41.143 9.08705H26.143ZM4.71443 13.3728V43.3728H43.2859V13.3728H4.71443Z",
      fill: "#F5F5F5"
    })
  ]
});

// src/icons/v2/CheckboxIcon.tsx
init_esm_shims();
import { jsx as jsx32 } from "react/jsx-runtime";
var CheckboxIcon = ({ color = "white", ...props }) => /* @__PURE__ */ jsx32(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 14, height: 9 },
  ...props,
  children: /* @__PURE__ */ jsx32("path", {
    d: "M2 4.25L5.84615 8L12 2",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })
});

// src/icons/v2/CodeIcon.tsx
init_esm_shims();
import { jsx as jsx33, jsxs as jsxs16 } from "react/jsx-runtime";
var CodeIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs16(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 45 },
  ...props,
  children: [
    /* @__PURE__ */ jsx33("path", {
      d: "M44.3858 1.00586H3.61417C2.15036 1.00586 0.959961 2.19779 0.959961 3.65853V40.501C0.959961 41.9618 2.15036 43.1537 3.61417 43.1537H44.3873C45.8496 43.1537 47.0415 41.9633 47.0415 40.501V3.65853C47.04 2.19779 45.8496 1.00586 44.3858 1.00586ZM3.61417 2.54186H44.3873C45.0032 2.54186 45.504 3.04259 45.504 3.65853V8.64439H2.49596V3.65853C2.49596 3.04259 2.9967 2.54186 3.61417 2.54186ZM44.3858 41.6177H3.61417C2.9967 41.6177 2.49596 41.117 2.49596 40.501V10.1804H45.504V40.501C45.504 41.117 45.0032 41.6177 44.3858 41.6177Z",
      fill: color
    }),
    /* @__PURE__ */ jsx33("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.209961 3.65853C0.209961 1.78358 1.73615 0.255859 3.61417 0.255859H44.3858C46.2639 0.255859 47.7895 1.78356 47.7915 3.65774V40.501C47.7915 42.3781 46.2632 43.9037 44.3873 43.9037H3.61417C1.73615 43.9037 0.209961 42.376 0.209961 40.501V3.65853ZM3.61417 1.75586C2.56457 1.75586 1.70996 2.61201 1.70996 3.65853V40.501C1.70996 41.5475 2.56458 42.4037 3.61417 42.4037H44.3873C45.4359 42.4037 46.2915 41.5485 46.2915 40.501V3.65932C46.2904 2.61203 45.4352 1.75586 44.3858 1.75586H3.61417ZM3.61417 3.29186C3.41024 3.29186 3.24596 3.45748 3.24596 3.65853V7.89439H44.754V3.65853C44.754 3.45681 44.589 3.29186 44.3873 3.29186H3.61417ZM1.74596 3.65853C1.74596 2.62771 2.58316 1.79186 3.61417 1.79186H44.3873C45.4174 1.79186 46.254 2.62838 46.254 3.65853V9.39439H1.74596V3.65853ZM1.74596 9.43039H46.254V40.501C46.254 41.5318 45.4168 42.3677 44.3858 42.3677H3.61417C2.58315 42.3677 1.74596 41.5318 1.74596 40.501V9.43039ZM3.24596 10.9304V40.501C3.24596 40.7021 3.41024 40.8677 3.61417 40.8677H44.3858C44.5897 40.8677 44.754 40.7021 44.754 40.501V10.9304H3.24596Z",
      fill: color
    }),
    /* @__PURE__ */ jsx33("path", {
      d: "M6.16405 7.03709C6.83337 7.03709 7.37596 6.4945 7.37596 5.82518C7.37596 5.15587 6.83337 4.61328 6.16405 4.61328C5.49474 4.61328 4.95215 5.15587 4.95215 5.82518C4.95215 6.4945 5.49474 7.03709 6.16405 7.03709Z",
      fill: color
    }),
    /* @__PURE__ */ jsx33("path", {
      d: "M10.0068 7.03709C10.6761 7.03709 11.2187 6.4945 11.2187 5.82518C11.2187 5.15587 10.6761 4.61328 10.0068 4.61328C9.33751 4.61328 8.79492 5.15587 8.79492 5.82518C8.79492 6.4945 9.33751 7.03709 10.0068 7.03709Z",
      fill: color
    }),
    /* @__PURE__ */ jsx33("path", {
      d: "M13.8516 7.03709C14.5209 7.03709 15.0635 6.4945 15.0635 5.82518C15.0635 5.15587 14.5209 4.61328 13.8516 4.61328C13.1822 4.61328 12.6396 5.15587 12.6396 5.82518C12.6396 6.4945 13.1822 7.03709 13.8516 7.03709Z",
      fill: color
    }),
    /* @__PURE__ */ jsx33("path", {
      d: "M17.7313 19.3867L9.81934 25.6029L17.7313 31.8222L18.679 30.6133L12.3061 25.6029L18.679 20.5956L17.7313 19.3867Z",
      fill: color,
      stroke: color
    }),
    /* @__PURE__ */ jsx33("path", {
      d: "M29.3203 20.5956L35.6932 25.6029L29.3203 30.6133L30.268 31.8222L38.18 25.6029L30.268 19.3867L29.3203 20.5956Z",
      fill: color,
      stroke: color
    }),
    /* @__PURE__ */ jsx33("path", {
      d: "M20.6444 35.8781L22.1348 36.25L27.355 15.328L25.8646 14.9562L20.6444 35.8781Z",
      fill: color,
      stroke: color
    })
  ]
});

// src/icons/v2/CopyIcon.tsx
init_esm_shims();
import { jsx as jsx34 } from "react/jsx-runtime";
var CopyIcon = ({ color = "#050203", ...props }) => /* @__PURE__ */ jsx34(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 16, height: 15 },
  ...props,
  children: /* @__PURE__ */ jsx34("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.844.813c-.381 0-.747.148-1.017.411a1.39 1.39 0 0 0-.42.995v1.406h1.437V2.219h7.906v7.734h-1.438v1.406h1.438c.381 0 .747-.148 1.017-.412.269-.263.42-.62.42-.994V2.22c0-.373-.151-.73-.42-.995A1.454 1.454 0 0 0 13.75.813H5.844ZM2.25 4.328c-.381 0-.747.148-1.016.412a1.39 1.39 0 0 0-.421.994v7.735c0 .373.151.73.42.994.27.264.636.412 1.017.412h7.906c.381 0 .747-.148 1.017-.412a1.39 1.39 0 0 0 .42-.994V5.734c0-.373-.15-.73-.42-.994a1.454 1.454 0 0 0-1.017-.412H2.25Zm0 1.406h7.906v7.735H2.25V5.734Z",
    fill: color
  })
});

// src/icons/v2/CreditCardIcon.tsx
init_esm_shims();
import { jsx as jsx35, jsxs as jsxs17 } from "react/jsx-runtime";
var CreditCardIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs17(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 51, height: 41 },
  ...props,
  children: [
    /* @__PURE__ */ jsx35("g", {
      clipPath: "url(#clip0_1613_12669)",
      children: /* @__PURE__ */ jsx35("path", {
        d: "M46.75 0C47.9187 0 48.9193 0.418186 49.7516 1.25456C50.5839 2.09093 51 3.09635 51 4.27083V36.7292C51 37.9036 50.5839 38.9091 49.7516 39.7454C48.9193 40.5818 47.9187 41 46.75 41H4.25C3.08125 41 2.08073 40.5818 1.24844 39.7454C0.416146 38.9091 0 37.9036 0 36.7292V4.27083C0 3.09635 0.416146 2.09093 1.24844 1.25456C2.08073 0.418186 3.08125 0 4.25 0H46.75ZM4.25 3.41667C4.01979 3.41667 3.82057 3.50119 3.65234 3.67025C3.48411 3.8393 3.4 4.0395 3.4 4.27083V10.25H47.6V4.27083C47.6 4.0395 47.5159 3.8393 47.3477 3.67025C47.1794 3.50119 46.9802 3.41667 46.75 3.41667H4.25ZM46.75 37.5833C46.9802 37.5833 47.1794 37.4988 47.3477 37.3298C47.5159 37.1607 47.6 36.9605 47.6 36.7292V20.5H3.4V36.7292C3.4 36.9605 3.48411 37.1607 3.65234 37.3298C3.82057 37.4988 4.01979 37.5833 4.25 37.5833H46.75ZM6.8 34.1667V30.75H13.6V34.1667H6.8ZM17 34.1667V30.75H27.2V34.1667H17Z",
        fill: color
      })
    }),
    /* @__PURE__ */ jsx35("defs", {
      children: /* @__PURE__ */ jsx35("clipPath", {
        id: "clip0_1613_12669",
        children: /* @__PURE__ */ jsx35("rect", {
          width: 51,
          height: 41,
          fill: "white"
        })
      })
    })
  ]
});

// src/icons/v2/DashboardIcon.tsx
init_esm_shims();
import { jsx as jsx36, jsxs as jsxs18 } from "react/jsx-runtime";
var DashboardIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs18(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 48 },
  ...props,
  children: [
    /* @__PURE__ */ jsx36("g", {
      clipPath: "url(#clip0_1613_12664)",
      children: /* @__PURE__ */ jsx36("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.1553 0.703125H6.9761C6.15536 0.703125 5.44932 0.703125 4.8257 0.850069C3.8603 1.08075 2.97761 1.5742 2.27544 2.27575C1.57326 2.97729 1.07902 3.85953 0.847461 4.82473C0.704101 5.44834 0.704102 6.1508 0.704102 6.97512V15.9351C0.704102 16.7559 0.704102 17.4619 0.851046 18.0855C1.08173 19.0509 1.57518 19.9336 2.27672 20.6358C2.97827 21.338 3.86051 21.8322 4.8257 22.0638C5.44932 22.2071 6.15178 22.2071 6.9761 22.2071H15.9361C16.7568 22.2071 17.4629 22.2071 18.0865 22.0602C19.0519 21.8295 19.9346 21.336 20.6368 20.6345C21.3389 19.933 21.8332 19.0507 22.0647 18.0855C22.2081 17.4619 22.2081 16.7594 22.2081 15.9351V6.97512C22.2081 6.15439 22.2081 5.44834 22.0612 4.82473C21.8305 3.85932 21.337 2.97664 20.6355 2.27446C19.9339 1.57228 19.0517 1.07804 18.0865 0.846485C17.4629 0.703125 16.7604 0.703125 15.9361 0.703125H7.1553ZM5.66077 4.3373C5.81488 4.30146 6.05501 4.28712 7.1553 4.28712H15.7569C16.8608 4.28712 17.0973 4.29788 17.2514 4.3373C17.5734 4.41429 17.8677 4.57895 18.1018 4.81302C18.3359 5.0471 18.5005 5.34143 18.5775 5.66338C18.6133 5.81391 18.6241 6.05045 18.6241 7.15432V15.7559C18.6241 16.8598 18.6133 17.0963 18.5739 17.2505C18.4969 17.5724 18.3323 17.8667 18.0982 18.1008C17.8641 18.3349 17.5698 18.4995 17.2478 18.5765C17.1009 18.6088 16.8644 18.6231 15.7569 18.6231H7.1553C6.05143 18.6231 5.81488 18.6124 5.66077 18.5729C5.33882 18.496 5.04449 18.3313 4.81042 18.0972C4.57635 17.8632 4.41168 17.5688 4.33469 17.2469C4.30244 17.0999 4.2881 16.8634 4.2881 15.7559V7.15432C4.2881 6.05045 4.29885 5.81391 4.33828 5.6598C4.41527 5.33785 4.57993 5.04351 4.814 4.80944C5.04807 4.57537 5.34241 4.41071 5.66436 4.33372L5.66077 4.3373ZM32.2433 0.703125H32.0641C31.2434 0.703125 30.5373 0.703125 29.9137 0.850069C28.9483 1.08075 28.0656 1.5742 27.3634 2.27575C26.6613 2.97729 26.167 3.85953 25.9355 4.82473C25.7921 5.44834 25.7921 6.1508 25.7921 6.97512V15.9351C25.7921 16.7559 25.7921 17.4619 25.939 18.0855C26.1697 19.0509 26.6632 19.9336 27.3647 20.6358C28.0663 21.338 28.9485 21.8322 29.9137 22.0638C30.5373 22.2071 31.2398 22.2071 32.0641 22.2071H41.0241C41.8448 22.2071 42.5509 22.2071 43.1745 22.0602C44.1399 21.8295 45.0226 21.336 45.7248 20.6345C46.4269 19.933 46.9212 19.0507 47.1527 18.0855C47.2961 17.4619 47.2961 16.7594 47.2961 15.9351V6.97512C47.2961 6.15439 47.2961 5.44834 47.1492 4.82473C46.9185 3.85932 46.425 2.97664 45.7235 2.27446C45.0219 1.57228 44.1397 1.07804 43.1745 0.846485C42.5509 0.703125 41.8484 0.703125 41.0241 0.703125H32.2433ZM30.7488 4.3373C30.9029 4.30146 31.143 4.28712 32.2433 4.28712H40.8449C41.9488 4.28712 42.1853 4.29788 42.3394 4.3373C42.6614 4.41429 42.9557 4.57895 43.1898 4.81302C43.4239 5.0471 43.5885 5.34143 43.6655 5.66338C43.7014 5.81391 43.7121 6.05045 43.7121 7.15432V15.7559C43.7121 16.8598 43.6978 17.0963 43.6619 17.2505C43.5849 17.5724 43.4203 17.8667 43.1862 18.1008C42.9521 18.3349 42.6578 18.4995 42.3358 18.5765C42.1853 18.6124 41.9488 18.6231 40.8449 18.6231H32.2433C31.1394 18.6231 30.9029 18.6124 30.7488 18.5729C30.4268 18.496 30.1325 18.3313 29.8984 18.0972C29.6643 17.8632 29.4997 17.5688 29.4227 17.2469C29.3904 17.0999 29.3761 16.8634 29.3761 15.7559V7.15432C29.3761 6.05045 29.3869 5.81391 29.4263 5.6598C29.5033 5.33785 29.6679 5.04351 29.902 4.80944C30.1361 4.57537 30.4304 4.41071 30.7524 4.33372L30.7488 4.3373ZM6.9761 25.7911H15.9361C16.7568 25.7911 17.4629 25.7911 18.0865 25.9381C19.0519 26.1688 19.9346 26.6622 20.6368 27.3637C21.3389 28.0653 21.8332 28.9475 22.0647 29.9127C22.2081 30.5363 22.2081 31.2388 22.2081 32.0631V41.0231C22.2081 41.8439 22.2081 42.5499 22.0612 43.1735C21.8305 44.1389 21.337 45.0216 20.6355 45.7238C19.9339 46.426 19.0517 46.9202 18.0865 47.1518C17.4629 47.2951 16.7604 47.2951 15.9361 47.2951H6.9761C6.15536 47.2951 5.44932 47.2951 4.8257 47.1482C3.8603 46.9175 2.97761 46.424 2.27544 45.7225C1.57326 45.021 1.07902 44.1387 0.847461 43.1735C0.704101 42.5499 0.704102 41.8474 0.704102 41.0231V32.0631C0.704102 31.2424 0.704102 30.5363 0.851046 29.9127C1.08173 28.9473 1.57518 28.0646 2.27672 27.3625C2.97827 26.6603 3.86051 26.166 4.8257 25.9345C5.44932 25.7911 6.15178 25.7911 6.9761 25.7911ZM7.1553 29.3751C6.05143 29.3751 5.81488 29.3859 5.66077 29.4253C5.33882 29.5023 5.04449 29.6669 4.81042 29.901C4.57635 30.1351 4.41168 30.4294 4.33469 30.7514C4.30244 30.8983 4.2881 31.1349 4.2881 32.2423V40.8439C4.2881 41.9478 4.29885 42.1843 4.33828 42.3385C4.41527 42.6604 4.57993 42.9547 4.814 43.1888C5.04807 43.4229 5.34241 43.5875 5.66436 43.6645C5.81489 43.7004 6.05143 43.7111 7.1553 43.7111H15.7569C16.8608 43.7111 17.0973 43.6968 17.2514 43.6609C17.5734 43.584 17.8677 43.4193 18.1018 43.1852C18.3359 42.9512 18.5005 42.6568 18.5775 42.3349C18.6133 42.1843 18.6241 41.9478 18.6241 40.8439V32.2423C18.6241 31.1385 18.6133 30.9019 18.5739 30.7478C18.4969 30.4258 18.3323 30.1315 18.0982 29.8974C17.8641 29.6634 17.5698 29.4987 17.2478 29.4217C17.1009 29.3895 16.8644 29.3751 15.7569 29.3751H7.1553ZM32.2433 25.7911H32.0641C31.2434 25.7911 30.5373 25.7911 29.9137 25.9381C28.9483 26.1688 28.0656 26.6622 27.3634 27.3637C26.6613 28.0653 26.167 28.9475 25.9355 29.9127C25.7921 30.5363 25.7921 31.2388 25.7921 32.0631V41.0231C25.7921 41.8439 25.7921 42.5499 25.939 43.1735C26.1697 44.1389 26.6632 45.0216 27.3647 45.7238C28.0663 46.426 28.9485 46.9202 29.9137 47.1518C30.5373 47.2987 31.2434 47.2987 32.0641 47.2987H41.0241C41.8448 47.2987 42.5509 47.2987 43.1745 47.1518C44.1392 46.9205 45.0212 46.4268 45.7227 45.7253C46.4242 45.0238 46.9179 44.1418 47.1492 43.1771C47.2961 42.5535 47.2961 41.8474 47.2961 41.0267V32.0631C47.2961 31.2424 47.2961 30.5363 47.1492 29.9127C46.9185 28.9473 46.425 28.0646 45.7235 27.3625C45.0219 26.6603 44.1397 26.166 43.1745 25.9345C42.5509 25.7911 41.8484 25.7911 41.0241 25.7911H32.2433ZM30.7488 29.4253C30.9029 29.3895 31.143 29.3751 32.2433 29.3751H40.8449C41.9488 29.3751 42.1853 29.3859 42.3394 29.4253C42.6614 29.5023 42.9557 29.6669 43.1898 29.901C43.4239 30.1351 43.5885 30.4294 43.6655 30.7514C43.7014 30.9019 43.7121 31.1385 43.7121 32.2423V40.8439C43.7121 41.9478 43.6978 42.1843 43.6619 42.3385C43.5849 42.6604 43.4203 42.9547 43.1862 43.1888C42.9521 43.4229 42.6578 43.5875 42.3358 43.6645C42.1853 43.7004 41.9488 43.7111 40.8449 43.7111H32.2433C31.1394 43.7111 30.9029 43.6968 30.7488 43.6609C30.4268 43.584 30.1325 43.4193 29.8984 43.1852C29.6643 42.9512 29.4997 42.6568 29.4227 42.3349C29.3904 42.1879 29.3761 41.9514 29.3761 40.8439V32.2423C29.3761 31.1385 29.3869 30.9019 29.4263 30.7478C29.5033 30.4258 29.6679 30.1315 29.902 29.8974C30.1361 29.6634 30.4304 29.4987 30.7524 29.4217L30.7488 29.4253Z",
        fill: color
      })
    }),
    /* @__PURE__ */ jsx36("defs", {
      children: /* @__PURE__ */ jsx36("clipPath", {
        id: "clip0_1613_12664",
        children: /* @__PURE__ */ jsx36("rect", {
          width: 48,
          height: 48,
          fill: "white"
        })
      })
    })
  ]
});

// src/icons/v2/DeleteIcon.tsx
init_esm_shims();
import { jsx as jsx37 } from "react/jsx-runtime";
var DeleteIcon = ({ color = "#655C94", ...props }) => /* @__PURE__ */ jsx37(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 20, height: 20 },
  ...props,
  children: /* @__PURE__ */ jsx37("path", {
    d: "M7.805 3.415h3.902a1.951 1.951 0 0 0-3.902 0Zm-1.464 0a3.414 3.414 0 1 1 6.83 0h5.61a.732.732 0 0 1 0 1.463h-1.288L16.35 16.694A3.658 3.658 0 0 1 12.708 20H6.804a3.658 3.658 0 0 1-3.642-3.306L2.02 4.878H.732a.732.732 0 0 1 0-1.463h5.61Zm1.952 4.634a.732.732 0 1 0-1.464 0v7.317a.732.732 0 0 0 1.464 0V8.049Zm3.658-.732a.732.732 0 0 1 .732.732v7.317a.732.732 0 0 1-1.463 0V8.049a.732.732 0 0 1 .731-.732ZM4.62 16.553a2.195 2.195 0 0 0 2.185 1.984h5.904a2.195 2.195 0 0 0 2.186-1.984l1.13-11.675H3.488l1.13 11.675Z",
    fill: color
  })
});

// src/icons/v2/DocumentIcon.tsx
init_esm_shims();
import { jsx as jsx38 } from "react/jsx-runtime";
var DocumentIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsx38(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 29, height: 30 },
  ...props,
  children: /* @__PURE__ */ jsx38("path", {
    d: "M3.729.938A3.114 3.114 0 0 0 .604 4.063v21.875a3.114 3.114 0 0 0 3.125 3.125h21.875a3.114 3.114 0 0 0 3.125-3.125V4.063A3.114 3.114 0 0 0 25.604.938H3.729Zm0 3.125h21.875v21.875H3.729V4.063Zm3.125 3.125v3.125h15.625V7.187H6.854Zm0 6.25v3.124h15.625v-3.125H6.854Zm0 6.25v3.125H17.79v-3.125H6.854Z",
    fill: color
  })
});

// src/icons/v2/EditIcon.tsx
init_esm_shims();
import { jsx as jsx39 } from "react/jsx-runtime";
var EditIcon = ({ color = "#655C94", ...props }) => /* @__PURE__ */ jsx39(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 18, height: 18 },
  ...props,
  children: /* @__PURE__ */ jsx39("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.185.198a.676.676 0 0 1 .957 0l4.66 4.662a.676.676 0 0 1 0 .956l-11.71 11.71A1.618 1.618 0 0 1 4.948 18H.676A.676.676 0 0 1 0 17.324v-4.272c0-.429.17-.84.474-1.144L9.52 2.861 12.185.198Zm2.475 6.847 1.707-1.707-3.704-3.705-1.708 1.707 3.705 3.705Zm-4.662-2.75-8.568 8.57a.266.266 0 0 0-.077.187v3.595h3.595c.07 0 .138-.028.187-.077L13.703 8 9.998 4.297Z",
    fill: color
  })
});

// src/icons/v2/ErrorOutlineIcon.tsx
init_esm_shims();
import { jsx as jsx40, jsxs as jsxs19 } from "react/jsx-runtime";
var ErrorOutlineIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs19(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 42, height: 40 },
  ...props,
  children: [
    /* @__PURE__ */ jsxs19("g", {
      clipPath: "url(#clip0_1613_12663)",
      children: [
        /* @__PURE__ */ jsx40("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.7919 1.95812C19.7319 0.18843 22.2676 0.188447 23.2076 1.95812L41.4627 36.3264C42.3472 37.9915 41.1403 39.9991 39.2549 39.9991H2.74465C0.85921 39.9991 -0.34767 37.9915 0.53678 36.3264L18.7919 1.95812ZM20.9998 4.19674L3.57639 36.9991H38.4231L20.9998 4.19674Z",
          fill: color
        }),
        /* @__PURE__ */ jsx40("path", {
          d: "M18.9293 14.748H23.0827V25.1699H18.9293V14.748Z",
          fill: color
        }),
        /* @__PURE__ */ jsx40("path", {
          d: "M18.9219 29.3379H23.0835V33.5H18.9219V29.3379Z",
          fill: color
        })
      ]
    }),
    /* @__PURE__ */ jsx40("defs", {
      children: /* @__PURE__ */ jsx40("clipPath", {
        id: "clip0_1613_12663",
        children: /* @__PURE__ */ jsx40("rect", {
          width: 42,
          height: 40,
          fill: "white"
        })
      })
    })
  ]
});

// src/icons/v2/ErrorSolidIcon.tsx
init_esm_shims();
import { jsx as jsx41, jsxs as jsxs20 } from "react/jsx-runtime";
var ErrorSolidIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs20(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 42, height: 40 },
  ...props,
  children: [
    /* @__PURE__ */ jsx41("g", {
      clipPath: "url(#clip0_1613_12670)",
      children: /* @__PURE__ */ jsx41("path", {
        d: "M22.842 1.27578C22.1212 -0.0867188 19.8795 -0.0867188 19.1587 1.27578L0.408654 36.6924C0.23987 37.0099 0.156194 37.3656 0.165779 37.725C0.175364 38.0844 0.277884 38.4352 0.463349 38.7432C0.648814 39.0512 0.910898 39.3059 1.22407 39.4824C1.53723 39.659 1.8908 39.7515 2.25032 39.7508H39.7503C40.1096 39.7515 40.4629 39.6592 40.7759 39.4827C41.0888 39.3062 41.3507 39.0517 41.536 38.7438C41.7213 38.436 41.8236 38.0854 41.8331 37.7263C41.8425 37.3671 41.7587 37.0117 41.5899 36.6945L22.842 1.27578ZM23.0837 33.5008H18.917V29.3341H23.0837V33.5008ZM18.917 25.1674V14.7508H23.0837L23.0857 25.1674H18.917Z",
        fill: color
      })
    }),
    /* @__PURE__ */ jsx41("defs", {
      children: /* @__PURE__ */ jsx41("clipPath", {
        id: "clip0_1613_12670",
        children: /* @__PURE__ */ jsx41("rect", {
          width: 42,
          height: 40,
          fill: "white"
        })
      })
    })
  ]
});

// src/icons/v2/EyeIcon.tsx
init_esm_shims();
import { jsx as jsx42, jsxs as jsxs21 } from "react/jsx-runtime";
var EyeIcon = ({ color = "#655C94", ...props }) => /* @__PURE__ */ jsxs21(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 18, height: 14 },
  ...props,
  children: [
    /* @__PURE__ */ jsx42("path", {
      d: "M9 11.05a4.05 4.05 0 1 1 0-8.101 4.05 4.05 0 0 1 0 8.1ZM9 .7C2.7.7 0 7 0 7s2.7 6.3 9 6.3S18 7 18 7 15.3.7 9 .7Z",
      fill: color
    }),
    /* @__PURE__ */ jsx42("path", {
      d: "M9 9.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z",
      fill: color
    })
  ]
});

// src/icons/v2/EyeOffIcon.tsx
init_esm_shims();
import { jsx as jsx43, jsxs as jsxs22 } from "react/jsx-runtime";
var EyeOffIcon = ({ color = "#655C94", ...props }) => /* @__PURE__ */ jsxs22(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 18, height: 16 },
  ...props,
  children: [
    /* @__PURE__ */ jsx43("path", {
      d: "M11.241 7.526a2.06 2.06 0 0 0-.675-1.461A2.324 2.324 0 0 0 9 5.46l2.241 2.066Z",
      fill: color
    }),
    /* @__PURE__ */ jsx43("path", {
      d: "M7.38 4.104A4.15 4.15 0 0 1 9 3.765c1.074 0 2.104.402 2.864 1.117a3.702 3.702 0 0 1 1.186 2.695c-.001.45-.09.894-.261 1.313l2.511 2.194A11.917 11.917 0 0 0 18 7.577s-2.7-5.93-9-5.93a9.13 9.13 0 0 0-3.6.72l1.98 1.737ZM1.8.801l-.9.847L3.195 3.68A11.886 11.886 0 0 0 0 7.577s2.7 5.93 9 5.93a9.14 9.14 0 0 0 4.176-.983l3.024 2.677.9-.847L1.8.8ZM9 11.389a4.182 4.182 0 0 1-2.864-1.116A3.702 3.702 0 0 1 4.95 7.577a3.602 3.602 0 0 1 .54-1.863l1.377 1.22a1.981 1.981 0 0 0-.117.643c0 .345.088.685.259.99.17.305.419.565.721.76a2.37 2.37 0 0 0 2.089.216l1.386 1.228A4.207 4.207 0 0 1 9 11.389Z",
      fill: color
    })
  ]
});

// src/icons/v2/FileDownloadIcon.tsx
init_esm_shims();
import { jsx as jsx44, jsxs as jsxs23 } from "react/jsx-runtime";
var FileDownloadIcon = ({ color = "white", ...props }) => /* @__PURE__ */ jsxs23(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 22, height: 22 },
  stroke: color,
  ...props,
  children: [
    /* @__PURE__ */ jsx44("path", {
      stroke: "none",
      d: "M0 0h24v24H0z"
    }),
    /* @__PURE__ */ jsx44("path", {
      d: "M14 3v4a1 1 0 001 1h4"
    }),
    /* @__PURE__ */ jsx44("path", {
      d: "M17 21H7a2 2 0 01-2-2V5a2 2 0 012-2h7l5 5v11a2 2 0 01-2 2z"
    }),
    /* @__PURE__ */ jsx44("path", {
      d: "M12 11L12 17"
    }),
    /* @__PURE__ */ jsx44("path", {
      d: "M9 14L12 17 15 14"
    })
  ]
});

// src/icons/v2/FilterIcon.tsx
init_esm_shims();
import { jsx as jsx45 } from "react/jsx-runtime";
var FilterIcon = ({ color = "#655C94", ...props }) => /* @__PURE__ */ jsx45(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 23, height: 16 },
  ...props,
  children: /* @__PURE__ */ jsx45("g", {
    fill: color,
    children: /* @__PURE__ */ jsx45("path", {
      d: "M22.384 1.846H8.846A1.844 1.844 0 0 0 7 0H5.769a1.844 1.844 0 0 0-1.846 1.846H1.46a.61.61 0 0 0-.615.616c0 .344.27.615.615.615h2.462c0 1.021.824 1.846 1.846 1.846h1.23a1.844 1.844 0 0 0 1.847-1.846h13.538A.61.61 0 0 0 23 2.462a.61.61 0 0 0-.616-.616Zm-14.77 1.23A.61.61 0 0 1 7 3.693H5.769a.61.61 0 0 1-.616-.615v-1.23a.61.61 0 0 1 .616-.616h1.23a.61.61 0 0 1 .616.615v1.23ZM22.384 7.385h-2.461a1.844 1.844 0 0 0-1.846-1.846h-1.231a1.844 1.844 0 0 0-1.847 1.846H1.461a.61.61 0 0 0-.615.616c0 .344.27.615.615.615H15c0 1.022.825 1.846 1.847 1.846h1.23a1.844 1.844 0 0 0 1.847-1.846h2.461A.61.61 0 0 0 23 8.001a.61.61 0 0 0-.616-.616Zm-3.692 1.231a.61.61 0 0 1-.616.615h-1.23a.61.61 0 0 1-.616-.615v-1.23a.61.61 0 0 1 .616-.616h1.23a.61.61 0 0 1 .616.615v1.231ZM22.384 12.922h-10.77a1.844 1.844 0 0 0-1.845-1.846H8.538a1.844 1.844 0 0 0-1.846 1.846h-5.23a.61.61 0 0 0-.616.616c0 .344.27.615.615.615h5.23c0 1.022.825 1.846 1.847 1.846h1.23a1.844 1.844 0 0 0 1.847-1.846h10.77a.61.61 0 0 0 .614-.615.61.61 0 0 0-.615-.616Zm-12 1.231a.61.61 0 0 1-.615.615H8.538a.61.61 0 0 1-.615-.615v-1.23a.61.61 0 0 1 .615-.616h1.23a.61.61 0 0 1 .616.615v1.231Z"
    })
  })
});

// src/icons/v2/GearIcon.tsx
init_esm_shims();
import { jsx as jsx46, jsxs as jsxs24 } from "react/jsx-runtime";
var GearIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs24(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 48 },
  ...props,
  children: [
    /* @__PURE__ */ jsx46("path", {
      d: "M24.144 13.9209C18.528 13.9209 14.064 18.3849 14.064 24.0009C14.064 29.6169 18.528 34.0809 24.144 34.0809C29.76 34.0809 34.224 29.6169 34.224 24.0009C34.224 18.3849 29.76 13.9209 24.144 13.9209ZM24.144 31.2009C20.112 31.2009 16.944 28.0329 16.944 24.0009C16.944 19.9689 20.112 16.8009 24.144 16.8009C28.176 16.8009 31.344 19.9689 31.344 24.0009C31.344 28.0329 28.176 31.2009 24.144 31.2009Z",
      fill: color
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "M45.312 19.2489L41.28 17.9529L40.416 15.7929L42.432 12.0489C42.864 11.1849 42.72 10.0329 42 9.31294L38.544 5.85694C37.824 5.13694 36.672 4.99294 35.808 5.42494L32.064 7.44094L29.904 6.57694L28.608 2.54494C28.32 1.68094 27.456 0.960938 26.448 0.960938H21.552C20.544 0.960938 19.68 1.68094 19.536 2.68894L18.24 6.72094C17.376 6.86494 16.656 7.15294 15.936 7.58494L12.192 5.56894C11.328 5.13694 10.176 5.28094 9.45596 6.00094L5.99996 9.45694C5.27996 10.1769 5.13596 11.3289 5.56796 12.1929L7.43996 15.7929C7.15196 16.5129 6.86396 17.3769 6.57596 18.0969L2.54396 19.3929C1.67996 19.6809 0.959961 20.5449 0.959961 21.5529V26.4489C0.959961 27.4569 1.67996 28.3209 2.68796 28.6089L6.71996 29.9049L7.58396 32.0649L5.56796 35.8089C5.13596 36.6729 5.27996 37.8249 5.99996 38.5449L9.45596 42.0009C10.176 42.7209 11.328 42.8649 12.192 42.4329L15.936 40.4169L18.096 41.2809L19.392 45.4569C19.68 46.3209 20.544 47.0409 21.552 47.0409H26.448C27.456 47.0409 28.32 46.3209 28.608 45.4569L29.904 41.2809L32.064 40.4169L35.808 42.4329C36.672 42.8649 37.824 42.7209 38.544 42.0009L42 38.5449C42.72 37.8249 42.864 36.6729 42.432 35.8089L40.416 32.0649L41.28 29.9049L45.456 28.6089C46.32 28.3209 47.04 27.4569 47.04 26.4489V21.5529C47.04 20.5449 46.32 19.5369 45.312 19.2489ZM44.16 26.0169L38.976 27.6009L38.832 28.3209L37.536 31.3449L37.104 32.0649L39.696 36.8169L36.816 39.6969L32.064 37.1049L31.344 37.5369C30.336 38.1129 29.328 38.5449 28.32 38.8329L27.6 38.9769L26.016 44.1609H21.984L20.4 38.9769L19.68 38.8329L16.656 37.5369L15.936 37.1049L11.184 39.6969L8.30396 36.8169L10.896 32.0649L10.464 31.3449C9.88796 30.3369 9.45596 29.3289 9.16796 28.3209L9.02396 27.6009L3.83996 26.0169V21.9849L8.73596 20.5449L9.02396 19.8249C9.31196 18.6729 9.74396 17.6649 10.32 16.6569L10.752 15.9369L8.30396 11.1849L11.184 8.30494L15.792 10.8969L16.512 10.4649C17.52 9.88894 18.528 9.45694 19.68 9.16894L20.4 8.88094L21.984 3.84094H26.016L27.6 8.88094L28.32 9.16894C29.328 9.45694 30.336 9.88894 31.344 10.4649L32.064 10.8969L36.816 8.30494L39.696 11.1849L37.104 15.9369L37.536 16.6569C38.112 17.6649 38.544 18.6729 38.832 19.6809L38.976 20.4009L44.16 21.9849V26.0169Z",
      fill: color
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.0477 2.57409C19.2467 1.33447 20.3186 0.460938 21.552 0.460938H26.448C27.6926 0.460938 28.7333 1.33973 29.0823 2.38682L29.084 2.39192L30.308 6.20004L32.0327 6.88991L35.5776 4.98111L35.5844 4.97772C36.6306 4.4546 38.0174 4.62326 38.8975 5.50338L42.3535 8.95938C43.2336 9.83951 43.4023 11.2263 42.8792 12.2725L42.8758 12.2793L40.967 15.8242L41.6569 17.5489L45.4576 18.7706C46.6836 19.1252 47.54 20.3326 47.54 21.5529V26.4489C47.54 27.6936 46.6612 28.7343 45.6141 29.0833L45.6042 29.0866L41.6557 30.3119L40.967 32.0337L42.8758 35.5786L42.8792 35.5853C43.4023 36.6316 43.2336 38.0184 42.3535 38.8985L38.8975 42.3545C38.0174 43.2346 36.6306 43.4033 35.5844 42.8802L35.5776 42.8768L32.0327 40.968L30.3109 41.6567L29.0824 45.6151C28.7334 46.6622 27.6926 47.5409 26.448 47.5409H21.552C20.3073 47.5409 19.2667 46.6621 18.9176 45.6151L18.9143 45.6052L17.689 41.6567L15.9672 40.968L12.4223 42.8768L12.4156 42.8802C11.3693 43.4033 9.98253 43.2346 9.10241 42.3545L5.64641 38.8985C4.76629 38.0184 4.59762 36.6316 5.12075 35.5853L5.12413 35.5786L7.03293 32.0337L6.34306 30.309L2.54238 29.0873C1.35198 28.7436 0.459961 27.7053 0.459961 26.4489V21.5529C0.459961 20.3083 1.33876 19.2676 2.38585 18.9186L2.39095 18.9169L6.19721 17.6935C6.30957 17.4023 6.42274 17.0912 6.53806 16.7741L6.53967 16.7697C6.65518 16.452 6.7729 16.1283 6.89141 15.8218L5.12069 12.4166C4.59756 11.3703 4.76629 9.98351 5.64641 9.10338L9.10241 5.64738C9.98253 4.76726 11.3693 4.5986 12.4156 5.12172L12.4223 5.12511L15.9274 7.01247C16.5306 6.6775 17.1504 6.43342 17.8549 6.28482L19.0477 2.57409ZM21.552 1.46094C20.784 1.46094 20.1385 2.00662 20.0309 2.75965L20.0249 2.8016L18.6227 7.16404L18.3222 7.21413C17.5273 7.34661 16.8661 7.60993 16.1932 8.01368L15.9493 8.16001L11.962 6.01299C11.2809 5.67602 10.3677 5.79635 9.80951 6.35449L6.35351 9.81049C5.79455 10.3695 5.67469 11.2846 6.01351 11.966L7.98937 15.7657L7.9042 15.9786C7.7637 16.3299 7.62248 16.7181 7.47786 17.1158L7.47627 17.1202C7.3334 17.5131 7.18715 17.9153 7.0402 18.2826L6.95286 18.501L2.70207 19.8673L2.69969 19.8681C2.01985 20.0959 1.45996 20.7825 1.45996 21.5529V26.4489C1.45996 27.2057 2.00383 27.8935 2.82532 28.1282L2.83318 28.1304L7.09686 29.5009L8.13499 32.0962L6.01202 36.0389C5.67505 36.72 5.79537 37.6332 6.35351 38.1914L9.80951 41.6474C10.3677 42.2055 11.281 42.3259 11.9621 41.9889L15.9047 39.8659L18.5029 40.9052L19.8678 45.3034C20.0964 45.9823 20.7823 46.5409 21.552 46.5409H26.448C27.2176 46.5409 27.9035 45.9823 28.1321 45.3035L29.497 40.9052L32.0952 39.8659L36.0378 41.9888C36.7189 42.3259 37.6322 42.2056 38.1904 41.6474L41.6464 38.1914C42.2046 37.6332 42.3249 36.7199 41.9879 36.0388L39.8649 32.0962L40.9042 29.498L45.3025 28.133C45.9813 27.9045 46.54 27.2185 46.54 26.4489V21.5529C46.54 20.76 45.9602 19.9542 45.1746 19.7297L45.1667 19.7275L40.9031 18.357L39.8649 15.7617L41.9879 11.8191C42.3249 11.138 42.2046 10.2247 41.6464 9.66649L38.1904 6.21049C37.6323 5.65235 36.719 5.53202 36.0379 5.869L32.0952 7.99197L29.4999 6.95383L28.1336 2.70305L28.1328 2.70066C27.905 2.02083 27.2184 1.46094 26.448 1.46094H21.552ZM21.617 3.34094H26.3829L28.0059 8.50478L28.4822 8.6953C29.5243 8.99541 30.561 9.44166 31.592 10.0308L31.6013 10.0361L32.0758 10.3209L36.905 7.68684L40.3141 11.0959L37.68 15.9251L37.9702 16.4088C38.564 17.448 39.0126 18.4931 39.3127 19.5436L39.3183 19.563L39.4077 20.01L44.66 21.6149V26.387L39.4077 27.9918L39.312 28.47L37.9822 31.5731L37.68 32.0768L40.3141 36.906L36.905 40.315L32.0758 37.6809L31.5921 37.9712C30.5529 38.565 29.5078 39.0136 28.4573 39.3137L28.4379 39.3193L27.9909 39.4087L26.386 44.6609H21.6139L20.0091 39.4087L19.5309 39.313L16.4278 37.9831L15.9241 37.6809L11.095 40.315L7.68587 36.906L10.32 32.0768L10.0297 31.5931C9.43591 30.5539 8.98735 29.5088 8.6872 28.4583L8.68164 28.4388L8.59224 27.9918L3.33996 26.387V21.6108L8.36191 20.1338L8.54725 19.6704C8.84794 18.4814 9.29618 17.4408 9.88584 16.4089L9.89112 16.3996L10.18 15.9184L7.69233 11.0895L11.0986 7.68323L15.7839 10.3187L16.2638 10.0307C17.2957 9.44106 18.3365 8.99292 19.5254 8.69223L19.9941 8.50478L21.617 3.34094ZM22.3509 4.34094L20.8059 9.2571L19.8342 9.64578L19.8012 9.65401C18.7018 9.92886 17.7375 10.3409 16.7646 10.8964L15.8001 11.4752L11.2694 8.92665L8.91559 11.2804L11.3239 15.9555L10.7515 16.9096C10.1959 17.8825 9.78389 18.8468 9.50903 19.9462L9.5008 19.9791L9.11001 20.9561L4.33996 22.3591V25.6469L9.45568 27.21L9.65424 28.2028C9.92966 29.1604 10.3423 30.1235 10.8955 31.0923L11.472 32.0531L8.92206 36.7279L11.273 39.0788L15.9478 36.5289L16.8841 37.0907L19.8291 38.3529L20.7909 38.5452L22.354 43.6609H25.6459L27.2091 38.5452L28.2019 38.3467C29.1595 38.0712 30.1226 37.6586 31.0913 37.1054L32.0521 36.5289L36.727 39.0788L39.0779 36.7279L36.528 32.0531L37.0898 31.1168L38.3519 28.1718L38.5442 27.21L43.66 25.6469V22.355L38.5442 20.7918L38.3457 19.799C38.0703 18.8414 37.6576 17.8783 37.1045 16.9096L36.528 15.9488L39.0779 11.2739L36.727 8.92303L32.0521 11.4729L31.0913 10.8964C30.1161 10.3396 29.1466 9.92512 28.1826 9.6497L28.158 9.64267L27.1941 9.2571L25.649 4.34094H22.3509ZM13.564 24.0009C13.564 18.1088 18.2518 13.4209 24.144 13.4209C30.0361 13.4209 34.724 18.1088 34.724 24.0009C34.724 29.8931 30.0361 34.5809 24.144 34.5809C18.2518 34.5809 13.564 29.8931 13.564 24.0009ZM24.144 14.4209C18.8041 14.4209 14.564 18.6611 14.564 24.0009C14.564 29.3408 18.8041 33.5809 24.144 33.5809C29.4838 33.5809 33.724 29.3408 33.724 24.0009C33.724 18.6611 29.4838 14.4209 24.144 14.4209ZM24.144 17.3009C20.3881 17.3009 17.444 20.2451 17.444 24.0009C17.444 27.7568 20.3881 30.7009 24.144 30.7009C27.8998 30.7009 30.844 27.7568 30.844 24.0009C30.844 20.2451 27.8998 17.3009 24.144 17.3009ZM16.444 24.0009C16.444 19.6928 19.8358 16.3009 24.144 16.3009C28.4521 16.3009 31.844 19.6928 31.844 24.0009C31.844 28.3091 28.4521 31.7009 24.144 31.7009C19.8358 31.7009 16.444 28.3091 16.444 24.0009Z",
      fill: color
    })
  ]
});

// src/icons/v2/CommunicationsIcon.tsx
init_esm_shims();
import { jsx as jsx47, jsxs as jsxs25 } from "react/jsx-runtime";
var CommunicationsIcon = ({ color = "white", ...props }) => /* @__PURE__ */ jsxs25(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 22, height: 22 },
  stroke: color,
  ...props,
  children: [
    /* @__PURE__ */ jsx47("path", {
      stroke: "none",
      d: "M0 0h24v24H0z"
    }),
    /* @__PURE__ */ jsx47("path", {
      d: "M4 21V8a3 3 0 013-3h10a3 3 0 013 3v6a3 3 0 01-3 3H8l-4 4"
    }),
    /* @__PURE__ */ jsx47("path", {
      d: "M8 9L16 9"
    }),
    /* @__PURE__ */ jsx47("path", {
      d: "M8 13L14 13"
    })
  ]
});

// src/icons/v2/HelpOutlineIcon.tsx
init_esm_shims();
import { jsx as jsx48, jsxs as jsxs26 } from "react/jsx-runtime";
var HelpOutlineIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs26(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 42, height: 42 },
  ...props,
  children: [
    /* @__PURE__ */ jsx48("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.75 38C30.2769 38 38 30.2769 38 20.75C38 11.2231 30.2769 3.5 20.75 3.5C11.2231 3.5 3.5 11.2231 3.5 20.75C3.5 30.2769 11.2231 38 20.75 38ZM20.75 41C31.9338 41 41 31.9338 41 20.75C41 9.56623 31.9338 0.5 20.75 0.5C9.56623 0.5 0.5 9.56623 0.5 20.75C0.5 31.9338 9.56623 41 20.75 41Z",
      fill: color
    }),
    /* @__PURE__ */ jsx48("path", {
      d: "M21 8.5C18.8272 8.50276 16.7441 9.36713 15.2077 10.9035C13.6713 12.44 12.8069 14.523 12.8042 16.6958H16.9708C16.9708 14.4729 18.7792 12.6667 21 12.6667C23.2208 12.6667 25.0292 14.4729 25.0292 16.6958C25.0292 17.9417 24.0271 18.8458 22.4958 20.0833C21.9956 20.4752 21.5151 20.8917 21.0563 21.3312C18.9771 23.4083 18.9167 25.6146 18.9167 25.8604V27.25H23.0833L23.0812 25.9312C23.0833 25.8979 23.15 25.1271 24 24.2792C24.3125 23.9667 24.7063 23.6542 25.1146 23.325C26.7375 22.0104 29.1937 20.025 29.1937 16.6958C29.1921 14.523 28.3284 12.4397 26.7922 10.9031C25.2559 9.36647 23.1728 8.50221 21 8.5ZM18.9167 29.3333H23.0833V33.5H18.9167V29.3333Z",
      fill: color
    })
  ]
});

// src/icons/v2/HelpSolidIcon.tsx
init_esm_shims();
import { jsx as jsx49, jsxs as jsxs27 } from "react/jsx-runtime";
var HelpSolidIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs27(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 42, height: 42 },
  ...props,
  children: [
    /* @__PURE__ */ jsx49("g", {
      clipPath: "url(#clip0_1613_12661)",
      children: /* @__PURE__ */ jsx49("path", {
        d: "M21.0003 0.166016C9.51283 0.166016 0.166992 9.51185 0.166992 20.9993C0.166992 32.4868 9.51283 41.8327 21.0003 41.8327C32.4878 41.8327 41.8337 32.4868 41.8337 20.9993C41.8337 9.51185 32.4878 0.166016 21.0003 0.166016ZM23.0837 33.4993H18.917V29.3327H23.0837V33.4993ZM25.117 23.3223C24.7087 23.6514 24.3149 23.966 24.0024 24.2785C23.1524 25.1264 23.0857 25.8973 23.0837 25.9306V26.2077H18.917V25.8598C18.917 25.6139 18.9774 23.4077 21.0545 21.3306C21.4607 20.9243 21.9649 20.5118 22.4941 20.0827C24.0232 18.8431 25.0274 17.9389 25.0274 16.6931C25.0032 15.6406 24.568 14.6395 23.815 13.9038C23.062 13.1681 22.051 12.7563 20.9983 12.7566C19.9455 12.7569 18.9347 13.1691 18.1821 13.9052C17.4295 14.6413 16.9948 15.6427 16.9712 16.6952H12.8045C12.8045 12.1764 16.4816 8.49935 21.0003 8.49935C25.5191 8.49935 29.1962 12.1764 29.1962 16.6952C29.1962 20.0223 26.7399 22.0077 25.117 23.3223V23.3223Z",
        fill: color
      })
    }),
    /* @__PURE__ */ jsx49("defs", {
      children: /* @__PURE__ */ jsx49("clipPath", {
        id: "clip0_1613_12661",
        children: /* @__PURE__ */ jsx49("rect", {
          width: 42,
          height: 42,
          fill: "white"
        })
      })
    })
  ]
});

// src/icons/v2/InfoOutlineIcon.tsx
init_esm_shims();
import { jsx as jsx50, jsxs as jsxs28 } from "react/jsx-runtime";
var InfoOutlineIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs28(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 42, height: 42 },
  ...props,
  children: [
    /* @__PURE__ */ jsx50("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H38C39.933 0.5 41.5 2.067 41.5 4V38C41.5 39.933 39.933 41.5 38 41.5H4C2.067 41.5 0.5 39.933 0.5 38V4ZM4 3.5C3.72386 3.5 3.5 3.72386 3.5 4V38C3.5 38.2761 3.72386 38.5 4 38.5H38C38.2761 38.5 38.5 38.2761 38.5 38V4C38.5 3.72386 38.2761 3.5 38 3.5H4Z",
      fill: color
    }),
    /* @__PURE__ */ jsx50("path", {
      d: "M23.1547 30.752H19.0013V20.3301H23.1547V30.752Z",
      fill: color
    }),
    /* @__PURE__ */ jsx50("path", {
      d: "M23.1621 16.1621H19.0004V12H23.1621V16.1621Z",
      fill: color
    })
  ]
});

// src/icons/v2/InfoSolidIcon.tsx
init_esm_shims();
import { jsx as jsx51, jsxs as jsxs29 } from "react/jsx-runtime";
var InfoSolidIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs29(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 42, height: 42 },
  ...props,
  children: [
    /* @__PURE__ */ jsx51("path", {
      d: "M0 2C0 0.89543 0.895431 0 2 0H40C41.1046 0 42 0.895431 42 2V40C42 41.1046 41.1046 42 40 42H2C0.89543 42 0 41.1046 0 40V2Z",
      fill: color
    }),
    /* @__PURE__ */ jsx51("path", {
      d: "M23.1547 30.752H19.0013V20.3301H23.1547V30.752Z",
      fill: "white"
    }),
    /* @__PURE__ */ jsx51("path", {
      d: "M23.1621 16.1621L19.0004 16.1621V12H23.1621V16.1621Z",
      fill: "white"
    })
  ]
});

// src/icons/v2/KeyIcon.tsx
init_esm_shims();
import { jsx as jsx52, jsxs as jsxs30 } from "react/jsx-runtime";
var KeyIcon2 = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs30(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 29 },
  ...props,
  children: [
    /* @__PURE__ */ jsxs30("g", {
      clipPath: "url(#clip0_1613_12666)",
      children: [
        /* @__PURE__ */ jsx52("path", {
          d: "M44 28.4004H32V20.4004H26.64C24.36 25.2404 19.44 28.4004 14 28.4004C6.28 28.4004 0 22.1204 0 14.4004C0 6.68039 6.28 0.400391 14 0.400391C19.44 0.400391 24.34 3.56039 26.64 8.40039H48V20.4004H44V28.4004ZM36 24.4004H40V16.4004H44V12.4004H23.88L23.42 11.0604C22.02 7.08039 18.22 4.40039 14 4.40039C8.48 4.40039 4 8.88039 4 14.4004C4 19.9204 8.48 24.4004 14 24.4004C18.22 24.4004 22.02 21.7204 23.42 17.7404L23.88 16.4004H36V24.4004ZM14 20.4004C10.7 20.4004 8 17.7004 8 14.4004C8 11.1004 10.7 8.40039 14 8.40039C17.3 8.40039 20 11.1004 20 14.4004C20 17.7004 17.3 20.4004 14 20.4004ZM14 12.4004C12.9 12.4004 12 13.3004 12 14.4004C12 15.5004 12.9 16.4004 14 16.4004C15.1 16.4004 16 15.5004 16 14.4004C16 13.3004 15.1 12.4004 14 12.4004Z",
          fill: color
        }),
        /* @__PURE__ */ jsx52("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 0.400391C19.44 0.400391 24.34 3.56039 26.64 8.40039H48V20.4004H44V28.4004H32V20.4004H26.64C24.36 25.2404 19.44 28.4004 14 28.4004C6.28 28.4004 0 22.1204 0 14.4004C0 6.68039 6.28 0.400391 14 0.400391ZM26.4504 8.70039L26.369 8.52915C24.1181 3.79243 19.3228 0.700391 14 0.700391C6.44569 0.700391 0.3 6.84608 0.3 14.4004C0.3 21.9547 6.44569 28.1004 14 28.1004C19.3234 28.1004 24.1379 25.0078 26.3686 20.2725L26.4497 20.1004H32.3V28.1004H43.7V20.1004H47.7V8.70039H26.4504Z",
          fill: "#F5F5F5"
        }),
        /* @__PURE__ */ jsx52("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.3 14.4004C8.3 17.5347 10.8657 20.1004 14 20.1004C17.1343 20.1004 19.7 17.5347 19.7 14.4004C19.7 11.2661 17.1343 8.70039 14 8.70039C10.8657 8.70039 8.3 11.2661 8.3 14.4004ZM11.7 14.4004C11.7 13.1347 12.7343 12.1004 14 12.1004C15.2657 12.1004 16.3 13.1347 16.3 14.4004C16.3 15.6661 15.2657 16.7004 14 16.7004C12.7343 16.7004 11.7 15.6661 11.7 14.4004ZM8 14.4004C8 17.7004 10.7 20.4004 14 20.4004C17.3 20.4004 20 17.7004 20 14.4004C20 11.1004 17.3 8.40039 14 8.40039C10.7 8.40039 8 11.1004 8 14.4004ZM12 14.4004C12 13.3004 12.9 12.4004 14 12.4004C15.1 12.4004 16 13.3004 16 14.4004C16 15.5004 15.1 16.4004 14 16.4004C12.9 16.4004 12 15.5004 12 14.4004Z",
          fill: "#F5F5F5"
        }),
        /* @__PURE__ */ jsx52("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M24.0942 16.7004H35.7V24.7004H40.3V16.7004H44.3V12.1004H24.0942L23.7038 10.963L23.703 10.9608C22.2606 6.86019 18.3467 4.10039 14 4.10039C8.31431 4.10039 3.7 8.7147 3.7 14.4004C3.7 20.0861 8.31431 24.7004 14 24.7004C18.3467 24.7004 22.2606 21.9406 23.703 17.8399L24.0942 16.7004ZM23.42 11.0604L23.88 12.4004H44V16.4004H40V24.4004H36V16.4004H23.88L23.42 17.7404C22.02 21.7204 18.22 24.4004 14 24.4004C8.48 24.4004 4 19.9204 4 14.4004C4 8.88039 8.48 4.40039 14 4.40039C18.22 4.40039 22.02 7.08039 23.42 11.0604Z",
          fill: "#F5F5F5"
        })
      ]
    }),
    /* @__PURE__ */ jsx52("defs", {
      children: /* @__PURE__ */ jsx52("clipPath", {
        id: "clip0_1613_12666",
        children: /* @__PURE__ */ jsx52("rect", {
          width: 48,
          height: 28.8,
          fill: "white"
        })
      })
    })
  ]
});

// src/icons/v2/LightBulbIcon.tsx
init_esm_shims();
import { jsx as jsx53, jsxs as jsxs31 } from "react/jsx-runtime";
var LightBulbIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs31(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 39, height: 52 },
  ...props,
  children: [
    /* @__PURE__ */ jsx53("path", {
      d: "M8.94438 5.37133L11.1744 8.70498C11.2419 8.65125 11.3098 8.5981 11.3784 8.54554C13.8153 6.67687 16.8006 5.66406 19.8715 5.66406L8.94438 5.37133Z",
      fill: color
    }),
    /* @__PURE__ */ jsx53("path", {
      d: "M19.8715 1.66406C15.9205 1.66406 12.0797 2.96712 8.94438 5.37133L19.8715 5.66406C22.9425 5.66406 25.9277 6.67686 28.3646 8.54554C30.8016 10.4142 32.5542 13.0344 33.351 16.0002C34.1478 18.966 33.9442 22.1118 32.7718 24.9501C31.5993 27.7885 29.5236 30.1609 26.8661 31.6999L26.8649 31.7005L28.8601 35.1432L28.8718 35.1607C32.2903 33.1807 34.9605 30.1286 36.4688 26.4772C37.9772 22.8255 38.2391 18.7782 37.214 14.9624C36.1889 11.1467 33.934 7.77554 30.7987 5.37133C27.6633 2.96712 23.8226 1.66406 19.8715 1.66406Z",
      fill: color
    }),
    /* @__PURE__ */ jsx53("path", {
      d: "M6.97128 24.9501C5.79886 22.1118 5.59526 18.966 6.39202 16.0002C7.16638 13.1179 8.8436 10.5619 11.1744 8.70498L8.94438 5.37133C5.80902 7.77554 3.5541 11.1467 2.529 14.9624C1.5039 18.7782 1.76585 22.8255 3.27426 26.4772C4.7825 30.1286 7.45272 33.1807 10.8713 35.1607C12.2883 35.9826 13.0853 37.2069 13.0853 38.3583V38.7668C13.0853 39.8713 13.9808 40.7668 15.0853 40.7668C16.1899 40.7668 17.0853 39.8713 17.0853 38.7668V38.3583C17.0853 35.3267 15.0781 32.9765 12.8781 31.7005L12.877 31.6999C10.2195 30.1609 8.14369 27.7885 6.97128 24.9501Z",
      fill: color
    }),
    /* @__PURE__ */ jsx53("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.1787 25.2573C16.1089 24.9825 15.0188 25.627 14.744 26.6968C14.4692 27.7666 15.1136 28.8567 16.1835 29.1315C16.7402 29.2745 17.3042 29.3848 17.8726 29.462V38.7668C17.8726 39.8713 18.768 40.7668 19.8726 40.7668C20.9772 40.7668 21.8726 39.8713 21.8726 38.7668V29.462C22.441 29.3848 23.005 29.2745 23.5617 29.1315C23.9248 29.0383 24.239 28.851 24.4848 28.6026L22.2917 25.3241C21.499 25.5057 20.688 25.5972 19.8741 25.5966H19.871C18.9629 25.5973 18.0583 25.4833 17.1787 25.2573ZM19.8726 29.5966L19.871 29.5966L19.8726 27.5966L19.8741 29.5966L19.8726 29.5966Z",
      fill: color
    }),
    /* @__PURE__ */ jsx53("path", {
      d: "M25.0012 26.6968C24.7263 25.627 23.6363 24.9825 22.5664 25.2573C22.4751 25.2808 22.3835 25.303 22.2917 25.3241L24.4848 28.6026C24.9631 28.119 25.1827 27.4035 25.0012 26.6968Z",
      fill: color
    }),
    /* @__PURE__ */ jsx53("path", {
      d: "M26.6598 38.3583C26.6598 37.2061 27.4556 35.9825 28.8706 35.1613L28.8601 35.1432L26.6451 31.832C24.532 33.135 22.6598 35.429 22.6598 38.3583V38.7668C22.6598 39.8713 23.5552 40.7668 24.6598 40.7668C25.7644 40.7668 26.6598 39.8713 26.6598 38.7668V38.3583Z",
      fill: color
    }),
    /* @__PURE__ */ jsx53("path", {
      d: "M15.4585 41.1402C14.3733 40.9341 13.3265 41.6468 13.1205 42.7319C12.9144 43.8171 13.627 44.8639 14.7122 45.07C18.122 45.7175 21.6232 45.7175 25.0329 45.07C26.1181 44.8639 26.8308 43.8171 26.6247 42.7319C26.4186 41.6468 25.3719 40.9341 24.2867 41.1402C21.37 41.6941 18.3752 41.6941 15.4585 41.1402Z",
      fill: color
    }),
    /* @__PURE__ */ jsx53("path", {
      d: "M16.8893 46.1862C15.7908 46.0711 14.807 46.8685 14.692 47.967C14.577 49.0656 15.3743 50.0494 16.4728 50.1644C18.7332 50.4011 21.012 50.4011 23.2723 50.1644C24.3709 50.0494 25.1682 49.0656 25.0532 47.967C24.9382 46.8685 23.9544 46.0711 22.8558 46.1862C20.8724 46.3938 18.8727 46.3938 16.8893 46.1862Z",
      fill: color
    }),
    /* @__PURE__ */ jsx53("path", {
      d: "M26.8649 31.7005C26.7914 31.7432 26.7181 31.787 26.6451 31.832L28.8601 35.1432L26.8649 31.7005Z",
      fill: color
    })
  ]
});

// src/icons/v2/LockOutlineIcon.tsx
init_esm_shims();
import { jsx as jsx54, jsxs as jsxs32 } from "react/jsx-runtime";
var LockOutlineIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs32(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 40, height: 48 },
  ...props,
  children: [
    /* @__PURE__ */ jsx54("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M36 22.8H3.6V44.4H36V22.8ZM0 19.2V48H39.6V19.2H0Z",
      fill: color
    }),
    /* @__PURE__ */ jsx54("path", {
      d: "M35.3475 15.2738C35.3475 6.85141 28.4961 0 20.0738 0C11.6514 0 4.8 6.85141 4.8 15.2738V19.2H9.16312V15.2738C9.16312 9.25657 14.0594 4.36312 20.0738 4.36312C26.0881 4.36312 30.9844 9.25944 30.9844 15.2738V19.2H35.3475V15.2738Z",
      fill: color
    }),
    /* @__PURE__ */ jsx54("path", {
      d: "M15.6 30H24V37.2H15.6V30Z",
      fill: color
    })
  ]
});

// src/icons/v2/LockSolidIcon.tsx
init_esm_shims();
import { jsx as jsx55, jsxs as jsxs33 } from "react/jsx-runtime";
var LockSolidIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs33(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 40, height: 48 },
  ...props,
  children: [
    /* @__PURE__ */ jsx55("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M36 22.8H3.6V44.4H36V22.8ZM0 19.2V48H39.6V19.2H0Z",
      fill: color
    }),
    /* @__PURE__ */ jsx55("path", {
      d: "M35.3475 15.2738C35.3475 6.85141 28.4961 0 20.0738 0C11.6514 0 4.8 6.85141 4.8 15.2738V19.2H9.16312V15.2738C9.16312 9.25657 14.0594 4.36312 20.0738 4.36312C26.0881 4.36312 30.9844 9.25944 30.9844 15.2738V19.2H35.3475V15.2738Z",
      fill: color
    }),
    /* @__PURE__ */ jsx55("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.6 22.8H36V44.4H3.6V22.8ZM24 30H15.6V37.2H24V30Z",
      fill: color
    })
  ]
});

// src/icons/v2/LogOutIcon.tsx
init_esm_shims();
import { jsx as jsx56, jsxs as jsxs34 } from "react/jsx-runtime";
var LogOutIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs34(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 38, height: 48 },
  ...props,
  children: [
    /* @__PURE__ */ jsx56("g", {
      clipPath: "url(#clip0_1613_12665)",
      children: /* @__PURE__ */ jsx56("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.08444 2.25144C3.36594 0.969938 5.10403 0.25 6.91634 0.25H31.083C32.8953 0.25 34.6334 0.969939 35.9149 2.25144C37.1964 3.53294 37.9163 5.27102 37.9163 7.08333V9.5C37.9163 10.6046 37.0209 11.5 35.9163 11.5C34.8118 11.5 33.9163 10.6046 33.9163 9.5V7.08333C33.9163 6.33189 33.6178 5.61122 33.0865 5.07986C32.5551 4.54851 31.8345 4.25 31.083 4.25H6.91634C6.16489 4.25 5.44422 4.54851 4.91287 5.07986C4.38152 5.61122 4.08301 6.33189 4.08301 7.08333V40.9167C4.08301 41.6681 4.38152 42.3888 4.91287 42.9201C5.44423 43.4515 6.1649 43.75 6.91634 43.75H31.083C31.8345 43.75 32.5551 43.4515 33.0865 42.9201C33.6178 42.3888 33.9163 41.6681 33.9163 40.9167V38.5C33.9163 37.3954 34.8118 36.5 35.9163 36.5C37.0209 36.5 37.9163 37.3954 37.9163 38.5V40.9167C37.9163 42.729 37.1964 44.4671 35.9149 45.7486C34.6334 47.0301 32.8953 47.75 31.083 47.75H6.91634C5.10403 47.75 3.36594 47.0301 2.08444 45.7486C0.802946 44.4671 0.0830078 42.729 0.0830078 40.9167V7.08333C0.0830078 5.27102 0.802946 3.53294 2.08444 2.25144ZM27.2521 15.3358C28.0332 14.5547 29.2995 14.5547 30.0806 15.3358L37.3289 22.5841C37.334 22.5892 37.339 22.5943 37.3441 22.5994C37.5291 22.788 37.6693 23.0041 37.7646 23.2344C37.8658 23.479 37.9163 23.7395 37.9163 24C37.9163 24.549 37.6952 25.0463 37.3371 25.4077M37.3295 25.4152L30.0806 32.6642C29.2995 33.4453 28.0332 33.4453 27.2521 32.6642C26.4711 31.8832 26.4711 30.6168 27.2521 29.8358L31.0879 26H18.9997C17.8951 26 16.9997 25.1046 16.9997 24C16.9997 22.8954 17.8951 22 18.9997 22H31.0879L27.2521 18.1642C26.4711 17.3832 26.4711 16.1168 27.2521 15.3358M35.9318 25.9999C36.1973 25.9979 36.4506 25.9442 36.6819 25.8482C36.9151 25.7518 37.1338 25.6092 37.324 25.4207C37.3259 25.4189 37.3277 25.4171 37.3295 25.4152",
        fill: color
      })
    }),
    /* @__PURE__ */ jsx56("defs", {
      children: /* @__PURE__ */ jsx56("clipPath", {
        id: "clip0_1613_12665",
        children: /* @__PURE__ */ jsx56("rect", {
          width: 38,
          height: 48,
          fill: "white"
        })
      })
    })
  ]
});

// src/icons/v2/MinusIcon.tsx
init_esm_shims();
import { jsx as jsx57, jsxs as jsxs35 } from "react/jsx-runtime";
var MinusIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs35(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 48 },
  ...props,
  children: [
    /* @__PURE__ */ jsx57("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 21.7143H20.7143H26.2857H43V27.2857H26.2857H20.7143H4V21.7143Z",
      fill: color
    }),
    /* @__PURE__ */ jsx57("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.7143 27.2857V21.7143H26.2857V27.2857H20.7143Z",
      fill: color
    })
  ]
});

// src/icons/v2/MoonIcon.tsx
init_esm_shims();
import { jsx as jsx58 } from "react/jsx-runtime";
var MoonIcon = ({ color = "#5C5C5C", ...props }) => /* @__PURE__ */ jsx58(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 20, height: 20 },
  ...props,
  children: /* @__PURE__ */ jsx58("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 9c0-4.908 4.278-9 8.68-9a1 1 0 0 1 .894 1.447 8.12 8.12 0 0 0-.776 2.968c-.07 1.256.211 2.54 1.23 3.558 1.017 1.018 2.301 1.298 3.556 1.229a8.12 8.12 0 0 0 2.969-.776 1 1 0 0 1 1.447.894c0 4.402-4.093 8.676-9 8.68-4.968 0-9-4.032-9-9Zm7.155-6.78C4.926 3.005 2.5 5.773 2.5 9c0 3.863 3.136 7 7 7 3.228-.003 5.996-2.427 6.779-5.155a9.798 9.798 0 0 1-2.084.353c-1.624.09-3.54-.269-5.082-1.81C7.57 7.844 7.21 5.928 7.302 4.304c.041-.755.18-1.466.353-2.084Z",
    fill: color
  })
});

// src/icons/v2/PlusIcon.tsx
init_esm_shims();
import { jsx as jsx59, jsxs as jsxs36 } from "react/jsx-runtime";
var PlusIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs36(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 48 },
  ...props,
  children: [
    /* @__PURE__ */ jsx59("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.7143 44V5H26.2857V44H20.7143Z",
      fill: color
    }),
    /* @__PURE__ */ jsx59("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 21.7143H43V27.2857H4V21.7143Z",
      fill: color
    })
  ]
});

// src/icons/v2/PrinterIcon.tsx
init_esm_shims();
import { jsx as jsx60, jsxs as jsxs37 } from "react/jsx-runtime";
var PrinterIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs37(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 42 },
  ...props,
  children: [
    /* @__PURE__ */ jsx60("g", {
      clipPath: "url(#clip0_1613_12667)",
      children: /* @__PURE__ */ jsx60("path", {
        d: "M10.2857 5.14286C10.2857 3.77889 10.8275 2.47078 11.792 1.50631C12.7565 0.541835 14.0646 0 15.4286 0H32.5714C33.9354 0 35.2435 0.541835 36.208 1.50631C37.1725 2.47078 37.7143 3.77889 37.7143 5.14286V6.85714H41.1429C42.9615 6.85714 44.7056 7.57959 45.9916 8.86555C47.2776 10.1515 48 11.8957 48 13.7143V29.1429C48 30.5068 47.4582 31.8149 46.4937 32.7794C45.5292 33.7439 44.2211 34.2857 42.8571 34.2857H38.0571V36C38.0571 37.364 37.5153 38.6721 36.5508 39.6366C35.5864 40.601 34.2783 41.1429 32.9143 41.1429H15.4286C14.0646 41.1429 12.7565 40.601 11.792 39.6366C10.8275 38.6721 10.2857 37.364 10.2857 36V34.2857H5.14286C3.77889 34.2857 2.47078 33.7439 1.50631 32.7794C0.541835 31.8149 0 30.5068 0 29.1429V13.7143C0 11.8957 0.722447 10.1515 2.00841 8.86555C3.29437 7.57959 5.03852 6.85714 6.85714 6.85714H10.2857V5.14286ZM34.2857 6.85714V5.14286C34.2857 4.6882 34.1051 4.25217 33.7836 3.93067C33.4621 3.60918 33.0261 3.42857 32.5714 3.42857H15.4286C14.9739 3.42857 14.5379 3.60918 14.2164 3.93067C13.8949 4.25217 13.7143 4.6882 13.7143 5.14286V6.85714H34.2857ZM10.2857 10.2857H6.85714C5.94783 10.2857 5.07576 10.6469 4.43278 11.2899C3.78979 11.9329 3.42857 12.805 3.42857 13.7143V29.1429C3.42857 29.5975 3.60918 30.0336 3.93067 30.355C4.25217 30.6765 4.6882 30.8571 5.14286 30.8571H10.2857V29.1429C10.2857 27.7789 10.8275 26.4708 11.792 25.5063C12.7565 24.5418 14.0646 24 15.4286 24H32.9143C34.2783 24 35.5864 24.5418 36.5508 25.5063C37.5153 26.4708 38.0571 27.7789 38.0571 29.1429V30.8571H42.8571C43.3118 30.8571 43.7478 30.6765 44.0693 30.355C44.3908 30.0336 44.5714 29.5975 44.5714 29.1429V13.7143C44.5714 12.805 44.2102 11.9329 43.5672 11.2899C42.9242 10.6469 42.0522 10.2857 41.1429 10.2857H10.2857ZM15.4286 27.4286C14.9739 27.4286 14.5379 27.6092 14.2164 27.9307C13.8949 28.2522 13.7143 28.6882 13.7143 29.1429V36C13.7143 36.4547 13.8949 36.8907 14.2164 37.2122C14.5379 37.5337 14.9739 37.7143 15.4286 37.7143H32.9143C33.3689 37.7143 33.805 37.5337 34.1265 37.2122C34.448 36.8907 34.6286 36.4547 34.6286 36V29.1429C34.6286 28.6882 34.448 28.2522 34.1265 27.9307C33.805 27.6092 33.3689 27.4286 32.9143 27.4286H15.4286Z",
        fill: color
      })
    }),
    /* @__PURE__ */ jsx60("defs", {
      children: /* @__PURE__ */ jsx60("clipPath", {
        id: "clip0_1613_12667",
        children: /* @__PURE__ */ jsx60("rect", {
          width: 48,
          height: 41.1429,
          fill: "white"
        })
      })
    })
  ]
});

// src/icons/v2/RefreshIcon.tsx
init_esm_shims();
import { jsx as jsx61 } from "react/jsx-runtime";
var RefreshIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsx61(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 40, height: 42 },
  ...props,
  children: /* @__PURE__ */ jsx61("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8.5C12.9171 8.5 7.5 13.5966 7.5 19.32C7.5 20.1484 6.82843 20.82 6 20.82C5.17157 20.82 4.5 20.1484 4.5 19.32C4.5 11.6034 11.618 5.5 20 5.5C24.673 5.5 28.4972 7.67678 31.087 9.7487C31.603 10.1614 32.0748 10.5739 32.5 10.9701V7C32.5 6.17157 33.1716 5.5 34 5.5C34.8284 5.5 35.5 6.17157 35.5 7V14.84C35.5 15.222 35.3572 15.5706 35.1221 15.8354C34.876 16.1127 34.5287 16.2981 34.1381 16.3337C34.0861 16.3385 34.0342 16.3406 33.9824 16.34H27.28C26.4516 16.34 25.78 15.6684 25.78 14.84C25.78 14.0116 26.4516 13.34 27.28 13.34H30.6406C30.2196 12.9386 29.7423 12.5148 29.213 12.0913C26.9028 10.2432 23.727 8.5 20 8.5ZM34 21.18C34.8284 21.18 35.5 21.8516 35.5 22.68C35.5 30.3966 28.382 36.5 20 36.5C15.327 36.5 11.5028 34.3232 8.91296 32.2513C8.39703 31.8386 7.92516 31.4261 7.5 31.0299V35C7.5 35.8284 6.82843 36.5 6 36.5C5.17157 36.5 4.5 35.8284 4.5 35V27.16C4.5 26.7789 4.6421 26.4311 4.8762 26.1665C4.94719 26.0861 5.02692 26.0132 5.11425 25.9493C5.3276 25.793 5.5838 25.6916 5.86194 25.6663C5.9139 25.6615 5.96583 25.6594 6.01754 25.66H12.72C13.5484 25.66 14.22 26.3316 14.22 27.16C14.22 27.9884 13.5484 28.66 12.72 28.66H9.35938C9.78036 29.0614 10.2577 29.4852 10.787 29.9087C13.0972 31.7568 16.273 33.5 20 33.5C27.0829 33.5 32.5 28.4034 32.5 22.68C32.5 21.8516 33.1716 21.18 34 21.18Z",
    fill: color
  })
});

// src/icons/v2/SearchIcon.tsx
init_esm_shims();
import { jsx as jsx62 } from "react/jsx-runtime";
var SearchIcon = ({ color = "#655C94", ...props }) => /* @__PURE__ */ jsx62(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 21, height: 22 },
  ...props,
  children: /* @__PURE__ */ jsx62("path", {
    d: "m20 20.5-4.486-4.494L20 20.5ZM18 10a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0v0Z",
    stroke: color,
    strokeWidth: 2,
    strokeLinecap: "round"
  })
});

// src/icons/v2/SuccessIcon.tsx
init_esm_shims();
import { jsx as jsx63, jsxs as jsxs38 } from "react/jsx-runtime";
var SuccessIcon = ({ color = "#BCCCDD", ...props }) => /* @__PURE__ */ jsxs38(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 100, height: 100 },
  ...props,
  children: [
    /* @__PURE__ */ jsx63("path", {
      d: "M50 93.75a43.75 43.75 0 1 1 0-87.5 43.75 43.75 0 0 1 0 87.5Zm0 6.25A50 50 0 1 0 50 0a50 50 0 0 0 0 100Z",
      fill: color
    }),
    /* @__PURE__ */ jsx63("path", {
      d: "M68.561 31.062a1.454 1.454 0 0 0-.125.137L46.73 58.855 33.649 45.768a4.687 4.687 0 0 0-6.625 6.625L43.56 68.937a4.687 4.687 0 0 0 6.744-.125l24.95-31.188a4.688 4.688 0 0 0-6.694-6.562Z",
      fill: color
    })
  ]
});

// src/icons/v2/SunIcon.tsx
init_esm_shims();
import { jsx as jsx64 } from "react/jsx-runtime";
var SunIcon = ({ color = "#050203", ...props }) => /* @__PURE__ */ jsx64(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 20, height: 20 },
  ...props,
  children: /* @__PURE__ */ jsx64("path", {
    d: "M10 4a1 1 0 0 0 1-1V1a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1Zm9 5h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2ZM4 10a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1Zm.22-7a1.012 1.012 0 1 0-1.39 1.47l1.44 1.39a1 1 0 0 0 .73.28 1 1 0 0 0 .72-.31 1 1 0 0 0 0-1.41L4.22 3ZM15 6.14a1 1 0 0 0 .69-.28l1.44-1.39A1 1 0 0 0 15.78 3l-1.44 1.42a1 1 0 0 0 0 1.41 1 1 0 0 0 .66.31ZM10 16a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1Zm5.73-1.86a1.001 1.001 0 0 0-1.39 1.44L15.78 17a1 1 0 0 0 1.41-.02 1.002 1.002 0 0 0 0-1.42l-1.46-1.42Zm-11.46 0-1.44 1.39a1 1 0 0 0 0 1.42 1 1 0 0 0 .72.3 1 1 0 0 0 .67-.25l1.44-1.39a1 1 0 1 0-1.39-1.44v-.03ZM10 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z",
    fill: color
  })
});

// src/icons/v2/TruckIcon.tsx
init_esm_shims();
import { jsx as jsx65 } from "react/jsx-runtime";
var TruckIcon2 = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsx65(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 48, height: 38 },
  ...props,
  children: /* @__PURE__ */ jsx65("path", {
    d: "M47.6506 18.1079L42.5306 6.16113C42.3999 5.85265 42.1814 5.58944 41.9021 5.40431C41.6229 5.21919 41.2954 5.12032 40.9604 5.12005H35.8404V1.70668C35.8404 1.25404 35.6605 0.819942 35.3405 0.499876C35.0204 0.179811 34.5863 0 34.1337 0H1.70668C1.25404 0 0.819941 0.179811 0.499876 0.499876C0.179811 0.819942 0 1.25404 0 1.70668V30.7203C0 31.1729 0.179811 31.607 0.499876 31.9271C0.819941 32.2472 1.25404 32.427 1.70668 32.427H5.35899C5.75201 33.8732 6.60999 35.1499 7.80056 36.0601C8.99114 36.9703 10.4481 37.4634 11.9468 37.4634C13.4454 37.4634 14.9024 36.9703 16.093 36.0601C17.2836 35.1499 18.1416 33.8732 18.5346 32.427H29.2526C29.6456 33.8732 30.5036 35.1499 31.6941 36.0601C32.8847 36.9703 34.3417 37.4634 35.8404 37.4634C37.339 37.4634 38.796 36.9703 39.9866 36.0601C41.1772 35.1499 42.0351 33.8732 42.4282 32.427H46.0805C46.5331 32.427 46.9672 32.2472 47.2873 31.9271C47.6073 31.607 47.7871 31.1729 47.7871 30.7203V18.7735C47.7867 18.5447 47.7403 18.3184 47.6506 18.1079ZM35.8404 8.53342H39.834L43.4863 17.0668H35.8404V8.53342ZM11.9468 34.1337C11.2717 34.1337 10.6117 33.9335 10.0504 33.5584C9.4891 33.1833 9.0516 32.6503 8.79325 32.0265C8.5349 31.4028 8.4673 30.7165 8.59901 30.0544C8.73071 29.3923 9.0558 28.7841 9.53317 28.3067C10.0105 27.8293 10.6187 27.5042 11.2809 27.3725C11.943 27.2408 12.6293 27.3084 13.253 27.5668C13.8767 27.8251 14.4098 28.2626 14.7849 28.8239C15.16 29.3853 15.3602 30.0452 15.3602 30.7203C15.3602 31.6256 15.0005 32.4938 14.3604 33.1339C13.7203 33.774 12.8521 34.1337 11.9468 34.1337ZM29.2526 29.0136H18.5346C18.1416 27.5674 17.2836 26.2907 16.093 25.3805C14.9024 24.4703 13.4454 23.9772 11.9468 23.9772C10.4481 23.9772 8.99114 24.4703 7.80056 25.3805C6.60999 26.2907 5.75201 27.5674 5.35899 29.0136H3.41337V3.41337H32.427V24.8493C31.6498 25.3004 30.9694 25.9004 30.4246 26.615C29.8799 27.3296 29.4816 28.1447 29.2526 29.0136ZM35.8404 34.1337C35.1653 34.1337 34.5053 33.9335 33.944 33.5584C33.3827 33.1833 32.9452 32.6503 32.6868 32.0265C32.4285 31.4028 32.3609 30.7165 32.4926 30.0544C32.6243 29.3923 32.9494 28.7841 33.4267 28.3067C33.9041 27.8293 34.5123 27.5042 35.1744 27.3725C35.8366 27.2408 36.5229 27.3084 37.1466 27.5668C37.7703 27.8251 38.3034 28.2626 38.6785 28.8239C39.0535 29.3853 39.2537 30.0452 39.2537 30.7203C39.2537 31.6256 38.8941 32.4938 38.254 33.1339C37.6138 33.774 36.7456 34.1337 35.8404 34.1337ZM44.3738 29.0136H42.4282C42.0507 27.5519 41.1995 26.2565 40.0075 25.3301C38.8155 24.4036 37.35 23.8985 35.8404 23.8936V20.4802H44.3738V29.0136Z",
    fill: color
  })
});

// src/icons/v2/UnlockOutlineIcon.tsx
init_esm_shims();
import { jsx as jsx66, jsxs as jsxs39 } from "react/jsx-runtime";
var UnlockOutlineIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs39(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 40, height: 48 },
  ...props,
  children: [
    /* @__PURE__ */ jsx66("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M36 22.8H3.6V44.4H36V22.8ZM0 19.2V48H39.6V19.2H0Z",
      fill: color
    }),
    /* @__PURE__ */ jsx66("path", {
      d: "M15.6 30H24V37.2H15.6V30Z",
      fill: color
    }),
    /* @__PURE__ */ jsx66("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M30.3479 11.6007L34.3433 9.82491C32.1445 4.08544 26.5775 0 20.0738 0C11.6514 0 4.8 6.85141 4.8 15.2738V19.2H9.16312V15.2738C9.16312 9.25657 14.0594 4.36312 20.0738 4.36312C24.8001 4.36312 28.836 7.38684 30.3479 11.6007Z",
      fill: color
    })
  ]
});

// src/icons/v2/UnlockSolidIcon.tsx
init_esm_shims();
import { jsx as jsx67, jsxs as jsxs40 } from "react/jsx-runtime";
var UnlockSolidIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs40(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 40, height: 48 },
  ...props,
  children: [
    /* @__PURE__ */ jsx67("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M36 22.8H3.6V44.4H36V22.8ZM0 19.2V48H39.6V19.2H0Z",
      fill: color
    }),
    /* @__PURE__ */ jsx67("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.6 22.8H36V44.4H3.6V22.8ZM24 30H15.6V37.2H24V30Z",
      fill: color
    }),
    /* @__PURE__ */ jsx67("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M30.3479 11.6007L34.3433 9.82491C32.1445 4.08544 26.5775 0 20.0738 0C11.6514 0 4.8 6.85141 4.8 15.2738V19.2H9.16312V15.2738C9.16312 9.25657 14.0594 4.36312 20.0738 4.36312C24.8001 4.36312 28.836 7.38684 30.3479 11.6007Z",
      fill: color
    })
  ]
});

// src/icons/v2/UsersIcon.tsx
init_esm_shims();
import { jsx as jsx68, jsxs as jsxs41 } from "react/jsx-runtime";
var UsersIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs41(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 44, height: 40 },
  ...props,
  children: [
    /* @__PURE__ */ jsxs41("g", {
      clipPath: "url(#clip0_1613_12654)",
      children: [
        /* @__PURE__ */ jsx68("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.92893 26.9289C4.8043 25.0536 7.34783 24 10 24H22C24.6522 24 27.1957 25.0536 29.0711 26.9289C30.9464 28.8043 32 31.3478 32 34V38C32 39.1046 31.1046 40 30 40C28.8954 40 28 39.1046 28 38V34C28 32.4087 27.3679 30.8826 26.2426 29.7574C25.1174 28.6321 23.5913 28 22 28H10C8.4087 28 6.88258 28.6321 5.75736 29.7574C4.63214 30.8826 4 32.4087 4 34V38C4 39.1046 3.10457 40 2 40C0.89543 40 0 39.1046 0 38V34C0 31.3478 1.05357 28.8043 2.92893 26.9289Z",
          fill: color
        }),
        /* @__PURE__ */ jsx68("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16 4C12.6863 4 10 6.68629 10 10C10 13.3137 12.6863 16 16 16C19.3137 16 22 13.3137 22 10C22 6.68629 19.3137 4 16 4ZM6 10C6 4.47715 10.4772 0 16 0C21.5228 0 26 4.47715 26 10C26 15.5228 21.5228 20 16 20C10.4772 20 6 15.5228 6 10Z",
          fill: color
        }),
        /* @__PURE__ */ jsx68("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28.0625 1.76392C28.3365 0.69387 29.426 0.0485236 30.4961 0.3225C32.6471 0.873253 34.5537 2.12425 35.9152 3.87828C37.2767 5.6323 38.0157 7.78957 38.0157 10.01C38.0157 12.2304 37.2767 14.3877 35.9152 16.1417C34.5537 17.8957 32.6471 19.1467 30.4961 19.6975C29.426 19.9715 28.3365 19.3261 28.0625 18.2561C27.7885 17.186 28.4339 16.0965 29.5039 15.8225C30.7945 15.492 31.9385 14.7414 32.7554 13.689C33.5723 12.6366 34.0157 11.3423 34.0157 10.01C34.0157 8.67775 33.5723 7.38338 32.7554 6.33097C31.9385 5.27855 30.7945 4.52795 29.5039 4.1975C28.4339 3.92352 27.7885 2.83397 28.0625 1.76392ZM34.0635 25.76C34.3396 24.6905 35.4305 24.0474 36.5 24.3235C38.6453 24.8774 40.5459 26.1282 41.9034 27.8793C43.2609 29.6304 43.9983 31.7828 44 33.9985V34V38C44 39.1046 43.1046 40 42 40C40.8954 40 40 39.1046 40 38V34.0015C40 34.0011 40 34.0007 40 34.0004C40 34.0002 40 34.0005 40 34.0004C39.9987 32.6715 39.5562 31.3803 38.7421 30.33C37.9276 29.2793 36.7872 28.5288 35.5 28.1965C34.4305 27.9203 33.7874 26.8295 34.0635 25.76Z",
          fill: color
        })
      ]
    }),
    /* @__PURE__ */ jsx68("defs", {
      children: /* @__PURE__ */ jsx68("clipPath", {
        id: "clip0_1613_12654",
        children: /* @__PURE__ */ jsx68("rect", {
          width: 44,
          height: 40,
          fill: "white"
        })
      })
    })
  ]
});

// src/icons/v2/VerticalDotsIcon.tsx
init_esm_shims();
import { jsx as jsx69 } from "react/jsx-runtime";
var VerticalDotsIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsx69(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 40, height: 48 },
  ...props,
  children: /* @__PURE__ */ jsx69("path", {
    d: "M24.6 43.2C24.6 44.1494 24.3185 45.0774 23.7911 45.8667C23.2636 46.6561 22.514 47.2713 21.6369 47.6346C20.7598 47.9979 19.7947 48.093 18.8636 47.9078C17.9325 47.7226 17.0772 47.2654 16.4059 46.5941C15.7346 45.9228 15.2774 45.0675 15.0922 44.1364C14.907 43.2053 15.0021 42.2402 15.3654 41.3631C15.7287 40.486 16.3439 39.7364 17.1333 39.2089C17.9226 38.6815 18.8507 38.4 19.8 38.4C21.073 38.4 22.2939 38.9057 23.1941 39.8059C24.0943 40.7061 24.6 41.927 24.6 43.2ZM19.8 9.6C20.7494 9.6 21.6774 9.31849 22.4667 8.79106C23.2561 8.26363 23.8713 7.51397 24.2346 6.63688C24.5979 5.7598 24.693 4.79468 24.5078 3.86357C24.3226 2.93246 23.8654 2.07718 23.1941 1.40589C22.5228 0.734598 21.6675 0.277442 20.7364 0.0922328C19.8053 -0.0929762 18.8402 0.00207975 17.9631 0.36538C17.086 0.728681 16.3364 1.34391 15.8089 2.13327C15.2815 2.92262 15 3.85065 15 4.8C15 6.07304 15.5057 7.29394 16.4059 8.19411C17.3061 9.09429 18.527 9.6 19.8 9.6ZM19.8 19.2C18.8507 19.2 17.9226 19.4815 17.1333 20.0089C16.3439 20.5364 15.7287 21.286 15.3654 22.1631C15.0021 23.0402 14.907 24.0053 15.0922 24.9364C15.2774 25.8675 15.7346 26.7228 16.4059 27.3941C17.0772 28.0654 17.9325 28.5226 18.8636 28.7078C19.7947 28.893 20.7598 28.7979 21.6369 28.4346C22.514 28.0713 23.2636 27.4561 23.7911 26.6667C24.3185 25.8774 24.6 24.9494 24.6 24C24.6 22.727 24.0943 21.5061 23.1941 20.6059C22.2939 19.7057 21.073 19.2 19.8 19.2V19.2Z",
    fill: color
  })
});

// src/icons/v2/WalletIcon.tsx
init_esm_shims();
import { jsx as jsx70, jsxs as jsxs42 } from "react/jsx-runtime";
var WalletIcon = ({ color = "#F56B55", ...props }) => /* @__PURE__ */ jsxs42(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 45, height: 39 },
  ...props,
  children: [
    /* @__PURE__ */ jsx70("g", {
      clipPath: "url(#clip0_1613_12668)",
      children: /* @__PURE__ */ jsx70("path", {
        d: "M40.8594 0.40625H4.14062C3.16678 0.40625 2.23283 0.793107 1.54422 1.48172C0.855607 2.17033 0.46875 3.10428 0.46875 4.07812V7.33875C1.47372 6.42676 2.78355 5.92379 4.14062 5.92875V4.07812H40.8594V5.92875C42.2165 5.92379 43.5263 6.42676 44.5312 7.33875V4.07812C44.5312 3.10428 44.1444 2.17033 43.4558 1.48172C42.7672 0.793107 41.8332 0.40625 40.8594 0.40625ZM40.8594 7.75H4.14062C3.16678 7.75 2.23283 8.13686 1.54422 8.82547C0.855607 9.51408 0.46875 10.448 0.46875 11.4219V14.6825C1.47372 13.7705 2.78355 13.2675 4.14062 13.2725V11.4219H40.8594V13.2725C42.2165 13.2675 43.5263 13.7705 44.5312 14.6825V11.4219C44.5312 10.448 44.1444 9.51408 43.4558 8.82547C42.7672 8.13686 41.8332 7.75 40.8594 7.75ZM40.8594 15.0938H29.8438C29.7748 16.9768 28.964 18.7562 27.5883 20.0439C26.2126 21.3316 24.3835 22.023 22.5 21.9675C20.6165 22.023 18.7874 21.3316 17.4117 20.0439C16.036 18.7562 15.2252 16.9768 15.1562 15.0938H4.14062C3.16678 15.0938 2.23283 15.4806 1.54422 16.1692C0.855607 16.8578 0.46875 17.7918 0.46875 18.7656V34.9219C0.46875 35.8957 0.855607 36.8297 1.54422 37.5183C2.23283 38.2069 3.16678 38.5938 4.14062 38.5938H40.8594C41.8332 38.5938 42.7672 38.2069 43.4558 37.5183C44.1444 36.8297 44.5312 35.8957 44.5312 34.9219V18.7656C44.5312 17.7918 44.1444 16.8578 43.4558 16.1692C42.7672 15.4806 41.8332 15.0938 40.8594 15.0938ZM40.8594 34.9219H4.14062V18.7656H12.16C12.996 20.8157 14.4289 22.5673 16.2727 23.793C18.1165 25.0187 20.2861 25.662 22.5 25.6394C24.7148 25.666 26.8862 25.0243 28.7307 23.7981C30.5753 22.5719 32.0073 20.8181 32.84 18.7656H40.8594V34.9219Z",
        fill: color
      })
    }),
    /* @__PURE__ */ jsx70("defs", {
      children: /* @__PURE__ */ jsx70("clipPath", {
        id: "clip0_1613_12668",
        children: /* @__PURE__ */ jsx70("rect", {
          width: 45,
          height: 39,
          fill: "white"
        })
      })
    })
  ]
});

// src/icons/v2/XIcon.tsx
init_esm_shims();
import { jsx as jsx71 } from "react/jsx-runtime";
var XIcon = ({ color = "#B3B3B3", ...props }) => /* @__PURE__ */ jsx71(IconSvg, {
  fill: "none",
  viewBox: { minX: 0, minY: 0, width: 14, height: 14 },
  ...props,
  children: /* @__PURE__ */ jsx71("path", {
    d: "M14 1.41 12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7 14 1.41Z",
    fill: color
  })
});

// src/icons/IconV3.tsx
init_esm_shims();
import { useMantineTheme } from "@mantine/core";
import { jsx as jsx72 } from "react/jsx-runtime";
var IconV3 = ({ icon, size = 24, color, className, style }) => {
  const theme = useMantineTheme();
  const finalColor = color || theme.black;
  return /* @__PURE__ */ jsx72("span", {
    className: `material-symbols-rounded ${className || ""}`,
    style: {
      fontSize: size,
      color: finalColor,
      display: "inline-block",
      lineHeight: 1,
      ...style
    },
    children: icon
  });
};

// src/components/RpiFlex.tsx
init_esm_shims();
import { Box, createStyles } from "@mantine/core";
import { jsx as jsx73 } from "react/jsx-runtime";
var useFlexStyles = createStyles(
  (_, { direction, justify, align, gap, wrap, flex, fullWidth }) => {
    return {
      root: {
        display: "flex",
        flexDirection: direction,
        justifyContent: justify,
        alignItems: align,
        gap,
        flexWrap: wrap,
        flex,
        ...fullWidth && { width: "100%" }
      }
    };
  }
);
var Flex = ({ direction, justify, align, gap, fullWidth, className, ...props }) => {
  const { classes, cx } = useFlexStyles({ direction, justify, align, gap, fullWidth });
  return /* @__PURE__ */ jsx73(Box, {
    className: cx(classes.root, className),
    ...props
  });
};
Flex.Row = (props) => /* @__PURE__ */ jsx73(Flex, {
  direction: "row",
  ...props
});
Flex.Column = (props) => /* @__PURE__ */ jsx73(Flex, {
  direction: "column",
  ...props
});

// src/components/RpiGrid.tsx
init_esm_shims();
import { Box as Box2, createStyles as createStyles2 } from "@mantine/core";
import { jsx as jsx74 } from "react/jsx-runtime";
var useGridStyles = createStyles2((_, props) => {
  return {
    root: {
      display: props.inline ? "inline-grid" : "grid",
      ...props.fullWidth && { width: "100%" },
      gridTemplateColumns: props.columns,
      gridTemplateRows: props.rows,
      gridTemplate: props.template,
      gap: props.gap,
      columnGap: props.columnGap,
      rowGap: props.rowGap,
      justifyItems: props.justifyItems,
      alignItems: props.alignItems,
      placeItems: props.placeItems,
      justifyContent: props.justify,
      alignContent: props.align,
      placeContent: props.place
    }
  };
});
var Grid = ({
  className,
  sx,
  children,
  m,
  mb,
  mt,
  ml,
  mr,
  mx,
  my,
  p,
  pb,
  pt,
  pl,
  pr,
  px,
  py,
  onClick,
  ...props
}) => {
  const { classes, cx } = useGridStyles(props);
  return /* @__PURE__ */ jsx74(Box2, {
    className: cx(classes.root, className),
    sx,
    children,
    ...{ m, mb, mt, ml, mr, mx, my, p, pb, pt, pl, pr, px, py, onClick }
  });
};

// src/components/RpiDivider.tsx
init_esm_shims();
import { Box as Box3 } from "@mantine/core";
import React2 from "react";
import { jsx as jsx75, jsxs as jsxs43 } from "react/jsx-runtime";
var RpiDivider = ({ label }) => {
  return /* @__PURE__ */ jsxs43(Flex.Row, {
    gap: 16,
    align: "center",
    sx: (theme) => ({
      width: "100%",
      fontSize: 16,
      lineHeight: "100%",
      color: theme.colors.text[4]
    }),
    children: [
      /* @__PURE__ */ jsx75(Box3, {
        sx: { flex: 1, height: 1, background: "currentColor" }
      }),
      /* @__PURE__ */ jsx75(Box3, {
        sx: { height: 16, lineHeight: "75%", userSelect: "none" },
        children: label
      }),
      /* @__PURE__ */ jsx75(Box3, {
        sx: { flex: 1, height: 1, background: "currentColor" }
      })
    ]
  });
};
var RpiSimpleDivider = ({ margin = 32 }) => {
  return React2.useMemo(
    () => /* @__PURE__ */ jsx75(Box3, {
      sx: (theme) => ({
        width: "100%",
        height: 1,
        background: theme.colors.calm[5],
        marginTop: margin,
        marginBottom: margin
      })
    }),
    [margin]
  );
};

// src/components/tyopography/RpiTypography.tsx
init_esm_shims();
import { Box as Box4, createStyles as createStyles3 } from "@mantine/core";
import { jsx as jsx76 } from "react/jsx-runtime";
var useRpiTextStyles = createStyles3(
  (theme, { type, weight, ellipsis, color }) => {
    return {
      root: {
        fontWeight: theme.other.fontWeights[weight],
        ...theme.other.fontTypes[type],
        ...ellipsis && {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        },
        color: typeof color === "function" ? color(theme) : color
      }
    };
  }
);
function RpiText({
  type = "p2",
  weight = "regular",
  ellipsis,
  color,
  className,
  ...props
}) {
  const { classes, cx } = useRpiTextStyles({ type, weight, ellipsis, color });
  return /* @__PURE__ */ jsx76(Box4, {
    className: cx(classes.root, className),
    ...props
  });
}

// src/components/buttons/RpiButton.tsx
init_esm_shims();
import { createStyles as createStyles4, Loader, UnstyledButton } from "@mantine/core";
import React3 from "react";
import { jsx as jsx77, jsxs as jsxs44 } from "react/jsx-runtime";
var useRpiButtonStyles = createStyles4((theme, { variant, size, shadow, width }) => {
  const variantCss = {
    spark: {
      color: theme.colors.sky[5],
      background: theme.colors.spark[5],
      borderColor: theme.colors.spark[5],
      "&:hover": {
        color: theme.colors.spark[5],
        background: theme.colors.sky[5],
        borderColor: theme.colors.spark[5]
      },
      "&:disabled": {
        color: theme.colors.sky[5],
        background: theme.colors.spark[3],
        borderColor: theme.colors.spark[3]
      }
    },
    "spark-outline": {
      color: theme.colors.spark[5],
      background: theme.colors.sky[5],
      borderColor: theme.colors.spark[5],
      "&:hover": {
        color: theme.colors.sky[5],
        background: theme.colors.spark[5],
        borderColor: theme.colors.spark[5]
      },
      "&:disabled": {
        color: theme.colors.spark[3],
        background: theme.colors.sky[5],
        borderColor: theme.colors.spark[3]
      }
    },
    "spark-ghost": {
      color: theme.colors.spark[5],
      background: "transparent",
      borderColor: "transparent",
      "&:disabled": {
        color: theme.colors.spark[3]
      }
    },
    mellow: {
      color: theme.colors.brand[5],
      background: theme.colors.mellow[5],
      borderColor: theme.colors.mellow[5],
      "&:hover": {
        color: theme.colors.mellow[5],
        background: theme.colors.brand[5],
        borderColor: theme.colors.brand[5]
      },
      "&:disabled": {
        color: theme.colors.brand[4],
        background: theme.colors.brand[3],
        borderColor: theme.colors.brand[3]
      }
    },
    "brand-outline": {
      color: theme.colors.brand[5],
      background: theme.colors.sky[3],
      borderColor: theme.colors.brand[5],
      "&:hover": {
        color: theme.colors.sky[5],
        background: theme.colors.brand[5],
        borderColor: theme.colors.brand[5]
      },
      "&:disabled": {
        color: theme.colors.brand[3],
        background: theme.colors.sky[5],
        borderColor: theme.colors.brand[3]
      }
    },
    brand: {
      color: theme.colors.sky[5],
      background: theme.colors.brand[5],
      "&:hover": {
        background: theme.colors.brand[4]
      },
      "&:disabled": {
        color: theme.colors.text[3],
        background: theme.colors.sky[8]
      }
    }
  };
  let buttonWidth;
  if (width) {
    if (width === "full")
      buttonWidth = "100%";
    else if (width === "fit")
      buttonWidth = "fit-content";
    else
      buttonWidth = width;
  } else {
    buttonWidth = size === "large" ? 410 : 132;
  }
  return {
    root: {
      ...theme.other.fontTypes.button,
      fontWeight: theme.other.fontWeights.bold,
      boxSizing: "border-box",
      lineHeight: "17px",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      paddingTop: 14,
      paddingBottom: 14,
      paddingLeft: size === "large" ? 28 : 22,
      paddingRight: size === "large" ? 28 : 22,
      width: buttonWidth,
      height: 56,
      outline: "none !important",
      textAlign: "center",
      userSelect: "none",
      borderRadius: "32px",
      borderWidth: 2,
      borderStyle: "solid",
      transition: "color 250ms, background 250ms, border 250ms",
      ...shadow && { boxShadow: theme.other.boxShadows.button },
      "&:hover": {
        ...shadow && { boxShadow: theme.other.boxShadows.buttonHover }
      },
      "&:active": {
        transform: "translateY(1px)"
      },
      "&:disabled": {
        cursor: "default",
        boxShadow: "none",
        transform: "none"
      }
    },
    variant: variantCss[variant]
  };
});
function RpiButton({
  variant = "spark",
  size = "small",
  shadow,
  icon,
  width,
  className,
  children,
  isLoading,
  trailingIcon,
  ...props
}) {
  const { classes, cx } = useRpiButtonStyles({ variant, size, shadow: !!shadow, width });
  const childrenMemo = React3.useMemo(() => {
    const updatedChildren = isLoading ? /* @__PURE__ */ jsxs44(Flex.Row, {
      align: "center",
      gap: 8,
      children: [
        /* @__PURE__ */ jsx77(Loader, {
          size: 18,
          color: "currentColor"
        }),
        /* @__PURE__ */ jsx77("div", {
          children
        })
      ]
    }) : children;
    if (!trailingIcon && !icon)
      return updatedChildren;
    return /* @__PURE__ */ jsxs44(Flex.Row, {
      align: "center",
      justify: width === "full" ? "center" : "space-between",
      gap: 10,
      fullWidth: true,
      children: [
        icon && /* @__PURE__ */ jsx77("div", {
          children: React3.createElement(icon, {
            width: 14,
            height: 14,
            color: "currentColor"
          })
        }),
        updatedChildren,
        trailingIcon && /* @__PURE__ */ jsx77("div", {
          children: React3.createElement(typeof trailingIcon === "boolean" ? IconV2_exports.Arrow : trailingIcon, {
            width: 14,
            height: 14,
            color: "currentColor"
          })
        })
      ]
    });
  }, [children, icon, isLoading, trailingIcon, width]);
  return /* @__PURE__ */ jsx77(UnstyledButton, {
    className: cx(classes.root, classes.variant, className),
    children: childrenMemo,
    ...props,
    ...isLoading && { disabled: true }
  });
}

// src/components/buttons/RpiCheckbox.tsx
init_esm_shims();
import { Checkbox, createStyles as createStyles6, Stack } from "@mantine/core";
import React4 from "react";
import { Minus } from "tabler-icons-react";

// src/components/RpiAlert.tsx
init_esm_shims();
import { Alert, createStyles as createStyles5, useMantineTheme as useMantineTheme2 } from "@mantine/core";
import { jsx as jsx78, jsxs as jsxs45 } from "react/jsx-runtime";
var useRpiAlertStyles = createStyles5((theme) => ({
  root: {
    background: theme.other.semanticColors.alertDangerBackground,
    color: theme.other.semanticColors.textBold,
    borderRadius: theme.radius.sm,
    padding: theme.spacing.xs,
    "--line-height": "20px"
  },
  message: {
    color: "unset",
    fontSize: theme.fontSizes.sm,
    lineHeight: "var(--line-height)"
  },
  errorContainer: {
    display: "flex",
    gap: 4,
    alignItems: "start"
  },
  iconContainer: {
    height: "var(--line-height)",
    display: "flex",
    alignItems: "center"
  }
}));
function RpiAlert({ showIcon = true, children, ...props }) {
  const { classes } = useRpiAlertStyles();
  const theme = useMantineTheme2();
  const content = showIcon ? /* @__PURE__ */ jsxs45("div", {
    className: classes.errorContainer,
    children: [
      /* @__PURE__ */ jsx78("div", {
        className: classes.iconContainer,
        children: /* @__PURE__ */ jsx78(IconV3, {
          icon: "error",
          size: 16,
          color: theme.other.semanticColors.alertDangerBorder
        })
      }),
      /* @__PURE__ */ jsx78("div", {
        className: classes.message,
        children
      })
    ]
  }) : children;
  return /* @__PURE__ */ jsx78(Alert, {
    classNames: classes,
    ...props,
    children: content
  });
}

// src/components/buttons/RpiCheckbox.tsx
import { Fragment, jsx as jsx79, jsxs as jsxs46 } from "react/jsx-runtime";
var checboxSizes = {
  xs: 16,
  sm: 18,
  md: 20,
  lg: 22,
  xl: 24
};
var radioSizes = {
  xs: 8,
  sm: 10,
  md: 12,
  lg: 14,
  xl: 16
};
var useRpiCheckboxStyles = createStyles6((theme, { size: checboxSize, variant, colors: defaultColors }) => {
  const colors = defaultColors || {
    primary: theme.colors.brand[5],
    icon: theme.colors.sky[5],
    disabledPrimary: theme.colors.brand[3],
    disabledLabel: theme.colors.brand[4]
  };
  switch (variant) {
    case "default": {
      const size = checboxSizes[checboxSize];
      return {
        root: {},
        body: {
          alignItems: "flex-start",
          color: colors.primary
        },
        inner: {
          width: size,
          height: size
        },
        input: {
          width: size,
          height: size,
          cursor: "pointer",
          backgroundColor: "transparent",
          borderColor: colors.primary,
          borderWidth: 1,
          "&:checked": {
            backgroundColor: colors.primary,
            borderColor: colors.primary,
            "& + svg": {
              color: `${colors.icon} !important`
            },
            "&:disabled": {
              backgroundColor: colors.disabledPrimary,
              borderColor: colors.disabledPrimary
            }
          },
          "&:disabled": {
            backgroundColor: "transparent",
            borderColor: colors.disabledPrimary,
            "& + svg": {
              color: `${colors.disabledPrimary} !important`
            }
          }
        },
        icon: {
          width: size * 2 / 3,
          height: size * 2 / 3,
          color: colors.primary
        },
        label: {
          ...theme.other.fontTypes.label,
          fontWeight: theme.other.fontWeights.regular,
          color: colors.primary,
          "&[data-disabled]": {
            color: `${colors.disabledLabel} !important`
          }
        }
      };
    }
    case "radio": {
      const size = radioSizes[checboxSize];
      return {
        root: {
          paddingLeft: 5
        },
        body: {
          alignItems: "center",
          color: colors.primary
        },
        inner: {
          width: size,
          height: size
        },
        input: {
          width: size,
          height: size,
          cursor: "pointer",
          backgroundColor: "transparent",
          borderColor: colors.primary,
          borderRadius: "50%",
          border: "none",
          outline: `1px solid ${colors.primary} !important`,
          outlineOffset: "4px !important",
          "&:checked": {
            backgroundColor: colors.primary,
            outline: `1px solid ${colors.primary} !important`,
            outlineOffset: "4px !important",
            border: "none",
            "&:disabled": {
              backgroundColor: colors.disabledPrimary,
              outline: `1px solid ${colors.disabledPrimary} !important`,
              outlineOffset: "4px !important",
              border: "none"
            }
          },
          "&:disabled": {
            backgroundColor: "transparent",
            outline: `1px solid ${colors.disabledPrimary} !important`,
            outlineOffset: "4px !important",
            border: "none"
          },
          "&:active, &:focus": {
            outline: `1px solid ${colors.disabledPrimary} !important`,
            outlineOffset: "4px !important",
            border: "none"
          }
        },
        icon: {
          width: size * 2 / 3,
          height: size * 2 / 3,
          color: colors.icon
        },
        label: {
          ...theme.other.fontTypes.label,
          fontWeight: theme.other.fontWeights.regular,
          color: colors.primary,
          paddingLeft: 17,
          "&[data-disabled]": {
            color: `${colors.disabledLabel} !important`
          }
        }
      };
    }
  }
});
var RpiCheckbox = React4.forwardRef(
  ({ variant = "default", colors, ...props }, ref) => {
    const { classes } = useRpiCheckboxStyles({ size: props.size || "md", variant, colors });
    const CheckboxIcon2 = ({ indeterminate, ...props2 }) => {
      switch (variant) {
        case "default":
          return indeterminate ? /* @__PURE__ */ jsx79(Minus, {
            color: "currentColor",
            ...props2
          }) : /* @__PURE__ */ jsx79(IconV2_exports.Checkbox, {
            color: "currentColor",
            ...props2
          });
        default:
          return /* @__PURE__ */ jsx79(Fragment, {});
      }
    };
    return /* @__PURE__ */ jsx79(Checkbox, {
      ref,
      classNames: classes,
      icon: CheckboxIcon2,
      radius: 4,
      ...props
    });
  }
);
var useRpiCheckboxV2Styles = createStyles6((theme) => ({
  root: {
    "--line-height": "22px",
    "--font-weight": theme.other.fontWeights.normal,
    "&:has(input:checked)": {
      "--font-weight": theme.other.fontWeights.bold
    }
  },
  body: {
    gap: theme.spacing.sm
  },
  inner: {
    width: "unset",
    height: "var(--line-height)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  label: {
    fontSize: theme.fontSizes.md,
    lineHeight: "var(--line-height)",
    fontWeight: "var(--font-weight)",
    padding: "unset"
  },
  input: {
    width: 18,
    height: 18,
    "&,&:checked": {
      border: `2px solid ${theme.other.semanticColors.icon.bold}`
    },
    "&:checked": {
      background: theme.other.semanticColors.icon.bold
    },
    "&:focus": {
      outline: `2px solid ${theme.other.semanticColors.borderFocus}`
    }
  }
}));
function RpiCheckboxV2({ error, ...props }) {
  const { classes } = useRpiCheckboxV2Styles();
  return /* @__PURE__ */ jsxs46(Stack, {
    sx: (theme) => ({ gap: theme.spacing.sm }),
    children: [
      /* @__PURE__ */ jsx79(Checkbox, {
        classNames: classes,
        ...props
      }),
      error && /* @__PURE__ */ jsx79(RpiAlert, {
        children: error
      })
    ]
  });
}

// src/components/buttons/RpiIconButton.tsx
init_esm_shims();
import { createStyles as createStyles7, UnstyledButton as UnstyledButton2 } from "@mantine/core";
import React5 from "react";
import { jsx as jsx80 } from "react/jsx-runtime";
var useRpiIconButtonStyles = createStyles7(
  (_, { disableAnimation }) => {
    return {
      root: {
        "&:disabled": {
          cursor: "default !important"
        },
        ...!disableAnimation && {
          "&:active": {
            transform: "translateY(1px)"
          },
          "&:disabled": {
            transform: "none !important"
          }
        }
      }
    };
  }
);
function RpiIconButton({
  icon,
  iconProps = {},
  color,
  size,
  width,
  height,
  disableAnimation,
  className,
  customRef,
  ...props
}) {
  const { classes, cx } = useRpiIconButtonStyles({ disableAnimation });
  return /* @__PURE__ */ jsx80(UnstyledButton2, {
    ref: customRef,
    className: cx(classes.root, className),
    children: React5.createElement(icon, { ...iconProps, color, size, width, height }),
    ...props
  });
}

// src/components/buttons/RpiLink.tsx
init_esm_shims();
import { Anchor, createStyles as createStyles8 } from "@mantine/core";
import { jsx as jsx81 } from "react/jsx-runtime";
var useRpiLinkStyles = createStyles8((theme, { variant }) => {
  switch (variant) {
    case "underline":
      return {
        root: {
          ...theme.other.fontTypes.p3,
          fontWeight: theme.other.fontWeights.regular,
          color: theme.colors.brand[5],
          textDecoration: "underline"
        }
      };
    case "inherit":
      return {
        root: {
          fontFamily: "inherit",
          fontWeight: "inherit",
          fontSize: "inherit",
          color: "inherit",
          lineHeight: "inherit",
          textDecoration: "none",
          "&:hover": {
            textDecoration: "underline"
          }
        }
      };
    case "unstyled":
      return {
        root: { color: "inherit" }
      };
    default:
      return {
        root: {
          ...theme.other.fontTypes.link,
          fontWeight: theme.other.fontWeights.bold,
          color: theme.colors.calm[5],
          "&:hover": {
            textDecoration: "underline"
          }
        }
      };
  }
});
function RpiLink({
  variant = "default",
  className,
  ...props
}) {
  const { classes, cx } = useRpiLinkStyles({ variant });
  return /* @__PURE__ */ jsx81(Anchor, {
    unstyled: true,
    className: cx(classes.root, className),
    ...props
  });
}

// src/components/inputs/RpiDropdown.tsx
init_esm_shims();
import { createStyles as createStyles9, Select } from "@mantine/core";
import React6 from "react";
import { jsx as jsx82 } from "react/jsx-runtime";
var useRpiDropdownStyles = createStyles9(
  (theme, { fullWidth }) => ({
    root: {
      width: fullWidth ? "100%" : 269
    },
    input: {
      ...theme.other.fontTypes.p3,
      fontWeight: theme.other.fontWeights.regular,
      lineHeight: "1rem",
      color: `${theme.colors.brand[5]} !important`,
      padding: "16px 24px",
      paddingRight: 36,
      borderRadius: "25px",
      outline: "none",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.colors.calm[5],
      height: 50,
      textOverflow: "ellipsis !important",
      "&::placeholder": {
        color: `${theme.colors.brand[5]} !important`,
        fontWeight: theme.other.fontWeights.light,
        opacity: 1
      },
      "&:focus, &:active": {
        borderColor: theme.colors.amethyst[5]
      }
    },
    rightSection: {
      color: theme.colors.brand[5],
      pointerEvents: "none",
      paddingRight: 24
    },
    dropdown: {
      borderRadius: "12px",
      marginTop: -5,
      border: "none"
    },
    itemsWrapper: {
      padding: 3,
      gap: 3
    },
    item: {
      ...theme.other.fontTypes.button,
      lineHeight: "16px",
      color: theme.colors.brand[5],
      minHeight: 32,
      height: "fit-content",
      display: "flex",
      alignItems: "center",
      borderRadius: 8,
      padding: "7.5px 24px",
      "&[data-selected]": {
        "&, &:hover": {
          color: theme.colors.brand[5],
          backgroundColor: theme.colors.calm[4]
        }
      },
      "&[data-hovered]": {
        color: theme.colors.brand[5],
        backgroundColor: theme.colors.calm[4]
      }
    },
    error: {
      ...theme.other.fontTypes.label,
      fontWeight: theme.other.fontWeights.regular,
      color: theme.colors.spark[6],
      marginLeft: 26,
      marginRight: 26,
      lineHeight: "unset",
      marginTop: 6
    },
    invalid: {
      borderColor: theme.colors.spark[6]
    }
  })
);
var RpiDropdown = React6.forwardRef(
  ({ fullWidth, ...props }, ref) => {
    const { classes } = useRpiDropdownStyles({ fullWidth });
    return /* @__PURE__ */ jsx82(Select, {
      ref,
      classNames: classes,
      rightSection: /* @__PURE__ */ jsx82(IconV2_exports.ArrowDown, {
        width: 10,
        height: 16,
        color: "currentColor"
      }),
      ...props
    });
  }
);

// src/components/inputs/RpiInput.tsx
init_esm_shims();
import { Box as Box5, createStyles as createStyles10, useMantineTheme as useMantineTheme3 } from "@mantine/core";

// ../../node_modules/@mantine/hooks/esm/index.js
init_esm_shims();

// ../../node_modules/@mantine/hooks/esm/use-merged-ref/use-merged-ref.js
init_esm_shims();
import { useCallback } from "react";

// ../../node_modules/@mantine/hooks/esm/utils/assign-ref/assign-ref.js
init_esm_shims();
function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (typeof ref === "object" && ref !== null && "current" in ref) {
    ref.current = value;
  }
}

// ../../node_modules/@mantine/hooks/esm/use-merged-ref/use-merged-ref.js
function mergeRefs(...refs) {
  return (node) => {
    refs.forEach((ref) => assignRef(ref, node));
  };
}
function useMergedRef(...refs) {
  return useCallback(mergeRefs(...refs), refs);
}

// src/components/inputs/RpiInput.tsx
import React7 from "react";
import { jsx as jsx83, jsxs as jsxs47 } from "react/jsx-runtime";
var useRpiInputStyles = createStyles10(
  (theme, { isError, hasIcon, is = {} }) => {
    return {
      root: {},
      label: {
        ...theme.other.fontTypes.p3,
        fontWeight: theme.other.fontWeights.regular,
        color: theme.colors.brand[5],
        marginLeft: 26
      },
      wrapper: {
        position: "relative",
        borderRadius: 32,
        width: "100%",
        ...is.textarea ? { height: "fit-content", minHeight: 52 } : { height: 52 },
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: isError ? theme.colors.spark[6] : theme.colors.calm[5],
        backgroundColor: theme.colors.sky[5],
        "&:focus-within": {
          borderColor: isError ? theme.colors.spark[6] : theme.colors.amethyst[5]
        }
      },
      input: {
        ...theme.other.fontTypes.p3,
        fontWeight: theme.other.fontWeights.regular,
        color: theme.colors.brand[5],
        outline: "none",
        background: "transparent",
        border: "none",
        ...is.textarea ? { margin: "14px 24px", padding: 0, resize: "none", height: "auto" } : { padding: "16px 24px", margin: 0, height: "100%" },
        width: "100%",
        "&:-webkit-autofill, &:-webkit-autofill:focus": {
          borderRadius: "inherit"
        },
        "&::placeholder": {
          color: theme.colors.brand[5],
          fontWeight: theme.other.fontWeights.light
        },
        ...hasIcon && {
          paddingLeft: 8
        }
      },
      error: {
        ...theme.other.fontTypes.label,
        fontWeight: theme.other.fontWeights.regular,
        color: theme.colors.spark[6],
        marginLeft: 26,
        marginRight: 26
      },
      action: {
        color: theme.colors.brand[5],
        paddingRight: 24,
        flexShrink: 0,
        "& svg": {
          color: theme.colors.brand[5]
        }
      },
      icon: {
        paddingLeft: 24
      }
    };
  }
);
var RpiTextInput = React7.forwardRef(
  ({
    label,
    error,
    fullWidth,
    classNames,
    styles: initialStyles,
    icon,
    action,
    ...inputProps
  }, ref) => {
    const theme = useMantineTheme3();
    const { classes, cx } = useRpiInputStyles({ isError: !!error, hasIcon: !!icon });
    const styles = React7.useMemo(() => {
      if (!initialStyles)
        return {};
      return typeof initialStyles === "function" ? initialStyles(theme) : initialStyles;
    }, [initialStyles]);
    const inputRef = React7.useRef();
    const refs = useMergedRef(inputRef, ref);
    return /* @__PURE__ */ jsxs47(Flex.Column, {
      gap: 8,
      fullWidth,
      className: cx(classes.root, classNames == null ? void 0 : classNames.root),
      sx: styles.root,
      onClick: () => {
        var _a;
        return (_a = inputRef.current) == null ? void 0 : _a.focus();
      },
      children: [
        label && /* @__PURE__ */ jsx83(Box5, {
          component: "label",
          className: cx(classes.label, classNames == null ? void 0 : classNames.label),
          sx: styles.label,
          children: label
        }),
        /* @__PURE__ */ jsxs47(Flex.Row, {
          className: cx(classes.wrapper, classNames == null ? void 0 : classNames.wrapper),
          sx: styles.wrapper,
          align: "center",
          children: [
            icon && /* @__PURE__ */ jsx83(Box5, {
              className: cx(classes.icon, classNames == null ? void 0 : classNames.icon),
              sx: styles.icon,
              children: React7.createElement(icon, { size: 18 })
            }),
            /* @__PURE__ */ jsx83(Box5, {
              ...inputProps,
              component: "input",
              ref: refs,
              type: "text",
              className: cx(classes.input, classNames == null ? void 0 : classNames.input),
              sx: styles.input
            }),
            action && /* @__PURE__ */ jsx83(Flex.Row, {
              align: "center",
              className: cx(classes.action, classNames == null ? void 0 : classNames.action),
              sx: styles.action,
              children: action
            })
          ]
        }),
        error && /* @__PURE__ */ jsx83(Box5, {
          className: cx(classes.error, classNames == null ? void 0 : classNames.error),
          sx: styles == null ? void 0 : styles.error,
          children: error
        })
      ]
    });
  }
);
var RpiPasswordInput = React7.forwardRef(
  ({
    label,
    error,
    fullWidth,
    classNames,
    styles: initialStyles,
    icon,
    ...inputProps
  }, ref) => {
    const theme = useMantineTheme3();
    const { classes, cx } = useRpiInputStyles({ isError: !!error, hasIcon: !!icon });
    const [showPassword, setShowPassword] = React7.useState(false);
    const [capsLock, setCapsLock] = React7.useState(false);
    const styles = React7.useMemo(() => {
      if (!initialStyles)
        return {};
      return typeof initialStyles === "function" ? initialStyles(theme) : initialStyles;
    }, [initialStyles]);
    const inputRef = React7.useRef();
    const refs = useMergedRef(inputRef, ref);
    return /* @__PURE__ */ jsxs47(Flex.Column, {
      gap: 8,
      fullWidth,
      className: cx(classes.root, classNames == null ? void 0 : classNames.root),
      sx: styles.root,
      onClick: () => {
        var _a;
        return (_a = inputRef.current) == null ? void 0 : _a.focus();
      },
      children: [
        label && /* @__PURE__ */ jsx83(Box5, {
          component: "label",
          className: cx(classes.label, classNames == null ? void 0 : classNames.label),
          sx: styles.label,
          children: label
        }),
        /* @__PURE__ */ jsxs47(Flex.Row, {
          className: cx(classes.wrapper, classNames == null ? void 0 : classNames.wrapper),
          sx: styles.wrapper,
          align: "center",
          children: [
            icon && /* @__PURE__ */ jsx83(Box5, {
              className: cx(classes.icon, classNames == null ? void 0 : classNames.icon),
              sx: styles.icon,
              children: React7.createElement(icon, { size: 18 })
            }),
            /* @__PURE__ */ jsx83(Box5, {
              ...inputProps,
              component: "input",
              ref: refs,
              type: showPassword ? "text" : "password",
              className: cx(classes.input, classNames == null ? void 0 : classNames.input),
              sx: styles.input,
              onKeyDown: (e) => {
                inputProps.onKeyDown && inputProps.onKeyDown(e);
                setCapsLock(!!e.getModifierState("CapsLock"));
              }
            }),
            /* @__PURE__ */ jsx83(Flex.Row, {
              align: "center",
              className: cx(classes.action, classNames == null ? void 0 : classNames.action),
              sx: styles == null ? void 0 : styles.action,
              children: /* @__PURE__ */ jsx83(RpiIconButton, {
                icon: showPassword ? IconV2_exports.Eye : IconV2_exports.EyeOff,
                size: 16,
                color: "currentColor",
                onClick: () => setShowPassword((showPassword2) => !showPassword2)
              })
            })
          ]
        }),
        (error || capsLock) && /* @__PURE__ */ jsx83(Box5, {
          className: cx(classes.error, classNames == null ? void 0 : classNames.error),
          sx: styles == null ? void 0 : styles.error,
          children: error ? error : /* @__PURE__ */ jsxs47(Flex.Row, {
            align: "center",
            gap: 4,
            children: [
              /* @__PURE__ */ jsx83(IconV2_exports.ErrorSolid, {
                size: 14,
                color: "currentColor"
              }),
              "Caps Lock is on"
            ]
          })
        })
      ]
    });
  }
);
var RpiMultilineInput = React7.forwardRef(
  ({
    label,
    error,
    fullWidth,
    classNames,
    styles: initialStyles,
    icon,
    action,
    ...inputProps
  }, ref) => {
    const theme = useMantineTheme3();
    const { classes, cx } = useRpiInputStyles({ isError: !!error, hasIcon: !!icon, is: { textarea: true } });
    const styles = React7.useMemo(() => {
      if (!initialStyles)
        return {};
      return typeof initialStyles === "function" ? initialStyles(theme) : initialStyles;
    }, [initialStyles]);
    const inputRef = React7.useRef();
    const refs = useMergedRef(inputRef, ref);
    return /* @__PURE__ */ jsxs47(Flex.Column, {
      gap: 8,
      fullWidth,
      className: cx(classes.root, classNames == null ? void 0 : classNames.root),
      sx: styles.root,
      onClick: () => {
        var _a;
        return (_a = inputRef.current) == null ? void 0 : _a.focus();
      },
      children: [
        label && /* @__PURE__ */ jsx83(Box5, {
          component: "label",
          className: cx(classes.label, classNames == null ? void 0 : classNames.label),
          sx: styles.label,
          children: label
        }),
        /* @__PURE__ */ jsxs47(Flex.Row, {
          className: cx(classes.wrapper, classNames == null ? void 0 : classNames.wrapper),
          sx: styles.wrapper,
          align: "center",
          children: [
            icon && /* @__PURE__ */ jsx83(Box5, {
              className: cx(classes.icon, classNames == null ? void 0 : classNames.icon),
              sx: styles.icon,
              children: React7.createElement(icon, { size: 18 })
            }),
            /* @__PURE__ */ jsx83(Box5, {
              rows: 1,
              ...inputProps,
              component: "textarea",
              ref: refs,
              className: cx(classes.input, classNames == null ? void 0 : classNames.input),
              sx: styles.input
            }),
            action && /* @__PURE__ */ jsx83(Flex.Row, {
              align: "center",
              className: cx(classes.action, classNames == null ? void 0 : classNames.action),
              sx: styles.action,
              children: action
            })
          ]
        }),
        error && /* @__PURE__ */ jsx83(Box5, {
          className: cx(classes.error, classNames == null ? void 0 : classNames.error),
          sx: styles == null ? void 0 : styles.error,
          children: error
        })
      ]
    });
  }
);

// src/components/inputs/RpiDrawerInput.tsx
init_esm_shims();
import { Box as Box7, createStyles as createStyles11, useMantineTheme as useMantineTheme5 } from "@mantine/core";
import React9 from "react";

// src/components/inputs/drawers/RpiDrawerSelectInput.tsx
init_esm_shims();
import { Box as Box6, Loader as Loader2, Popover, useMantineTheme as useMantineTheme4 } from "@mantine/core";
import React8 from "react";
import { Fragment as Fragment2, jsx as jsx84, jsxs as jsxs48 } from "react/jsx-runtime";
var RpiDrawerSelectInput = React8.forwardRef(
  ({
    label,
    error,
    fullWidth,
    classNames,
    styles: initialStyles,
    data,
    onChange,
    value,
    searchable,
    onSearch,
    isLoading,
    ...inputProps
  }, ref) => {
    const theme = useMantineTheme4();
    const [opened, setOpened] = React8.useState(false);
    const [searchValue, setSearchValue] = React8.useState("");
    const selected = React8.useMemo(() => data.find((e) => e.value === value), [data, value]);
    const { classes, cx } = useRpiDrawerInputStyles({
      isError: !!error,
      isDisabled: inputProps.disabled,
      isEmpty: opened ? false : void 0
    });
    const styles = React8.useMemo(() => {
      if (!initialStyles)
        return {};
      return typeof initialStyles === "function" ? initialStyles(theme) : initialStyles;
    }, [initialStyles]);
    const inputRef = React8.useRef();
    const refs = useMergedRef(inputRef, ref);
    React8.useEffect(() => {
      if (selected) {
        setSearchValue(selected.label);
      }
    }, [selected]);
    const handleSetSelected = (element, updateSearch = true) => {
      if (updateSearch) {
        setSearchValue((element == null ? void 0 : element.label) || "");
      }
      onChange && onChange(element == null ? void 0 : element.value, element);
    };
    const handleSetSearchValue = (value2) => {
      if (selected)
        handleSetSelected(void 0, false);
      setSearchValue(value2);
      onSearch && onSearch(value2);
    };
    React8.useEffect(() => {
      if (searchable && !opened) {
        if (searchValue && (!selected || selected.label !== searchValue)) {
          handleSetSearchValue("");
        }
      }
    }, [opened, searchable, selected, searchValue, handleSetSearchValue]);
    return /* @__PURE__ */ jsxs48(Flex.Column, {
      gap: 8,
      fullWidth,
      children: [
        /* @__PURE__ */ jsxs48(Popover, {
          opened,
          onChange: setOpened,
          offset: 0,
          width: "target",
          position: "bottom",
          styles: (theme2) => ({
            dropdown: {
              borderRadius: 8,
              border: "none",
              boxShadow: theme2.other.boxShadows.large,
              padding: 3
            }
          }),
          children: [
            /* @__PURE__ */ jsx84(Popover.Target, {
              children: /* @__PURE__ */ jsx84(Box6, {
                className: cx(classes.root, classNames == null ? void 0 : classNames.root),
                sx: styles.root,
                onClick: () => {
                  var _a;
                  if (!opened)
                    setOpened(!opened);
                  (_a = inputRef.current) == null ? void 0 : _a.focus();
                },
                children: /* @__PURE__ */ jsxs48(Flex.Row, {
                  fullWidth: true,
                  sx: { height: "100%", cursor: `${searchable ? "text" : "pointer"} !important` },
                  children: [
                    /* @__PURE__ */ jsxs48(Flex.Column, {
                      justify: "flex-end",
                      sx: { flex: 1 },
                      children: [
                        /* @__PURE__ */ jsx84(Box6, {
                          ref: refs,
                          component: "input",
                          type: searchable ? "text" : "search",
                          className: classes.input,
                          sx: [
                            styles.input,
                            {
                              cursor: `${searchable ? "text" : "pointer"} !important`,
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis"
                            }
                          ],
                          placeholder: label || "placeholder",
                          disabled: !searchable,
                          value: searchValue,
                          ...inputProps,
                          onChange: searchable ? (e) => handleSetSearchValue(e.target.value) : void 0
                        }),
                        label && /* @__PURE__ */ jsx84(Box6, {
                          component: "label",
                          className: cx(classes.label, classNames == null ? void 0 : classNames.label),
                          sx: styles.label,
                          children: /* @__PURE__ */ jsx84(RpiDrawerLabel, {
                            label,
                            required: inputProps.required
                          })
                        })
                      ]
                    }),
                    /* @__PURE__ */ jsx84(Flex.Column, {
                      justify: "center",
                      sx: (theme2) => ({ color: theme2.colors.brand[5], padding: 8 }),
                      children: /* @__PURE__ */ jsx84(IconV2_exports.ArrowDown, {
                        color: "currentColor",
                        size: { width: 10 },
                        style: { transform: opened ? "rotate(180deg)" : "" }
                      })
                    })
                  ]
                })
              })
            }),
            /* @__PURE__ */ jsx84(Popover.Dropdown, {
              children: /* @__PURE__ */ jsxs48(Flex.Column, {
                sx: (theme2) => ({
                  width: "100%",
                  height: "100%",
                  maxHeight: 224,
                  minHeight: 32,
                  overflowX: "hidden",
                  overflowY: "auto",
                  color: theme2.colors.brand[5],
                  transition: "color 250ms",
                  "&:hover": {
                    color: theme2.colors.text[5]
                  }
                }),
                children: [
                  !isLoading && /* @__PURE__ */ jsxs48(Fragment2, {
                    children: [
                      data.map((element, i) => {
                        return /* @__PURE__ */ jsx84(Flex.Row, {
                          align: "center",
                          onClick: () => {
                            handleSetSelected(element);
                            setOpened(false);
                          },
                          sx: (theme2) => ({
                            borderRadius: 8,
                            padding: "8px 24px",
                            height: 32,
                            cursor: "pointer",
                            color: "inherit",
                            flexShrink: 0,
                            "&:hover": {
                              background: theme2.colors.calm[4]
                            }
                          }),
                          children: /* @__PURE__ */ jsx84(RpiText, {
                            type: "p3",
                            weight: "light",
                            ellipsis: true,
                            color: "inherit",
                            sx: { width: "100%" },
                            children: element.labelRender || element.label
                          })
                        }, `select-element-${i}-${element.value}`);
                      }),
                      data.length === 0 && /* @__PURE__ */ jsx84(Flex.Row, {
                        justify: "center",
                        align: "center",
                        sx: { flex: 1 },
                        children: /* @__PURE__ */ jsx84(RpiText, {
                          type: "p3",
                          weight: "light",
                          color: (theme2) => theme2.colors.brand[3],
                          children: "No data"
                        })
                      })
                    ]
                  }),
                  isLoading && /* @__PURE__ */ jsx84(Flex.Row, {
                    justify: "center",
                    align: "center",
                    sx: { height: 64 },
                    children: /* @__PURE__ */ jsx84(Loader2, {
                      size: "md"
                    })
                  })
                ]
              })
            })
          ]
        }),
        error && /* @__PURE__ */ jsx84(Box6, {
          className: cx(classes.error, classNames == null ? void 0 : classNames.error),
          sx: styles.error,
          children: error
        })
      ]
    });
  }
);

// src/components/inputs/RpiDrawerInput.tsx
import { Fragment as Fragment3, jsx as jsx85, jsxs as jsxs49 } from "react/jsx-runtime";
var useRpiDrawerInputStyles = createStyles11(
  (theme, { isError, isDisabled, isFocused, isEmpty }) => {
    return {
      root: {
        borderRadius: 6,
        background: theme.colors.sky[5],
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: isError ? theme.colors.spark[6] : isFocused ? theme.colors.brand[5] : theme.colors.calm[5],
        position: "relative",
        cursor: isDisabled ? "not-allowed !important" : "text",
        height: 64,
        ...isFocused === void 0 && {
          "&:focus-within": {
            borderColor: isError ? theme.colors.spark[6] : theme.colors.brand[5]
          }
        }
      },
      label: {
        ...theme.other.fontTypes.p3,
        fontWeight: theme.other.fontWeights.light,
        color: isDisabled ? theme.colors.brand[3] : theme.colors.brand[5],
        position: "absolute",
        pointerEvents: "none",
        left: 8,
        ...isEmpty === void 0 ? { top: 8, transform: "translateY(0)" } : {
          top: isEmpty && !isFocused ? "50%" : 8,
          transform: isEmpty && !isFocused ? "translateY(-50%)" : "translateY(0)"
        }
      },
      input: {
        ...theme.other.fontTypes.p2,
        fontWeight: theme.other.fontWeights.light,
        lineHeight: "16px",
        color: isDisabled ? theme.colors.text[3] : theme.colors.text[5],
        outline: "none",
        background: "transparent",
        border: "none",
        padding: 8,
        margin: 0,
        width: "100%",
        cursor: isDisabled ? "not-allowed !important" : void 0,
        ...isEmpty === void 0 && {
          "&:focus ~ label": {
            top: 8,
            transform: "translateY(0)"
          },
          "&:placeholder-shown ~ *": {
            top: "50%",
            transform: "translateY(-50%)"
          }
        },
        "&:-webkit-autofill, &:-webkit-autofill:focus": {
          borderRadius: 6
        },
        "&::placeholder": {
          color: "transparent",
          userSelect: "none"
        }
      },
      error: {
        ...theme.other.fontTypes.p3,
        fontWeight: theme.other.fontWeights.light,
        color: theme.colors.spark[6]
      }
    };
  }
);
var RpiDrawerLabel = ({ label, required }) => {
  return /* @__PURE__ */ jsxs49(Fragment3, {
    children: [
      label,
      required && /* @__PURE__ */ jsx85(Box7, {
        component: "sup",
        sx: (theme) => ({ color: theme.colors.spark[5] }),
        children: "*"
      })
    ]
  });
};
var RpiDrawerTextInput = React9.forwardRef(
  ({
    label,
    error,
    fullWidth,
    classNames,
    styles: initialStyles,
    ...inputProps
  }, ref) => {
    const theme = useMantineTheme5();
    const { classes, cx } = useRpiDrawerInputStyles({ isError: !!error, isDisabled: inputProps.disabled });
    const styles = React9.useMemo(() => {
      if (!initialStyles)
        return {};
      return typeof initialStyles === "function" ? initialStyles(theme) : initialStyles;
    }, [initialStyles]);
    const inputRef = React9.useRef();
    const refs = useMergedRef(inputRef, ref);
    return /* @__PURE__ */ jsxs49(Flex.Column, {
      gap: 8,
      fullWidth,
      children: [
        /* @__PURE__ */ jsx85(Box7, {
          className: cx(classes.root, classNames == null ? void 0 : classNames.root),
          sx: styles.root,
          onClick: () => {
            var _a;
            return (_a = inputRef.current) == null ? void 0 : _a.focus();
          },
          children: /* @__PURE__ */ jsxs49(Flex.Column, {
            justify: "flex-end",
            sx: { height: "100%" },
            children: [
              /* @__PURE__ */ jsx85(Box7, {
                placeholder: label || "placeholder",
                ...inputProps,
                component: "input",
                ref: refs,
                type: "text",
                className: cx(classes.input, classNames == null ? void 0 : classNames.input),
                sx: styles.input
              }),
              label && /* @__PURE__ */ jsx85(Box7, {
                component: "label",
                className: cx(classes.label, classNames == null ? void 0 : classNames.label),
                sx: styles.label,
                children: /* @__PURE__ */ jsx85(RpiDrawerLabel, {
                  label,
                  required: inputProps.required
                })
              })
            ]
          })
        }),
        error && /* @__PURE__ */ jsx85(Box7, {
          className: cx(classes.error, classNames == null ? void 0 : classNames.error),
          sx: styles.error,
          children: error
        })
      ]
    });
  }
);
var RpiDrawerNumberInput = React9.forwardRef(
  ({
    label,
    error,
    fullWidth,
    classNames,
    styles: initialStyles,
    onInput,
    ...inputProps
  }, ref) => {
    const theme = useMantineTheme5();
    const { classes, cx } = useRpiDrawerInputStyles({ isError: !!error, isDisabled: inputProps.disabled });
    const styles = React9.useMemo(() => {
      if (!initialStyles)
        return {};
      return typeof initialStyles === "function" ? initialStyles(theme) : initialStyles;
    }, [initialStyles]);
    const inputRef = React9.useRef();
    const refs = useMergedRef(inputRef, ref);
    return /* @__PURE__ */ jsxs49(Flex.Column, {
      gap: 8,
      fullWidth,
      children: [
        /* @__PURE__ */ jsx85(Box7, {
          className: cx(classes.root, classNames == null ? void 0 : classNames.root),
          sx: styles.root,
          onClick: () => {
            var _a;
            return (_a = inputRef.current) == null ? void 0 : _a.focus();
          },
          children: /* @__PURE__ */ jsxs49(Flex.Column, {
            justify: "flex-end",
            sx: { height: "100%" },
            children: [
              /* @__PURE__ */ jsx85(Box7, {
                placeholder: label || "placeholder",
                ...inputProps,
                component: "input",
                ref: refs,
                type: "number",
                className: cx(classes.input, classNames == null ? void 0 : classNames.input),
                sx: styles.input,
                onInput: (e) => {
                  if ("max" in inputProps && inputProps.max !== void 0) {
                    const max = typeof inputProps.max === "string" ? Number.parseFloat(inputProps.max) : inputProps.max;
                    if (Number.parseFloat(e.target.value) > max) {
                      e.target.value = max;
                    }
                  }
                  if ("min" in inputProps && inputProps.min !== void 0) {
                    const min = typeof inputProps.min === "string" ? Number.parseFloat(inputProps.min) : inputProps.min;
                    if (Number.parseFloat(e.target.value) < min) {
                      e.target.value = min;
                    }
                  }
                  onInput && onInput(e);
                }
              }),
              label && /* @__PURE__ */ jsx85(Box7, {
                component: "label",
                className: cx(classes.label, classNames == null ? void 0 : classNames.label),
                sx: styles.label,
                children: /* @__PURE__ */ jsx85(RpiDrawerLabel, {
                  label,
                  required: inputProps.required
                })
              })
            ]
          })
        }),
        error && /* @__PURE__ */ jsx85(Box7, {
          className: cx(classes.error, classNames == null ? void 0 : classNames.error),
          sx: styles.error,
          children: error
        })
      ]
    });
  }
);
var RpiDrawerPasswordInput = React9.forwardRef(
  ({
    label,
    error,
    fullWidth,
    classNames,
    styles: initialStyles,
    ...inputProps
  }, ref) => {
    const theme = useMantineTheme5();
    const { classes, cx } = useRpiDrawerInputStyles({ isError: !!error, isDisabled: inputProps.disabled });
    const [showPassword, setShowPassword] = React9.useState(false);
    const [warning, setWarning] = React9.useState();
    const styles = React9.useMemo(() => {
      if (!initialStyles)
        return {};
      return typeof initialStyles === "function" ? initialStyles(theme) : initialStyles;
    }, [initialStyles]);
    const inputRef = React9.useRef();
    const refs = useMergedRef(inputRef, ref);
    return /* @__PURE__ */ jsxs49(Flex.Column, {
      gap: 8,
      fullWidth,
      children: [
        /* @__PURE__ */ jsx85(Box7, {
          className: cx(classes.root, classNames == null ? void 0 : classNames.root),
          sx: styles.root,
          children: /* @__PURE__ */ jsxs49(Flex.Row, {
            fullWidth: true,
            sx: { height: "100%" },
            children: [
              /* @__PURE__ */ jsxs49(Flex.Column, {
                justify: "flex-end",
                sx: { flex: 1 },
                onClick: () => {
                  var _a;
                  return (_a = inputRef.current) == null ? void 0 : _a.focus();
                },
                onKeyDown: (e) => {
                  setWarning(e.getModifierState("CapsLock") ? "Caps Lock is on" : void 0);
                },
                children: [
                  /* @__PURE__ */ jsx85(Box7, {
                    placeholder: label || "placeholder",
                    ...inputProps,
                    component: "input",
                    ref: refs,
                    type: showPassword ? "text" : "password",
                    className: cx(classes.input, classNames == null ? void 0 : classNames.input),
                    sx: styles.input
                  }),
                  label && /* @__PURE__ */ jsx85(Box7, {
                    component: "label",
                    className: cx(classes.label, classNames == null ? void 0 : classNames.label),
                    sx: styles.label,
                    children: /* @__PURE__ */ jsx85(RpiDrawerLabel, {
                      label,
                      required: inputProps.required
                    })
                  })
                ]
              }),
              /* @__PURE__ */ jsx85(RpiIconButton, {
                icon: showPassword ? IconV2_exports.Eye : IconV2_exports.EyeOff,
                size: { width: 18 },
                color: "currentColor",
                sx: (theme2) => ({ color: theme2.colors.brand[5], padding: 8 }),
                onClick: () => setShowPassword((showPassword2) => !showPassword2)
              })
            ]
          })
        }),
        (error || warning) && /* @__PURE__ */ jsx85(Box7, {
          className: cx(classes.error, classNames == null ? void 0 : classNames.error),
          sx: styles.error,
          children: error ? error : /* @__PURE__ */ jsxs49(Flex.Row, {
            align: "center",
            gap: 4,
            children: [
              /* @__PURE__ */ jsx85(IconV2_exports.ErrorSolid, {
                size: 14,
                color: "currentColor"
              }),
              warning
            ]
          })
        })
      ]
    });
  }
);
var RpiDrawerBraintreeInput = React9.forwardRef(
  ({
    label,
    error,
    fullWidth,
    classNames,
    styles: initialStyles,
    onFocus,
    isFocused,
    isEmpty,
    ...inputProps
  }, ref) => {
    const theme = useMantineTheme5();
    const { classes, cx } = useRpiDrawerInputStyles({ isError: !!error, isFocused: !!isFocused, isEmpty: !!isEmpty });
    const styles = React9.useMemo(() => {
      if (!initialStyles)
        return {};
      return typeof initialStyles === "function" ? initialStyles(theme) : initialStyles;
    }, [initialStyles]);
    const inputRef = React9.useRef();
    const refs = useMergedRef(inputRef, ref);
    return /* @__PURE__ */ jsxs49(Flex.Column, {
      gap: 8,
      fullWidth,
      children: [
        /* @__PURE__ */ jsx85(Box7, {
          className: cx(classes.root, classNames == null ? void 0 : classNames.root),
          sx: styles.root,
          onClick: () => onFocus && onFocus(),
          children: /* @__PURE__ */ jsxs49(Flex.Column, {
            justify: "flex-end",
            sx: { height: "100%" },
            children: [
              /* @__PURE__ */ jsx85(Box7, {
                placeholder: label || "placeholder",
                ...inputProps,
                ref: refs,
                className: cx(classes.input, classNames == null ? void 0 : classNames.input),
                sx: [styles.input, { height: 34.39, padding: 0 }]
              }),
              label && /* @__PURE__ */ jsx85(Box7, {
                component: "label",
                className: cx(classes.label, classNames == null ? void 0 : classNames.label),
                sx: styles.label,
                children: /* @__PURE__ */ jsx85(RpiDrawerLabel, {
                  label,
                  required: inputProps.required
                })
              })
            ]
          })
        }),
        typeof error === "string" && /* @__PURE__ */ jsx85(Box7, {
          className: cx(classes.error, classNames == null ? void 0 : classNames.error),
          sx: styles.error,
          children: error
        })
      ]
    });
  }
);

// src/components/inputs/RpiSlider.tsx
init_esm_shims();
import { createStyles as createStyles12, Slider } from "@mantine/core";
import React10 from "react";
import { jsx as jsx86 } from "react/jsx-runtime";
var useRpiSliderStyles = createStyles12((theme) => {
  return {
    root: {},
    track: {
      ":before": {
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: theme.colors.text[5],
        background: theme.colors.sky[5]
      }
    },
    bar: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.colors.text[5],
      background: theme.colors.amethyst[5]
    },
    thumb: {
      width: 24,
      height: 24,
      background: theme.colors.brand[5],
      border: "none",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
    },
    dragging: {
      background: theme.colors.brand[7],
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.5)"
    },
    label: {
      background: theme.colors.calm[5],
      borderRadius: 8,
      padding: "2px 4px 2px 4px",
      ...theme.other.fontTypes.p1,
      fontWeight: theme.other.fontWeights.regular,
      color: theme.colors.brand[5],
      lineHeight: "20px",
      paddingBottom: 6
    },
    mark: {
      display: "none"
    },
    markLabel: {
      ...theme.other.fontTypes.p3,
      fontWeight: theme.other.fontWeights.light,
      color: theme.colors.brand[5],
      marginTop: 7
    }
  };
});
var RpiSlider = React10.forwardRef((props, ref) => {
  const { classes } = useRpiSliderStyles();
  return /* @__PURE__ */ jsx86(Slider, {
    ref,
    size: 8,
    labelAlwaysOn: true,
    classNames: classes,
    ...props
  });
});

// src/components/typography/RpiHeaders.tsx
init_esm_shims();
import { createStyles as createStyles13, Text } from "@mantine/core";
import { jsx as jsx87 } from "react/jsx-runtime";
var useHeaderStyles = createStyles13((theme) => ({
  title: {
    fontFamily: theme.headings.fontFamily,
    fontWeight: theme.other.fontWeights.semibold,
    fontSize: theme.fontSizes.xl,
    lineHeight: theme.headings.sizes.h3.lineHeight,
    fontFeatureSettings: '"liga" off, "clig" off',
    textAlign: "center"
  },
  subTitle: {
    fontWeight: theme.other.fontWeights.normal,
    fontSize: theme.fontSizes.lg
  }
}));
function RpiTitle({ children }) {
  const { classes } = useHeaderStyles();
  return /* @__PURE__ */ jsx87(Text, {
    className: classes.title,
    children
  });
}
function RpiSubTitle({ children }) {
  const { classes } = useHeaderStyles();
  return /* @__PURE__ */ jsx87(Text, {
    className: `${classes.title} ${classes.subTitle}`,
    children
  });
}

// src/components/typography/RpiBodyText.tsx
init_esm_shims();
import { createStyles as createStyles14, Text as Text2 } from "@mantine/core";
import { jsx as jsx88 } from "react/jsx-runtime";
var useLabelStyles = createStyles14((theme) => ({
  labelText: {
    fontFamily: theme.fontFamily,
    fontWeight: theme.other.fontWeights.semibold,
    fontSize: theme.fontSizes.md,
    lineHeight: theme.lineHeight
  },
  bodyText: {
    fontFamily: theme.fontFamily,
    fontWeight: theme.other.fontWeights.normal,
    fontSize: theme.fontSizes.md,
    lineHeight: theme.other.sizes["body-text-lineheight"],
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
}));
function RpiLabelText({ children }) {
  const { classes } = useLabelStyles();
  return /* @__PURE__ */ jsx88(Text2, {
    className: classes.labelText,
    children
  });
}
function RpiBodyText({ children }) {
  const { classes } = useLabelStyles();
  return /* @__PURE__ */ jsx88(Text2, {
    className: classes.bodyText,
    children
  });
}

// src/components/RpiToast.tsx
init_esm_shims();
import { Alert as Alert2, tokens } from "@blurb/codex-react";
import { Box as Box8, createStyles as createStyles15, Group } from "@mantine/core";

// ../../node_modules/@mantine/notifications/esm/index.js
init_esm_shims();

// ../../node_modules/@mantine/notifications/esm/events.js
init_esm_shims();

// ../../node_modules/@mantine/utils/esm/index.js
init_esm_shims();

// ../../node_modules/@mantine/utils/esm/create-use-external-events/create-use-external-events.js
init_esm_shims();
import { useLayoutEffect, useEffect } from "react";
function dispatchEvent(type, detail) {
  window.dispatchEvent(new CustomEvent(type, { detail }));
}
var useIsomorphicEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
function createUseExternalEvents(prefix) {
  function _useExternalEvents(events) {
    const handlers = Object.keys(events).reduce((acc, eventKey) => {
      acc[`${prefix}:${eventKey}`] = (event) => events[eventKey](event.detail);
      return acc;
    }, {});
    useIsomorphicEffect(() => {
      Object.keys(handlers).forEach((eventKey) => {
        window.removeEventListener(eventKey, handlers[eventKey]);
        window.addEventListener(eventKey, handlers[eventKey]);
      });
      return () => Object.keys(handlers).forEach((eventKey) => {
        window.removeEventListener(eventKey, handlers[eventKey]);
      });
    }, [handlers]);
  }
  function createEvent2(event) {
    return (...payload) => dispatchEvent(`${prefix}:${String(event)}`, payload[0]);
  }
  return [_useExternalEvents, createEvent2];
}

// ../../node_modules/@mantine/notifications/esm/events.js
var [useNotificationsEvents, createEvent] = createUseExternalEvents("mantine-notifications");
var showNotification = createEvent("show");
var hideNotification = createEvent("hide");
var cleanNotifications = createEvent("clean");
var cleanNotificationsQueue = createEvent("cleanQueue");
var updateNotification = createEvent("update");

// src/components/RpiToast.tsx
import { useCallback as useCallback2 } from "react";
import { jsx as jsx89, jsxs as jsxs50 } from "react/jsx-runtime";
var useSuccessStyles = createStyles15((theme) => ({
  root: {
    background: theme.other.semanticColors.successBackground,
    color: theme.other.semanticColors.textInverse,
    padding: `0px ${theme.spacing.sm}px`,
    border: "none",
    height: theme.other.sizes.md,
    justifySelf: "center",
    maxWidth: "fit-content",
    "&::before": {
      display: "none"
    }
  },
  icon: {
    display: "none"
  },
  body: {
    margin: 0,
    gap: theme.spacing.sm
  },
  description: {
    color: "inherit",
    gap: theme.spacing.sm
  }
}));
function useShowSuccessToast() {
  const { classes } = useSuccessStyles();
  const showSuccessToast = useCallback2(
    (message) => {
      showNotification({
        message: /* @__PURE__ */ jsxs50(Group, {
          sx: { gap: "inherit" },
          children: [
            /* @__PURE__ */ jsx89(IconV3, {
              icon: "check_circle",
              color: "inherit",
              size: 20
            }),
            /* @__PURE__ */ jsx89(RpiBodyText, {
              children: message
            })
          ]
        }),
        disallowClose: true,
        autoClose: 4e3,
        classNames: classes
      });
    },
    [classes]
  );
  return showSuccessToast;
}
var useInfoToastStyles = createStyles15(() => ({
  root: {
    background: "transparent",
    padding: 0,
    border: "none",
    boxShadow: "none",
    maxWidth: "fit-content",
    marginTop: 80,
    marginLeft: "auto",
    marginRight: "auto",
    "&::before": {
      display: "none"
    }
  },
  icon: {
    display: "none"
  },
  body: {
    margin: 0
  },
  description: {
    color: "inherit"
  }
}));
function useShowInfoToast() {
  const { classes } = useInfoToastStyles();
  const showInfoToast = useCallback2(
    (message) => {
      showNotification({
        message: /* @__PURE__ */ jsx89(Box8, {
          sx: { "& > div": { backgroundColor: tokens.color.semantic.bg.info, width: "fit-content" } },
          children: /* @__PURE__ */ jsx89(Alert2, {
            type: "info",
            size: "small",
            children: /* @__PURE__ */ jsxs50(Group, {
              sx: { gap: tokens.spacing[2], color: tokens.color.semantic.text.inverse },
              children: [
                /* @__PURE__ */ jsx89(IconV3, {
                  icon: "info",
                  color: "inherit",
                  size: 20
                }),
                /* @__PURE__ */ jsx89(RpiBodyText, {
                  children: message
                })
              ]
            })
          })
        }),
        disallowClose: true,
        autoClose: 4e3,
        classNames: classes
      });
    },
    [classes]
  );
  return showInfoToast;
}
var useErrorToastStyles = createStyles15((theme) => ({
  root: {
    background: tokens.color.semantic.bg.danger,
    color: tokens.color.semantic.text.inverse,
    padding: `0px ${theme.spacing.sm}px`,
    border: "none",
    height: theme.other.sizes.md,
    justifySelf: "center",
    maxWidth: "fit-content",
    "&::before": {
      display: "none"
    }
  },
  icon: {
    display: "none"
  },
  body: {
    margin: 0,
    gap: theme.spacing.sm
  },
  description: {
    color: "inherit",
    gap: theme.spacing.sm
  }
}));
function useShowErrorToast() {
  const { classes } = useErrorToastStyles();
  return useCallback2(
    (message) => {
      showNotification({
        message: /* @__PURE__ */ jsxs50(Group, {
          sx: { gap: "inherit" },
          children: [
            /* @__PURE__ */ jsx89(IconV3, {
              icon: "error",
              color: "inherit",
              size: 20
            }),
            /* @__PURE__ */ jsx89(RpiBodyText, {
              children: message
            })
          ]
        }),
        disallowClose: true,
        autoClose: 4e3,
        classNames: classes
      });
    },
    [classes]
  );
}
function useToasts() {
  return {
    showSuccessToast: useShowSuccessToast(),
    showInfoToast: useShowInfoToast(),
    showErrorToast: useShowErrorToast()
  };
}
function showOldNotification(props) {
  showNotification({ ...props, sx: { justifySelf: "center", width: 440 } });
}
export {
  Flex,
  Grid,
  Icon_exports as Icon,
  IconSvg,
  IconV2_exports as IconV2,
  IconV3,
  RpiAlert,
  RpiBodyText,
  RpiButton,
  RpiCheckbox,
  RpiCheckboxV2,
  RpiDivider,
  RpiDrawerBraintreeInput,
  RpiDrawerLabel,
  RpiDrawerNumberInput,
  RpiDrawerPasswordInput,
  RpiDrawerSelectInput,
  RpiDrawerTextInput,
  RpiDropdown,
  RpiIconButton,
  RpiLabelText,
  RpiLink,
  RpiMultilineInput,
  RpiPasswordInput,
  RpiSimpleDivider,
  RpiSlider,
  RpiSubTitle,
  RpiText,
  RpiTextInput,
  RpiTitle,
  rpiTheme,
  showOldNotification,
  themeOther,
  useFlexStyles,
  useGridStyles,
  useRpiDrawerInputStyles,
  useRpiSliderStyles,
  useShowErrorToast,
  useShowInfoToast,
  useShowSuccessToast,
  useToasts
};
